import {
  SET_SEARCH_PLACE_AUTOCOMPLETE_STATUS,
  SET_SEARCH_PLACE_TEXT_HELPER,
  FETCH_SEARCH_PLACE_API_ERROR,
  FETCH_SEARCH_PLACE_DATA,
  SET_SEARCH_PLACE_ERROR,
  SET_SEARCH_PLACE_SELECTED,
  SET_SEARCH_ADDRESS_AUTOCOMPLETE_STATUS,
  SET_SEARCH_ADDRESS_TEXT_HELPER,
  FETCH_SEARCH_ADDRESS_API_ERROR,
  FETCH_SEARCH_ADDRESS_DATA,
  SET_SEARCH_ADDRESS_ERROR,
  SET_SEARCH_ADDRESS_SELECTED,
  ADD_TRIP_DESTINATION_IN_TRIP_OPEN_STATUS,
  ALERT_BARS_HANDLE,
  CEHCK_EMAIL_EXIST_FAILURE,
  CEHCK_EMAIL_EXIST_FAILURE_COMPANION,
  CEHCK_EMAIL_EXIST_SUCCESS,
  CEHCK_EMAIL_EXIST_SUCCESS_COMPANION,
  CEHCK_HANDLE_EXIST_FAILURE,
  CEHCK_HANDLE_EXIST_SUCCESS,
  SET_USER_SIGNATURE,
  CLEAN_SELECTED_SUBTYPES_DESTINATION,
  DELETE_DESTINATION_VISITED,
  DELETE_TRIP_DESTINATION_IN_TRIP_OPEN_STATUS,
  DESTINATION_SWITCH_FEATURE_TYPE_CONTAINER,
  DRAG_DROP_TRIP_DESTINATION_IN_TRIP,
  FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
  SET_ADDED_ACTIVITY_IN_TRIP,
  FETCH_API_ERROR_DESTINATION,
  FETCH_BREADCRUMB_DESTINATION,
  FETCH_BUCKET_LIST_DESTINATION,
  FETCH_CULTURE_API_ERROR,
  FETCH_CULTURE_DATA,
  FETCH_DESTINATION_VISITED_SEARCH,
  FETCH_DESTINATION_VISITED_SEARCH_ERROR,
  FETCH_DESTINATION_VISITED_SEARCH_QUERY,
  FETCH_DESTINATION_VISITED_SEARCH_STATUS,
  FETCH_EDUCATION_API_ERROR,
  FETCH_EDUCATION_DATA,
  FETCH_ESTABLISMENT_SETS_DESTINATION,
  FETCH_FEATURES_DESTINATION,
  FETCH_FEATURE_SUBTYPES_DESTINATION,
  FETCH_FEATURE_TYPES_DESTINATION,
  FETCH_FLUENCY_API_ERROR,
  FETCH_FLUENCY_DATA,
  FETCH_GENDER_API_ERROR,
  FETCH_GENDER_DATA,
  FETCH_GENERAL_INFO_DESTINATION,
  FETCH_GENERAL_SEARCH,
  FETCH_GENERAL_SEARCH_ERROR,
  FETCH_GENERAL_SEARCH_QUERY,
  FETCH_GENERAL_SEARCH_STATUS,
  SET_GENERAL_SEARCH_SEARCHER_ID,
  FETCH_HOMETOWN_AIRPORT_API_ERROR,
  FETCH_HOMETOWN_AIRPORT_DATA,
  FETCH_HOMETOWN_API_ERROR,
  FETCH_INFLUENCERS_DESTINATION,
  FETCH_LANGUAGE_API_ERROR,
  FETCH_LANGUAGE_DATA,
  FETCH_LEAVING_FROM_AIRPORT_API_ERROR,
  FETCH_LEAVING_FROM_AIRPORT_DATA,
  FETCH_NESTED_IDS_DESTINATION,
  FETCH_ORIENTATION_API_ERROR,
  FETCH_ORIENTATION_DATA,
  FETCH_PERSONALIZATION,
  FETCH_PERSONALIZATION_SWITCH_CONTAINER,
  FETCH_PERSONALIZATION_TYPE_SETS,
  FETCH_PLACES_NEAR_BY_CENTER,
  FETCH_PROFESSION_API_ERROR,
  FETCH_PROFESSION_DATA,
  FETCH_RELIGION_API_ERROR,
  FETCH_TIME_TO_REACH_OPTIONS,
  FETCH_RELIGION_DATA,
  FETCH_RETURNING_TO_AIRPORT_API_ERROR,
  FETCH_RETURNING_TO_AIRPORT_DATA,
  FETCH_SEARCH_DESTINATION_API_ERROR,
  FETCH_SEARCH_DESTINATION_DATA,
  FETCH_SEARCH_ESTABLISHMENT_API_ERROR,
  FETCH_SEARCH_ESTABLISHMENT_DATA,
  FETCH_SLIDER_IMAGES_DESTINATION,
  FETCH_SLIDER_IMAGES_ESTABLISHMENT,
  FETCH_SORTING_OPTION_DESTINATION,
  FETCH_SUGGESTEDTRIPS_DESTINATION,
  FETCH_TIMELINE_MUV_HOTELS,
  FETCH_TRIP_SETS_DESTINATION,
  FETCH_TRIP_TYPES_SETS,
  FETCH_TRIP_COMPANION_SETS,
  GetAsyncHelper,
  PL_FETCH_CITIES_LIST_SUCCESS,
  PL_FETCH_CITIES_LIST_FAILURE,
  PL_FETCH_HOTELS_LIST_SUCCESS,
  PL_FETCH_HOTELS_LIST_FAILURE,
  CONVERT_HOTELS_TO_ESTABLISHMENTS,
  PostAsyncHelper,
  PostAsyncHelperImage,
  REMOVE_EXIST_LANGUAGE_FLUENCY_SELECTED,
  REMOVE_LANGUAGE_FLUENCY_SELECTED,
  SELECTED_DESTINATION_VISITED_MERGE,
  SET_ABOUT_ME,
  SET_ACTIVE_DAY_IN_TRIP,
  SET_ACTIVE_TRIP_DESTINATION,
  SET_AUTH_FIRST_NAME,
  SET_AUTH_LAST_NAME,
  SET_BIRTHDAY,
  SET_BIRTHDAY_ERROR,
  SET_BIRTHDAY_TEXT_HELPER,
  SET_CULTURE_LOAD_RESOURCE,
  SET_CULTURE_SELECTED,
  SET_DESTINATION_ID_DESTINATION,
  SET_DESTINATION_VISITED_LOAD_GOOGLE_URL,
  SET_EDUCATION_LOAD_RESOURCE,
  SET_EDUCATION_SELECTED,
  SET_EMAIL_ADDRESS,
  SET_EMAIL_ADDRESS_COMPANION,
  SET_EMAIL_ADDRESS_ERROR,
  SET_EMAIL_ADDRESS_ERROR_COMPANION,
  SET_EMAIL_ADDRESS_LOGIN,
  SET_EMAIL_ADDRESS_TEXT_HELPER,
  SET_EMAIL_ADDRESS_TEXT_HELPER_COMPANION,
  SET_FACEBOOK,
  SET_FEATURE_FORMAT,
  SET_FIRST_NAME,
  SET_FIRST_NAME_COMPANION,
  SET_FIRST_NAME_ERROR,
  SET_FIRST_NAME_ERROR_COMPANION,
  SET_FIRST_NAME_TEXT_HELPER,
  SET_FIRST_NAME_TEXT_HELPER_COMPANION,
  SET_FLUENCY_LOAD_RESOURCE,
  SET_FLUENCY_SELECTED,
  SET_GENDER_LOAD_RESOURCE,
  SET_GENDER_SELECTED,
  SET_HANDLE,
  SET_HANDLE_ERROR,
  SET_HANDLE_TEXT_HELPER,
  SET_HOMETOWN_AIRPORT_AUTOCOMPLETE_STATUS,
  SET_HOMETOWN_AIRPORT_ERROR,
  SET_HOMETOWN_AIRPORT_SELECTED,
  SET_HOMETOWN_AIRPORT_TEXT_HELPER,
  SET_HOMETOWN_AUTOCOMPLETE_STATUS,
  SET_HOMETOWN_ERROR,
  SET_HOMETOWN_LOAD_GOOGLE_URL,
  SET_HOMETOWN_OPTIONS,
  SET_HOMETOWN_SEARCH_QUERY,
  SET_HOMETOWN_SELECTED,
  SET_HOMETOWN_SELECTED_POST_REQUIRED,
  SET_HOMETOWN_SERVICE_ACTIVE,
  SET_HOMETOWN_TEXT_HELPER,
  SET_HOTEL_SEARCH_FORM,
  SET_INSTAGRAM,
  SET_LANGUAGE_FLUENCY,
  SET_LANGUAGE_FLUENCY_SELECTED,
  SET_LANGUAGE_LOAD_RESOURCE,
  SET_LANGUAGE_SELECTED,
  SET_LAST_NAME,
  SET_LAST_NAME_COMPANION,
  SET_LAST_NAME_ERROR,
  SET_LAST_NAME_ERROR_COMPANION,
  SET_LAST_NAME_TEXT_HELPER,
  SET_LAST_NAME_TEXT_HELPER_COMPANION,
  SET_LEAVING_FROM_AIRPORT_AUTOCOMPLETE_STATUS,
  SET_LEAVING_FROM_AIRPORT_ERROR,
  SET_LEAVING_FROM_AIRPORT_SELECTED,
  SET_LEAVING_FROM_AIRPORT_TEXT_HELPER,
  SET_LIST_DISPLAY_FORMAT_DESTINATION,
  SET_LOADER,
  SET_ORIENTATION_LOAD_RESOURCE,
  SET_ORIENTATION_SELECTED,
  SET_PASSWORD,
  SET_PASSWORD_CONFIRM,
  SET_PASSWORD_CONFIRM_ERROR,
  SET_PASSWORD_CONFIRM_TEXT_HELPER,
  SET_PASSWORD_ERROR,
  SET_PASSWORD_LOGIN,
  SET_PASSWORD_LOGIN_TEXT_FIELD_TYPE,
  SET_PASSWORD_TEXT_FIELD_TYPE,
  SET_PASSWORD_TEXT_HELPER,
  SET_PINTEREST,
  SET_PROFESSION_LOAD_RESOURCE,
  SET_PROFESSION_SELECTED,
  SET_RELIGION_LOAD_RESOURCE,
  SET_RELIGION_SELECTED,
  SET_RETURNING_TO_AIRPORT_AUTOCOMPLETE_STATUS,
  SET_RETURNING_TO_AIRPORT_ERROR,
  SET_RETURNING_TO_AIRPORT_SELECTED,
  SET_RETURNING_TO_AIRPORT_TEXT_HELPER,
  SET_SEARCH_DESTINATION_AUTOCOMPLETE_STATUS,
  SET_SEARCH_DESTINATION_ERROR,
  SET_SEARCH_DESTINATION_SELECTED,
  SET_SEARCH_DESTINATION_TEXT_HELPER,
  SET_SEARCH_ESTABLISHMENT_AUTOCOMPLETE_STATUS,
  SET_SEARCH_ESTABLISHMENT_ERROR,
  SET_SEARCH_ESTABLISHMENT_SELECTED,
  SET_SEARCH_ESTABLISHMENT_TEXT_HELPER,
  SET_SELECTED_DESTINATION_VISITED,
  SET_SELECTED_PROFILE_PHOTO_AVATAR,
  SET_SELECTED_PROFILE_PHOTO_AVATAR_PROGRESS,
  SET_SNAPCHAT,
  SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
  SET_TIMELINE_ACTIVE_TRIP_COST,
  SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
  SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
  SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
  SET_TIMELINE_ACTIVE_TRIP_DURATION,
  SET_TIMELINE_ACTIVE_TRIP_ID,
  SET_TIMELINE_ACTIVE_TRIP_IMAGE,
  SET_TIMELINE_ACTIVE_TRIP_NAME,
  SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
  SET_TIMELINE_ACTIVE_TRIP_START_DATE,
  SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS,
  SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_ALL,
  SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
  SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_OPEN_SELECTED,
  SET_TIMELINE_WIZARD_DELETE_ALART_STATUS,
  SET_TIMELINE_WIZARD_DRAGGING_ACTIVITY,
  SET_TIMELINE_WIZARD_DRAGGING_ESTABLISHMENT,
  SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
  SET_TIMELINE_WIZARD_STATUS,
  SET_TRIP_TYPE_SELECTED,
  SET_TWITTER,
  SWITCH_BOOKING_FORM_ACTIVE_TAB,
  SWITCH_BOOKING_FORM_STATUS,
  SWRAP_TRIP_DESTINATION_IN_TRIP,
  UPDATE_LAZYLOADING_IS_FATCH_ALL_DESTINATION,
  UPDATE_LAZYLOADING_URL_REQUESTS_DESTINATION,
  UPDATE_PERSONALIZATION_BARS_SCORE,
  UPDATE_PERSONALIZATION_SCORE,
  UPDATE_SEARCH_QUERY_DESTINATION,
  UPDATE_TRIP_DESTINATION_IN_TRIP,
  CLEAR_ALL_TIMELINE,
  UPDATE_LAZYLOADING_URL_REQUESTS_HOTELS_LIST,
  FETCH_API_ERROR_HOTELS_LIST,
  UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
  FETCH_SORTING_OPTION_HOTELS_LIST,
  UPDATE_LAZYLOADING_HOTELS_LIST,
  UPDATE_LAZYLOADING_OFFSET_HOTELS_LIST,
  UPDATE_LAZYLOADING_LIMIT_HOTELS_LIST,
  UPDATE_LAZYLOADING_NO_MORE_HOTELS,
  UPDATE_LAZYLOADING_TOTAL_HOTELS,
  FETCH_GENERAL_INFO_HOTEL_ESTABLISHMENT,
  FETCH_GENERAL_INFO_HOTEL_ESTABLISHMENT_FAILURE,
  SET_HOTEL_ESTABLISHMENT_ID_ESTABLISHMENT,
  FETCH_SLIDER_IMAGES_HOTEL_ESTABLISHMENT,
  FETCH_REVIEWS_HOTEL_ESTABLISHMENT,
  FETCH_GENERAL_INFO_ROOMS,
  FETCH_GENERAL_INFO_ROOMS_FAILURE,
  SET_HOTEL_FORM_STATE,
  SET_BOOKING_FORM_STATE,
  FETCH_CONTRACT_INFO_HOTEL_BOOKING,
  FETCH_CONTRACT_INFO_HOTEL_BOOKING_FAILURE,
  ADD_BUNDLE_TO_HOTEL_BOOKING,
  ADD_BUNDLE_TO_HOTEL_BOOKING_FAILURE,
  REMOVE_BUNDLE_TO_HOTEL_BOOKING,
  REMOVE_BUNDLE_TO_HOTEL_BOOKING_FAILURE,
  FETCH_SUBTYPES_HOTELS_LIST,
  UPDATE_SELECTED_SUBTYPES_HOTELS_LIST,
  CLEAN_SELECTED_SUBTYPES_HOTELS_LIST,
  SET_ESTABLISHMENTS_TO_FILTER,
  SET_FILTERED_ESTABLISHMENTS,
  SET_HOTEL_SEARCH_IS_NEW,
  UPDATE_LAZYLOADING_SORT_BY,
  ADD_ACTIVITY_IN_ACTIVE_TRIP,
  SET_HOTEL_SEARCH_IS_SEARCHING,
  SET_SLIDER_INDEX,
  FETCH_TRANSPORT_MODES,
  CLEAR_TIMELINE_TRIP,
  SET_HOTEL_ESTABLISHMENTS_COPY,
  SET_TIMELINE_TRIP_DESTINATIONS_STATUS,
} from "../interfaces/types";
import {
  GET_ESTABLISHMENTS_NEAR_BY_MAP_CENTER,
  GET_ESTABLISHMENTS_WITHIN,
  LAZYLOADING_ESTABLISHMENTS_LIMIT,
  features_router,
  GOOGLE_API_KEY,
  LAZYDISPLAY_INIT_LIMIT,
  LAZYDISPLAY_INCREMENT,
  LAZYDISPLAY_SHOW_ALL_AFTER,
  LAZYLOADING_HOTELS_INIT_LIMIT,
  LAZYLOADING_HOTELS_INCREMENT,
  LAZYLOADING_HOTELS_LIMIT,
  LAZYLOADING_HOTELS_MAX,
  calcDistance,
  URL_REPLACE,
} from "../../Components/WebContent/Common/RegExValidate";
import moment, { lang } from "moment";

import Axios from "axios";
import Cookies from "js-cookie";
import { list_container_mode } from "../../Components/WebContent/Common/RegExValidate";
import qs from "qs";
import {
  setTripStartingPoint,
  updateActiveTrip,
} from "../../Components/WebContent/Common/Trip/ActiveTrip.slice";
import { environment } from "../../Environments/environment";
import { setTripToTimeline } from "./MemberAction";
import { isAuthenticated } from "../../redux/actions";
import { getHotelRate, getRoomData, getSmopRate } from "../../utility/utility";
import { getUserIp } from "../../Components/WebContent/MuvHotelPage/hotelServices";

// import moment from 'moment'

/* check email already used */

export const checkEmailExsit = (email) => async (dispatch) => {
  try {
    const response = await Axios({
      method: "post",
      url: environment.apiUrl + "memberemailisavailable",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify({
        email: email,
      }),
    });
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: CEHCK_EMAIL_EXIST_SUCCESS,
      check_email_exsit: response.data.status,
      axios_error: "axios success",
    });
    if (response.data.status === "success") {
      dispatch({
        type: SET_EMAIL_ADDRESS,
        email_address: email,
      });
      dispatch({
        type: SET_EMAIL_ADDRESS_ERROR,
        error: false,
      });
      dispatch({
        type: SET_EMAIL_ADDRESS_TEXT_HELPER,
        text_helper: "",
      });
    } else if (response.data.status === "fail") {
      dispatch({
        type: SET_EMAIL_ADDRESS,
        email_address: "",
      });
      dispatch({
        type: SET_EMAIL_ADDRESS_ERROR,
        error: true,
      });
      dispatch({
        type: SET_EMAIL_ADDRESS_TEXT_HELPER,
        text_helper: "Email already used.",
      });
    }
  } catch (error) {
    dispatch({
      type: CEHCK_EMAIL_EXIST_FAILURE,
      check_email_exsit: "",
      axios_error: error.message,
    });
  }
};

export const setTimeLineStatus = (status) => (dispatch) => {
  dispatch({
    type: SET_TIMELINE_WIZARD_STATUS,
    status: status,
  });
};

export const invalidEmailAddress = () => (dispatch) => {
  dispatch({
    type: SET_EMAIL_ADDRESS,
    email_address: "",
  });
  dispatch({
    type: SET_EMAIL_ADDRESS_ERROR,
    error: true,
  });
  dispatch({
    type: SET_EMAIL_ADDRESS_TEXT_HELPER,
    text_helper: "Email is invalid.",
  });
};

export const setHandle = (handle) => async (dispatch) => {
  dispatch({
    type: SET_HANDLE,
    hanlde: handle,
  });
};

/* check handle already used */
export const checkHandle = (handle, uuid, verifyOnly) => async (dispatch) => {
  try {
    dispatch({
      type: SET_HANDLE_ERROR,
      error: false,
    });

    let apiURL = environment.apiUrl + "account/memberHandleIsAvailable";
    const postData = {
      user_handle: handle,
    };

    const response = await PostAsyncHelper(apiURL, postData);

    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: CEHCK_HANDLE_EXIST_SUCCESS,
      check_handle_exsit: response.data.status,
      axios_error: "axios success",
    });
    if (response.data.status === "success") {
      /* updating handler */

      let apiURL2 = environment.apiUrl + "account/updateMemberHandle/" + uuid;

      const response = await PostAsyncHelper(apiURL2, postData);
      if (response.data.status === "success") {
        dispatch({
          type: ALERT_BARS_HANDLE,
          message_type: "success",
          message: "Handle was updated!",
        });

        dispatch({
          type: SET_HANDLE,
          hanlde: handle,
        });
        dispatch({
          type: SET_HANDLE_ERROR,
          error: false,
        });
        dispatch({
          type: SET_HANDLE_TEXT_HELPER,
          text_helper: "",
        });
      }
    } else if (response.data.status === "fail") {
      if (!verifyOnly) {
        dispatch({
          type: ALERT_BARS_HANDLE,
          message_type: "error",
          message: "Handle not updated!",
        });
      }

      dispatch({
        type: SET_HANDLE,
        handle: "",
      });
      dispatch({
        type: SET_HANDLE_ERROR,
        error: true,
      });
      dispatch({
        type: SET_HANDLE_TEXT_HELPER,
        text_helper: "Handle already used.",
      });
    }
  } catch (error) {
    dispatch({
      type: CEHCK_HANDLE_EXIST_FAILURE,
      check_handle_exsit: "",
      axios_error: error.message,
    });
    if (!verifyOnly) {
      dispatch({
        type: ALERT_BARS_HANDLE,
        message_type: "error",
        message: "Handle not updated!",
      });
    }
  }
};

/* check handle already used */
export const checkHandleExsit = (handle, token) => async (dispatch) => {
  try {
    const response = await Axios({
      method: "post",
      url: environment.apiUrl + "memberusernameisavailable",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify({
        username: handle,
      }),
    });
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: CEHCK_HANDLE_EXIST_SUCCESS,
      check_handle_exsit: response.data.status,
      axios_error: "axios success",
    });
    if (response.data.status === "success") {
      dispatch({
        type: SET_HANDLE,
        hanlde: handle,
      });
      dispatch({
        type: SET_HANDLE_ERROR,
        error: false,
      });
      dispatch({
        type: SET_HANDLE_TEXT_HELPER,
        text_helper: "",
      });
      /* updating handler */
      if (token !== "") {
        let api_url =
          environment.apiUrl +
          "memberUpdate?user_handle=" +
          handle +
          "&token=" +
          token;
        PostAsyncHelper(api_url);
        dispatch({
          type: ALERT_BARS_HANDLE,
          message_type: "success",
          message: "Hanlder was updated!",
        });
      }
    } else if (response.data.status === "fail") {
      dispatch({
        type: SET_HANDLE,
        handle: "",
      });
      dispatch({
        type: SET_HANDLE_ERROR,
        error: true,
      });
      dispatch({
        type: SET_HANDLE_TEXT_HELPER,
        text_helper: "Handle already used.",
      });
    }
  } catch (error) {
    dispatch({
      type: CEHCK_HANDLE_EXIST_FAILURE,
      check_handle_exsit: "",
      axios_error: error.message,
    });
  }
};

/* post signature */
export const setUserSignature = (signature, uuid, lang) => async (dispatch) => {
  try {
    let url =
      environment.apiUrl +
      "account/updateMemberInfoFields/" +
      uuid +
      "/" +
      lang;
    const response = await Axios({
      method: "post",
      url: url,
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify({
        updateFieldName: "signature",
        updateFieldValue: signature,
      }),
    });
    //console.log("formBankAction setUserSignature response")
    //console.log(response)
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }

    if (response.data.status === "success") {
      dispatch({
        type: SET_USER_SIGNATURE,
        signature: signature,
      });
    } else if (response.data.status === "fail") {
      dispatch({
        type: SET_USER_SIGNATURE,
        signature: "",
      });
    }
  } catch (error) {
    dispatch({
      type: SET_USER_SIGNATURE,
      signature: "",
    });
  }
};

export const invalidHandle = () => (dispatch) => {
  dispatch({
    type: SET_HANDLE,
    handle: "",
  });
  dispatch({
    type: SET_HANDLE_ERROR,
    error: true,
  });
  dispatch({
    type: SET_HANDLE_TEXT_HELPER,
    text_helper: "Please use 5-20 letters & numbers",
    //Use 8 or more characters with a mix of letters, numbers & symbols
  });
};

/* first name */

export const setFirstName = (first_name, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_FIRST_NAME,
    first_name: first_name,
  });

  dispatch({
    type: SET_AUTH_FIRST_NAME,
    first_name: first_name,
  });
  dispatch({
    type: SET_FIRST_NAME_ERROR,
    error: false,
  });
  dispatch({
    type: SET_FIRST_NAME_TEXT_HELPER,
    text_helper: "",
  });
  if (uuid !== undefined && uuid !== "") {
    let api_url =
      environment.apiUrl +
      "account/updateMemberInfoFields/" +
      uuid +
      "/" +
      lang;
    const obj = {
      uuid: uuid,
      lang: lang,
      updateFieldName: "firstName",
      updateFieldValue: first_name,
    };
    PostAsyncHelper(api_url, obj);
  }
};

export const invalidFirstName = () => (dispatch) => {
  dispatch({
    type: SET_FIRST_NAME,
    first_name: "",
  });
  dispatch({
    type: SET_FIRST_NAME_ERROR,
    error: true,
  });
  dispatch({
    type: SET_FIRST_NAME_TEXT_HELPER,
    text_helper: "Use 1 or more letters",
  });
};

/* last name */

export const setLastName = (last_name, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_LAST_NAME,
    last_name: last_name,
  });
  dispatch({
    type: SET_AUTH_LAST_NAME,
    last_name: last_name,
  });
  dispatch({
    type: SET_LAST_NAME_ERROR,
    error: false,
  });
  dispatch({
    type: SET_LAST_NAME_TEXT_HELPER,
    text_helper: "",
  });
  if (uuid !== undefined && uuid !== "") {
    let api_url =
      environment.apiUrl +
      "account/updateMemberInfoFields/" +
      uuid +
      "/" +
      lang;
    const obj = {
      uuid: uuid,
      lang: lang,
      updateFieldName: "lastName",
      updateFieldValue: last_name,
    };
    PostAsyncHelper(api_url, obj);
  }
};

export const invalidLastName = () => (dispatch) => {
  dispatch({
    type: SET_LAST_NAME,
    last_name: "",
  });
  dispatch({
    type: SET_LAST_NAME_ERROR,
    error: true,
  });
  dispatch({
    type: SET_LAST_NAME_TEXT_HELPER,
    text_helper: "Use 1 or more letters",
  });
};

/* password */

export const setPassword = (password) => (dispatch) => {
  dispatch({
    type: SET_PASSWORD,
    password: password,
  });
  dispatch({
    type: SET_PASSWORD_ERROR,
    error: false,
  });
  dispatch({
    type: SET_PASSWORD_TEXT_HELPER,
    text_helper: "",
  });
};

export const invalidPassword = () => (dispatch) => {
  dispatch({
    type: SET_PASSWORD,
    password: "",
  });
  dispatch({
    type: SET_PASSWORD_ERROR,
    error: true,
  });
  dispatch({
    type: SET_PASSWORD_TEXT_HELPER,
    text_helper: "Use 8 or more characters with a mix of letters & numbers",
  });
};

/* password confirm */
export const invalidPasswordConfirm = (password_confirm) => (dispatch) => {
  dispatch({
    type: SET_PASSWORD_CONFIRM,
    password_confirm: password_confirm,
  });
  dispatch({
    type: SET_PASSWORD_CONFIRM_ERROR,
    error: true,
  });
  dispatch({
    type: SET_PASSWORD_CONFIRM_TEXT_HELPER,
    text_helper: "Use 8 or more characters with a mix of letters & numbers",
  });
};

export const unmatchPasswordConfirm = (password_confirm) => (dispatch) => {
  dispatch({
    type: SET_PASSWORD_CONFIRM,
    password_confirm: password_confirm,
  });
  dispatch({
    type: SET_PASSWORD_CONFIRM_ERROR,
    error: true,
  });
  dispatch({
    type: SET_PASSWORD_CONFIRM_TEXT_HELPER,
    text_helper: "Those passwords didn't match.",
  });
};

export const validPasswordConfirm = (password_confirm) => (dispatch) => {
  dispatch({
    type: SET_PASSWORD_CONFIRM,
    password_confirm: password_confirm,
  });
  dispatch({
    type: SET_PASSWORD_CONFIRM_ERROR,
    error: false,
  });
  dispatch({
    type: SET_PASSWORD_CONFIRM_TEXT_HELPER,
    text_helper: "",
  });
};

export const setPasswordTextFieldType = (field_type) => (dispatch) => {
  dispatch({
    type: SET_PASSWORD_TEXT_FIELD_TYPE,
    field_type: field_type,
  });
};
export const setProfilePhotoAvatar =
  (localImageUrl, isSelected, previousSelectedFilePath, imageFile, token) =>
    async (dispatch) => {
      dispatch({
        type: SET_SELECTED_PROFILE_PHOTO_AVATAR,
        selected_file_path: localImageUrl,
        is_selected: true,
      });
      isSelected && window.URL.revokeObjectURL(previousSelectedFilePath);
      /* updating, avatar */
      if (token !== undefined && token !== "") {
        let api_url = environment.apiUrl + "muverUpdateMemberAvatar";
        const formData = new FormData();
        formData.set("token", token);
        formData.append("avatar", imageFile);

        PostAsyncHelperImage(api_url, formData);
        dispatch({
          type: ALERT_BARS_HANDLE,
          message_type: "success",
          message: "Avatar was updated!",
        });
      }
    };
export const uploadProfilePhotoAvatar = (selected_file) => (dispatch) => {
  const fd = new FormData();
  fd.append(
    "image",
    selected_file.selectedFile,
    selected_file.selectedFile.name
  );
  Axios.post("", fd, {
    onUploadProgress: (progressEvent) => {
      // console.log("Upload Progress: " + Math.round((progressEvent.loaded / progressEvent.total) * 100) + "%")
      dispatch({
        type: SET_SELECTED_PROFILE_PHOTO_AVATAR_PROGRESS,
        progress:
          "Upload Progress: " +
          Math.round((progressEvent.loaded / progressEvent.total) * 100) +
          "%",
      });
    },
  }).then((res) => {
    console.log(res);
  });
};

/* get hometown information */

export const setHometownSearchQuery = (query) => (dispatch) => {
  dispatch({
    type: SET_HOMETOWN_SEARCH_QUERY,
    query: query,
  });
  dispatch({
    type: SET_HOMETOWN_SERVICE_ACTIVE,
    active: true,
  });
};
export const setHometownSelected = (hometown, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_HOMETOWN_SELECTED,
    hometown_selected: hometown,
  });

  dispatch({
    type: SET_HOMETOWN_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: SET_HOMETOWN_OPTIONS,
    options: [],
  });

  dispatch({
    type: SET_HOMETOWN_SEARCH_QUERY,
    query: "",
  });
  dispatch({
    type: SET_HOMETOWN_SERVICE_ACTIVE,
    active: false,
  });
  dispatch({
    type: SET_HOMETOWN_SELECTED_POST_REQUIRED,
    place_id: "",
    city: "",
    state: "",
    country: "",
    latitude: "",
    longitude: "",
  });
  let geocoder = new window.google.maps.Geocoder();
  if (hometown !== null && hometown.description !== undefined) {
    geocoder.geocode(
      {
        address: hometown.description,
      },
      function (results, status) {
        if (status === window.google.maps.GeocoderStatus.OK) {
          dispatch({
            type: SET_HOMETOWN_SELECTED_POST_REQUIRED,
            place_id: hometown.place_id,
            city: hometown.terms[0] !== undefined && hometown.terms[0].value,
            state:
              hometown.terms.length === 3 && hometown.terms[1] !== undefined
                ? hometown.terms[1].value
                : "",
            country:
              hometown.terms.length === 3 &&
                hometown.terms[1] !== undefined &&
                hometown.terms[2] !== undefined
                ? hometown.terms[2].value
                : hometown.terms[1].value,
            latitude:
              results[0] !== undefined && results[0].geometry.location.lat(),
            longitude:
              results[0] !== undefined && results[0].geometry.location.lng(),
          });
          /* post hometown updating */
          if (uuid !== "") {
            let obj = {
              place_id: hometown.place_id,
              city: hometown.terms[0] !== undefined && hometown.terms[0].value,
              state:
                hometown.terms.length === 3 && hometown.terms[1] !== undefined
                  ? hometown.terms[1].value
                  : "",
              country:
                hometown.terms.length === 3 &&
                  hometown.terms[1] !== undefined &&
                  hometown.terms[2] !== undefined
                  ? hometown.terms[2].value
                  : hometown.terms[1].value,
              latitude:
                results[0] !== undefined && results[0].geometry.location.lat(),
              longitude:
                results[0] !== undefined && results[0].geometry.location.lng(),
            };
            let api_url =
              environment.apiUrl + "account/addHometown/" + uuid + "/" + lang;
            PostAsyncHelper(api_url, obj);
          }
          /* get nearly airport  */
          results[0] !== undefined &&
            GetAsyncHelper(
              environment.apiUrl +
              'muvsearch/nearestairport?limit=1&latitude="' +
              results[0].geometry.location.lat() +
              '"&longitude="' +
              results[0].geometry.location.lng() +
              '"'
            ).then((airportResponse) => {
              if (
                airportResponse.data !== undefined &&
                airportResponse.data.length > 0 &&
                airportResponse.data[0] !== undefined
              ) {
                dispatch({
                  type: SET_HOMETOWN_AIRPORT_SELECTED,
                  airport_selected: airportResponse.data[0],
                });
                /* post closest airport updating */
                if (uuid !== "") {
                  let obj = {
                    airport: airportResponse.data[0],
                  };
                  let api_url =
                    environment.apiUrl +
                    "account/addHomeAirport/" +
                    uuid +
                    "/" +
                    lang;
                  PostAsyncHelper(api_url, obj);
                }
              } else {
                console.log("The near hometown's airport not found");
              }
            });
        } else {
          alert(
            "Geocode was not successful for the following reason: " + status
          );
        }
      }
    );
  } else {
    if (uuid !== "") {
      let obj = {
        removeOnly: 1,
      };
      let api_url =
        environment.apiUrl + "account/addHometown/" + uuid + "/" + lang;
      PostAsyncHelper(api_url, obj);
    }
  }
};

export const invalidHometownQuery = () => (dispatch) => {
  dispatch({
    type: SET_HOMETOWN_OPTIONS,
    options: [],
  });
  dispatch({
    type: FETCH_HOMETOWN_API_ERROR,
    error_api: false,
  });
  dispatch({
    type: SET_HOMETOWN_ERROR,
    error: false,
  });
  dispatch({
    type: SET_HOMETOWN_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: SET_HOMETOWN_TEXT_HELPER,
    text_helper: "",
  });
  dispatch({
    type: SET_HOMETOWN_SEARCH_QUERY,
    query: "",
  });
};

/* loading google api script once */
export const setHometownLoadGoogleUrl = (load_google_url) => (dispatch) => {
  dispatch({
    type: SET_HOMETOWN_LOAD_GOOGLE_URL,
    load_google_url: load_google_url,
  });
};

export const setHometownOptions = (options) => (dispatch) => {
  dispatch({
    type: SET_HOMETOWN_OPTIONS,
    options: options,
  });
  dispatch({
    type: SET_HOMETOWN_AUTOCOMPLETE_STATUS,
    open: true,
  });
};
export const resetHometownOptions = (options) => (dispatch) => {
  dispatch({
    type: SET_HOMETOWN_OPTIONS,
    options: options,
  });
  dispatch({
    type: SET_HOMETOWN_AUTOCOMPLETE_STATUS,
    open: false,
  });
};

/* get hometown airport information */
export const fetchHometownAirportTextField = (query) => async (dispatch) => {
  try {
    const response = await Axios.get(
      environment.apiUrl + "muvsearch/airportsearch/" + query + "?limit=7"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_HOMETOWN_AIRPORT_DATA,
      airport_resource: response.data,
    });

    dispatch({
      type: FETCH_HOMETOWN_AIRPORT_API_ERROR,
      error_api: false,
    });
    if (response.data !== undefined && response.data.length === 0) {
      dispatch({
        type: SET_HOMETOWN_AIRPORT_ERROR,
        error: false,
      });
      dispatch({
        type: SET_HOMETOWN_AIRPORT_TEXT_HELPER,
        text_helper: "",
      });
      dispatch({
        type: SET_HOMETOWN_AIRPORT_AUTOCOMPLETE_STATUS,
        open: false,
      });
    } else {
      dispatch({
        type: SET_HOMETOWN_AIRPORT_ERROR,
        error: false,
      });
      dispatch({
        type: SET_HOMETOWN_AIRPORT_TEXT_HELPER,
        text_helper: "",
      });
      dispatch({
        type: SET_HOMETOWN_AIRPORT_AUTOCOMPLETE_STATUS,
        open: true,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_HOMETOWN_AIRPORT_DATA,
      airport_resource: [],
    });
    dispatch({
      type: FETCH_HOMETOWN_AIRPORT_API_ERROR,
      error_api: true,
    });
    dispatch({
      type: SET_HOMETOWN_AIRPORT_ERROR,
      error: false,
    });
    dispatch({
      type: SET_HOMETOWN_AIRPORT_AUTOCOMPLETE_STATUS,
      open: false,
    });
    dispatch({
      type: SET_HOMETOWN_AIRPORT_TEXT_HELPER,
      text_helper: "",
    });
  }
};

export const setHometownAirportSelected =
  (airport, uuid = "", lang = "") =>
    (dispatch) => {
      dispatch({
        type: SET_HOMETOWN_AIRPORT_SELECTED,
        airport_selected: airport,
      });

      dispatch({
        type: SET_HOMETOWN_AIRPORT_AUTOCOMPLETE_STATUS,
        open: false,
      });
      dispatch({
        type: FETCH_HOMETOWN_AIRPORT_DATA,
        airport_resource: [],
      });
      /* post closest airport */
      if (uuid !== "") {
        // console.log(airport)
        if (airport !== null && airport !== undefined && airport !== "") {
          let obj = {
            airport: airport,
          };
          let api_url =
            environment.apiUrl + "account/addHomeAirport/" + uuid + "/" + lang;
          PostAsyncHelper(api_url, obj);
        } else {
          let obj = {
            removeOnly: 1,
          };
          let api_url =
            environment.apiUrl + "account/addHomeAirport/" + uuid + "/" + lang;
          PostAsyncHelper(api_url, obj);
        }
      }
    };

export const invalidHometownAirportQuery = () => (dispatch) => {
  dispatch({
    type: FETCH_HOMETOWN_AIRPORT_DATA,
    airport_resource: [],
  });
  dispatch({
    type: FETCH_HOMETOWN_AIRPORT_API_ERROR,
    error_api: false,
  });
  dispatch({
    type: SET_HOMETOWN_AIRPORT_ERROR,
    error: false,
  });
  dispatch({
    type: SET_HOMETOWN_AIRPORT_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: SET_HOMETOWN_AIRPORT_TEXT_HELPER,
    text_helper: "",
  });
};

/* get gender information */
export const fetchGenderTextField = () => async (dispatch) => {
  dispatch({
    type: SET_GENDER_LOAD_RESOURCE,
    is_load: true,
  });
  try {
    const response = await Axios.get(
      environment.apiUrl + "getmuvergendertodisplay"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_GENDER_DATA,
      gender_resource: response.data,
    });
    dispatch({
      type: FETCH_GENDER_API_ERROR,
      error_api: false,
    });
  } catch (error) {
    dispatch({
      type: FETCH_GENDER_DATA,
      gender_resource: [],
    });
    dispatch({
      type: FETCH_GENDER_API_ERROR,
      error_api: true,
    });
  }
};

export const setGenderSelected = (gender, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_GENDER_SELECTED,
    gender_selected: gender,
  });
  let post_data = [];
  gender !== null && post_data.push(gender);
  let obj = {
    gender: post_data,
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/gender";
  PostAsyncHelper(api_url, obj);
};

/* get orientation information */
export const fetchOrientationTextField = () => async (dispatch) => {
  dispatch({
    type: SET_ORIENTATION_LOAD_RESOURCE,
    is_load: true,
  });
  try {
    const response = await Axios.get(
      environment.apiUrl + "getmuverorientationtodisplay"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_ORIENTATION_DATA,
      orientation_resource: response.data,
    });
    dispatch({
      type: FETCH_ORIENTATION_API_ERROR,
      error_api: false,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ORIENTATION_DATA,
      orientation_resource: [],
    });
    dispatch({
      type: FETCH_ORIENTATION_API_ERROR,
      error_api: true,
    });
  }
};

export const setOrientationSelected =
  (orientation, uuid, lang) => (dispatch) => {
    dispatch({
      type: SET_ORIENTATION_SELECTED,
      orientation_selected: orientation,
    });
    let post_data = [];
    orientation !== null && post_data.push(orientation);
    let obj = {
      orientation: post_data,
    };
    let api_url =
      environment.apiUrl +
      "muver/savemuverprofileinfo/" +
      uuid +
      "/" +
      lang +
      "/orientation";
    PostAsyncHelper(api_url, obj);
  };

/* get religion information */
export const fetchReligionTextField = () => async (dispatch) => {
  dispatch({
    type: SET_RELIGION_LOAD_RESOURCE,
    is_load: true,
  });
  try {
    const response = await Axios.get(
      environment.apiUrl + "getmuverreligionstodisplay"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_RELIGION_DATA,
      religion_resource: response.data,
    });
    dispatch({
      type: FETCH_RELIGION_API_ERROR,
      error_api: false,
    });
  } catch (error) {
    dispatch({
      type: FETCH_RELIGION_DATA,
      religion_resource: [],
    });
    dispatch({
      type: FETCH_RELIGION_API_ERROR,
      error_api: true,
    });
  }
};

export const setReligionSelected = (religion, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_RELIGION_SELECTED,
    religion_selected: religion,
  });

  let post_data = [];
  religion !== null && post_data.push(religion);
  let obj = {
    religion: post_data,
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/religion";
  PostAsyncHelper(api_url, obj);
};

/* get profession information */
export const fetchProfessionTextField = () => async (dispatch) => {
  dispatch({
    type: SET_PROFESSION_LOAD_RESOURCE,
    is_load: true,
  });
  try {
    const response = await Axios.get(
      environment.apiUrl + "getmuverprofessionstodisplay"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_PROFESSION_DATA,
      profession_resource: response.data,
    });
    dispatch({
      type: FETCH_PROFESSION_API_ERROR,
      error_api: false,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PROFESSION_DATA,
      profession_resource: [],
    });
    dispatch({
      type: FETCH_PROFESSION_API_ERROR,
      error_api: true,
    });
  }
};

export const setProfessionSelected = (profession, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_PROFESSION_SELECTED,
    profession_selected: profession,
  });
  let obj = {
    profession: profession,
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/profession";
  PostAsyncHelper(api_url, obj);
};
/* get education information */
export const fetchEducationTextField = () => async (dispatch) => {
  dispatch({
    type: SET_EDUCATION_LOAD_RESOURCE,
    is_load: true,
  });
  try {
    const response = await Axios.get(
      environment.apiUrl + "getmuvereducationtodisplay"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_EDUCATION_DATA,
      education_resource: response.data,
    });
    dispatch({
      type: FETCH_EDUCATION_API_ERROR,
      error_api: false,
    });
  } catch (error) {
    dispatch({
      type: FETCH_EDUCATION_DATA,
      education_resource: [],
    });
    dispatch({
      type: FETCH_EDUCATION_API_ERROR,
      error_api: true,
    });
  }
};

export const setEducationSelected = (education, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_EDUCATION_SELECTED,
    education_selected: education,
  });
  let post_data = [];
  education !== null && post_data.push(education);
  let obj = {
    education: post_data,
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/education";
  PostAsyncHelper(api_url, obj);
};

/* get culture information */
export const fetchCultureTextField = () => async (dispatch) => {
  dispatch({
    type: SET_CULTURE_LOAD_RESOURCE,
    is_load: true,
  });
  try {
    const response = await Axios.get(
      environment.apiUrl + "getmuverculturetodisplay"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_CULTURE_DATA,
      culture_resource: response.data,
    });
    dispatch({
      type: FETCH_CULTURE_API_ERROR,
      error_api: false,
    });
  } catch (error) {
    dispatch({
      type: FETCH_CULTURE_DATA,
      culture_resource: [],
    });
    dispatch({
      type: FETCH_CULTURE_API_ERROR,
      error_api: true,
    });
  }
};

export const setCultureSelected = (culture, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_CULTURE_SELECTED,
    culture_selected: culture,
  });

  let obj = {
    culture: culture,
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/culture";
  PostAsyncHelper(api_url, obj);
};

/* birthday information */
export const setBirthday = (date) => (dispatch) => {
  dispatch({
    type: SET_BIRTHDAY,
    date: date,
  });
};
export const postBirthday = (date, uuid, lang) => (dispatch) => {
  let post_data = [];
  date !== null && post_data.push(date);
  let obj = {
    dob: post_data,
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/dob";
  PostAsyncHelper(api_url, obj);
};
export const setErrorBirthday = () => (dispatch) => {
  dispatch({
    type: SET_BIRTHDAY_ERROR,
    error: true,
  });
  dispatch({
    type: SET_BIRTHDAY_TEXT_HELPER,
    text_helper: "Please enter a valid date.",
  });
};
export const clearErrorBirthday = () => (dispatch) => {
  dispatch({
    type: SET_BIRTHDAY_ERROR,
    error: false,
  });
  dispatch({
    type: SET_BIRTHDAY_TEXT_HELPER,
    text_helper: "",
  });
};

/* get langague information */
export const fetchLanguageTextField = () => async (dispatch) => {
  dispatch({
    type: SET_LANGUAGE_LOAD_RESOURCE,
    is_load: true,
  });
  try {
    const response = await Axios.get(
      environment.apiUrl + "getmuverlanguagestodisplay"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_LANGUAGE_DATA,
      language_resource: response.data,
    });
    dispatch({
      type: FETCH_LANGUAGE_API_ERROR,
      error_api: false,
    });
  } catch (error) {
    dispatch({
      type: FETCH_LANGUAGE_DATA,
      language_resource: [],
    });
    dispatch({
      type: FETCH_LANGUAGE_API_ERROR,
      error_api: true,
    });
  }
};
export const setLanguageSelected = (language) => (dispatch) => {
  dispatch({
    type: SET_LANGUAGE_SELECTED,
    language_selected: language,
  });
  dispatch({
    type: SET_FLUENCY_SELECTED,
    fluency_selected: null,
  });
};

/* get fluency information */
export const fetchFluencyTextField = () => async (dispatch) => {
  dispatch({
    type: SET_FLUENCY_LOAD_RESOURCE,
    is_load: true,
  });

  try {
    const response = await Axios.get(
      environment.apiUrl + "getlanguagefluencytodisplay"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_FLUENCY_DATA,
      fluency_resource: response.data,
    });
    dispatch({
      type: FETCH_FLUENCY_API_ERROR,
      error_api: false,
    });
  } catch (error) {
    dispatch({
      type: FETCH_FLUENCY_DATA,
      fluency_resource: [],
    });
    dispatch({
      type: FETCH_FLUENCY_API_ERROR,
      error_api: true,
    });
  }
};

export const setFluencySelected =
  (fluency, language, uuid, lang) => (dispatch) => {
    dispatch({
      type: SET_FLUENCY_SELECTED,
      fluency_selected: fluency,
    });
    let lang_id = language !== undefined && language !== null && language.id;
    let fluency_code =
      fluency !== undefined && fluency !== null && "_" + fluency.code;
    let ids = lang_id + fluency_code;

    language !== null &&
      fluency !== null &&
      dispatch({
        type: REMOVE_EXIST_LANGUAGE_FLUENCY_SELECTED,
        language_id: lang_id,
      }) &&
      dispatch({
        type: SET_LANGUAGE_FLUENCY_SELECTED,
        language_fluency_selected: {
          ids: ids,
          language: language,
          fluency: fluency,
        },
      });

    let obj = {
      action: "insert",
      languages: {
        ids,
        language,
        fluency,
      },
    };
    let api_url =
      environment.apiUrl +
      "muver/savemuverprofileinfo/" +
      uuid +
      "/" +
      lang +
      "/languages";
    language !== null && fluency !== null && PostAsyncHelper(api_url, obj);
  };

export const removeLanguageFluency =
  (ids, language, fluency, uuid, lang) => (dispatch) => {
    dispatch({
      type: REMOVE_LANGUAGE_FLUENCY_SELECTED,
      ids: ids,
    });
    let obj = {
      action: "delete",
      languages: {
        ids,
        language,
        fluency,
      },
    };
    let api_url =
      environment.apiUrl +
      "muver/savemuverprofileinfo/" +
      uuid +
      "/" +
      lang +
      "/languages";
    language !== null && PostAsyncHelper(api_url, obj);
  };

/*  set about me */

export const setAboutMe = (about_me, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_ABOUT_ME,
    about_me: about_me,
  });
  let post_about_me = [];
  post_about_me.push(about_me);
  let obj = {
    bio: [
      {
        id: about_me,
      },
    ],
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/bio";
  PostAsyncHelper(api_url, obj);
};

export const fetchAboutMe = (uuid, lang) => (dispatch) => {
  GetAsyncHelper(
    environment.apiUrl + "muver/getMuverBio/" + uuid + "/" + lang
  ).then((responseAboutMeValue) => {
    if (
      responseAboutMeValue !== undefined &&
      responseAboutMeValue.statusText === "OK"
    ) {
      dispatch({
        type: SET_ABOUT_ME,
        about_me:
          responseAboutMeValue.data.result !== undefined &&
            responseAboutMeValue.data.result !== null
            ? responseAboutMeValue.data.result.muverBio
            : "",
      });
    }
  });
};

/*  set facebook */

export const setFacebook = (facebook, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_FACEBOOK,
    facebook: facebook,
  });
  let obj = {
    facebook: [
      {
        id: facebook,
      },
    ],
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/facebook";
  PostAsyncHelper(api_url, obj);
};

/*  set instagram */

export const setInstagram = (instagram, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_INSTAGRAM,
    instagram: instagram,
  });
  let obj = {
    instagram: [
      {
        id: instagram,
      },
    ],
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/instagram";
  PostAsyncHelper(api_url, obj);
};

/*  set twitter */

export const setTwitter = (twitter, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_TWITTER,
    twitter: twitter,
  });
  let obj = {
    twitter: [
      {
        id: twitter,
      },
    ],
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/twitter";
  PostAsyncHelper(api_url, obj);
};

/*  set pinterest */

export const setPinterest = (pinterest, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_PINTEREST,
    pinterest: pinterest,
  });
  let obj = {
    pinterest: [
      {
        id: pinterest,
      },
    ],
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/pinterest";
  PostAsyncHelper(api_url, obj);
};
/*  set snapchat */

export const setSnapchat = (snapchat, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_SNAPCHAT,
    snapchat: snapchat,
  });
  let obj = {
    snapchat: [
      {
        id: snapchat,
      },
    ],
  };
  let api_url =
    environment.apiUrl +
    "muver/savemuverprofileinfo/" +
    uuid +
    "/" +
    lang +
    "/snapchat";
  PostAsyncHelper(api_url, obj);
};

export const setEmailAddressLogin = (email) => (dispatch) => {
  dispatch({
    type: SET_EMAIL_ADDRESS_LOGIN,
    email_address_or_username: email,
  });
};

export const setPasswordLogin = (password) => (dispatch) => {
  dispatch({
    type: SET_PASSWORD_LOGIN,
    password: password,
  });
};

export const setPasswordLoginTextFieldType = (field_type) => (dispatch) => {
  dispatch({
    type: SET_PASSWORD_LOGIN_TEXT_FIELD_TYPE,
    field_type: field_type,
  });
};

/* get topbar search information */
export const fetchGeneralSearch = (query) => async (dispatch) => {
  dispatch({
    type: FETCH_GENERAL_SEARCH_QUERY,
    query: query,
  });
  try {
    const response = await Axios.get(
      environment.apiUrl + "muvsearch/topsearch/" + query + "/en"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_GENERAL_SEARCH,
      establishments: response.data.establishments,
      destinations: response.data.destinations,
    });

    dispatch({
      type: FETCH_GENERAL_SEARCH_ERROR,
      api_error: false,
    });
    if (
      response.data !== undefined &&
      response.data.establishments !== undefined &&
      response.data.destinations !== undefined &&
      response.data.establishments.length === 0 &&
      response.data.destinations.length === 0
    ) {
      dispatch({
        type: FETCH_GENERAL_SEARCH_STATUS,
        open: false,
      });
      dispatch({
        type: FETCH_GENERAL_SEARCH,
        establishments: [],
        destinations: [],
      });
    } else {
      dispatch({
        type: FETCH_GENERAL_SEARCH_STATUS,
        open: true,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_GENERAL_SEARCH_ERROR,
      api_error: true,
    });
    dispatch({
      type: FETCH_GENERAL_SEARCH_STATUS,
      open: false,
    });
    dispatch({
      type: FETCH_GENERAL_SEARCH,
      establishments: [],
      destinations: [],
    });
  }
};

export const clearGeneralSearch = () => (dispatch) => {
  dispatch({
    type: FETCH_GENERAL_SEARCH_STATUS,
    open: false,
  });
  dispatch({
    type: FETCH_GENERAL_SEARCH,
    establishments: [],
    destinations: [],
  });
};

//SET_GENERAL_SEARCH_SEARCHER_ID
export const setGeneralSearchSearcherId = (id) => (dispatch) => {
  dispatch({
    type: SET_GENERAL_SEARCH_SEARCHER_ID,
    searcherId: id,
  });
};

/* get landing visited destination search information */
export const fetchDestinationVisitedSearch = (query) => async (dispatch) => {
  dispatch({
    type: FETCH_DESTINATION_VISITED_SEARCH_QUERY,
    query: query,
  });
  try {
    const response = await Axios.get(
      environment.apiUrl + "muvsearch/topsearch/" + query + "/en"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_DESTINATION_VISITED_SEARCH,
      destinations: response.data.destinations,
    });

    dispatch({
      type: FETCH_DESTINATION_VISITED_SEARCH_ERROR,
      api_error: false,
    });
    if (
      response.data !== undefined &&
      response.data.destinations !== undefined &&
      response.data.destinations.length === 0
    ) {
      dispatch({
        type: FETCH_DESTINATION_VISITED_SEARCH_STATUS,
        open: false,
      });
      dispatch({
        type: FETCH_DESTINATION_VISITED_SEARCH,
        destinations: [],
      });
    } else {
      dispatch({
        type: FETCH_DESTINATION_VISITED_SEARCH_STATUS,
        open: true,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_DESTINATION_VISITED_SEARCH_ERROR,
      api_error: true,
    });
    dispatch({
      type: FETCH_DESTINATION_VISITED_SEARCH_STATUS,
      open: false,
    });
    dispatch({
      type: FETCH_DESTINATION_VISITED_SEARCH,
      destinations: [],
    });
  }
};

/* get landing visited destination selected sets*/
export const fetchDestinationVisitedSelectedSets =
  (uuid, lang) => async (dispatch) => {
    GetAsyncHelper(
      environment.apiUrl +
      "muver/getMuverVisitedDestinations/" +
      uuid +
      "/" +
      lang
    ).then((response) => {
      if (response !== undefined && response.statusText === "OK") {
        dispatch({
          type: SET_SELECTED_DESTINATION_VISITED,
          selected_destination_sets: response.data.result,
        });
        dispatch({
          type: FETCH_DESTINATION_VISITED_SEARCH_ERROR,
          error: false,
        });
      } else {
        dispatch({
          type: FETCH_DESTINATION_VISITED_SEARCH_ERROR,
          error: true,
        });
      }
    });
  };

export const clearDestinationVisitedSearch = () => (dispatch) => {
  dispatch({
    type: FETCH_DESTINATION_VISITED_SEARCH_STATUS,
    open: false,
  });
  dispatch({
    type: FETCH_DESTINATION_VISITED_SEARCH,
    destinations: [],
  });
  dispatch({
    type: FETCH_DESTINATION_VISITED_SEARCH_QUERY,
    query: "",
  });
};

export const selectedDestinationVisitedMerge =
  (destination, selectedDestinationSets, uuid, lang) => (dispatch) => {
    if (
      selectedDestinationSets !== undefined &&
      selectedDestinationSets.length > 0 &&
      selectedDestinationSets.find(
        (element) => element.destinationId === destination.destinationId
      ) === undefined
    ) {
      dispatch({
        type: SELECTED_DESTINATION_VISITED_MERGE,
        destination: destination,
      });
      let array = Array.from(
        new Set(selectedDestinationSets.map((a) => a.destinationId))
      );
      array.push(destination.destinationId);
      if (uuid !== "") {
        let obj = {
          destination_ids: array,
        };
        let api_url =
          environment.apiUrl +
          "muver/saveMuverVisitedDestinations/" +
          uuid +
          "/" +
          lang;
        PostAsyncHelper(api_url, obj);
      }
    }
    if (selectedDestinationSets.length === 0) {
      dispatch({
        type: SELECTED_DESTINATION_VISITED_MERGE,
        destination: destination,
      });
      let array = [];
      array.push(destination.destinationId);
      if (uuid !== "") {
        let obj = {
          destination_ids: array,
        };
        let api_url =
          environment.apiUrl +
          "muver/saveMuverVisitedDestinations/" +
          uuid +
          "/" +
          lang;
        PostAsyncHelper(api_url, obj);
      }
    }
  };

export const deleteDestinationVisited =
  (destination, selectedDestinationSets, uuid, lang) => (dispatch) => {
    if (
      selectedDestinationSets !== undefined &&
      selectedDestinationSets.length > 0
    ) {
      dispatch({
        type: DELETE_DESTINATION_VISITED,
        destination_id: destination.destinationId,
      });
      let array = Array.from(
        new Set(selectedDestinationSets.map((a) => a.destinationId))
      );
      let intersection = array.filter(
        (val) => val !== destination.destinationId
      );
      if (uuid !== "") {
        let obj = {
          destination_ids: intersection,
        };
        let api_url =
          environment.apiUrl +
          "muver/saveMuverVisitedDestinations/" +
          uuid +
          "/" +
          lang;
        PostAsyncHelper(api_url, obj);
      }
    }
  };
export const setDestinationVisitedLoadGoogleUrl =
  (load_google_url) => (dispatch) => {
    dispatch({
      type: SET_DESTINATION_VISITED_LOAD_GOOGLE_URL,
      load_google_url: load_google_url,
    });
  };

/* get personalization */
export const fetchPersonalization = (uuid, lang) => async (dispatch) => {
  GetAsyncHelper(
    environment.apiUrl + "featurelist/getfeaturetypes/" + lang
  ).then((typeResponse) => {
    if (typeResponse.statusText === "OK") {
      dispatch({
        type: FETCH_PERSONALIZATION_TYPE_SETS,
        types: typeResponse.data.types,
      });
      typeResponse.data.types !== undefined &&
        typeResponse.data.types.length > 0 &&
        GetAsyncHelper(
          environment.apiUrl +
          "getMuverPersCategoriesScores/" +
          uuid +
          "/" +
          lang +
          "?typeID=" +
          typeResponse.data.types[0].typeID
        ).then((personalizationResponse) => {
          if (personalizationResponse.statusText === "OK") {
            dispatch({
              type: FETCH_PERSONALIZATION,
              bars: personalizationResponse.data.bars,
              check_boxes: personalizationResponse.data.check_boxes,
            });
            dispatch({
              type: FETCH_PERSONALIZATION_SWITCH_CONTAINER,
              switch_container: typeResponse.data.types[0].typeID,
            });
          } else {
            dispatch({
              type: FETCH_PERSONALIZATION,
              bars: [],
              check_boxes: [],
            });
          }
        });
    } else {
      dispatch({
        type: FETCH_PERSONALIZATION_TYPE_SETS,
        types: [],
      });
    }
  });
};

export const setSwitchPersTypeContainer =
  (uuid, lang, type_id) => (dispatch) => {
    GetAsyncHelper(
      environment.apiUrl +
      "getMuverPersCategoriesScores/" +
      uuid +
      "/" +
      lang +
      "?typeID=" +
      type_id
    ).then((personalizationResponse) => {
      if (personalizationResponse.statusText === "OK") {
        dispatch({
          type: FETCH_PERSONALIZATION,
          bars: personalizationResponse.data.bars,
          check_boxes: personalizationResponse.data.check_boxes,
        });
        dispatch({
          type: FETCH_PERSONALIZATION_SWITCH_CONTAINER,
          switch_container: type_id,
        });
      } else {
        dispatch({
          type: FETCH_PERSONALIZATION,
          bars: [],
          check_boxes: [],
        });
      }
    });
  };

export const setMuverPersCategoriesScores =
  (uuid, id, score, lang, from = "", bars_id = "", avg = "0") =>
    async (dispatch) => {
      from === "check_box" &&
        dispatch({
          type: UPDATE_PERSONALIZATION_SCORE,
          id: id,
          score: score,
        });
      from === "bar" &&
        dispatch({
          type: UPDATE_PERSONALIZATION_BARS_SCORE,
          bars_id: bars_id,
          id: id,
          avg: avg,
          score: score,
        });
      if (uuid !== undefined && uuid !== "") {
        let api_url =
          environment.apiUrl +
          "setMuverPersCategoriesScores/" +
          uuid +
          "/" +
          lang;
        let obj = {
          pstID: id,
          score: score,
        };

        PostAsyncHelper(api_url, obj);
      }
    };

export const setBookingFormActiveTab = (param) => (dispatch) => {
  param !== "" &&
    dispatch({
      type: SWITCH_BOOKING_FORM_ACTIVE_TAB,
      active_tab: param,
    });
};

export const setBookingFormStatus = (status) => (dispatch) => {
  dispatch({
    type: SWITCH_BOOKING_FORM_STATUS,
    status: status,
  });
};

export const setHotelSearchForm = (hotelSearchForm) => (dispatch) => {
  dispatch({
    type: SET_HOTEL_SEARCH_FORM,
    hotelSearchForm: hotelSearchForm,
  });
};

export const setHotelSearchIsNew = (isNew) => (dispatch) => {
  dispatch({
    type: SET_HOTEL_SEARCH_IS_NEW,
    isNew: isNew,
  });
};

export const addQuerySubtype =
  (query, selectedSubtypes) => async (dispatch) => {
    console.log("addQuerySubtype", query, selectedSubtypes);

    //remove other queries
    let selectedSubtypesNew = selectedSubtypes.filter(
      (val) => val.type !== "query"
    );

    const subtype = {
      title: query,
      id: "q-" + query,
      type: "query",
    };

    let subtypes =
      selectedSubtypes !== undefined
        ? selectedSubtypes.slice().filter((val) => val.type !== "query")
        : [];
    subtypes.push(subtype);

    dispatch({
      type: UPDATE_SELECTED_SUBTYPES_HOTELS_LIST,
      selectedSubtypes: subtypes,
    });
  };

export const setFoundHotels =
  (query, establishments, selectedSubtypes) => async (dispatch) => {
    console.log("setFoundHotels", query, establishments, selectedSubtypes);

    const subtype = {
      title: query,
      id: "q-" + query,
      type: "query",
    };

    let subtypes =
      selectedSubtypes !== undefined
        ? selectedSubtypes.slice().filter((val) => val.type !== "query")
        : [];
    subtypes.push(subtype);

    dispatch({
      type: UPDATE_SELECTED_SUBTYPES_HOTELS_LIST,
      selectedSubtypes: subtypes,
    });

    let found = [];
    establishments.forEach((establishment) => {
      console.log(query, establishment.establishmentName);
      if (
        establishment.establishmentName
          .toLowerCase()
          .indexOf(query.toLowerCase()) > -1
      ) {
        found.push(establishment);
        console.log("found", establishment.establishmentName);
      }
    });
    console.log(found);

    dispatch({
      type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
      establishments: found.slice(0, LAZYLOADING_HOTELS_INIT_LIMIT), // just use 4 first
    });

    dispatch({
      type: SET_FILTERED_ESTABLISHMENTS,
      filteredEstablishments: found,
    });
  };

function getMapHotels(establishments, hotel_form_state) {
  let mapHotels = [];
  Object.values(establishments).forEach((establishment, index) => {
    //console.log(establishment, index);
    const distance = calcDistance(
      hotel_form_state.city_latitude,
      hotel_form_state.city_latitude,
      establishment.latitude,
      establishment.longitude,
      "K"
    );

    const uri =
      "/hotel-" + establishment.establishmentName !== undefined
        ? establishment.establishmentName.replace(URL_REPLACE, "_")
        : "" +
        establishment.establishmentCity.replace(URL_REPLACE, "_") +
        " " +
        establishment.establishmentState.replace(URL_REPLACE, "_") +
        " " +
        establishment.establishmentCountry.replace(URL_REPLACE, "_") +
        "-" +
        establishment.establishmentPricelineID +
        "?city_id=" +
        hotel_form_state.city_id +
        "&check_in=" +
        hotel_form_state.check_in +
        "&check_out=" +
        hotel_form_state.check_out +
        "&rooms=" +
        (hotel_form_state.rooms ? hotel_form_state.rooms : 1) +
        "&guests=" +
        (hotel_form_state.adults ? hotel_form_state.adults : 2) +
        "&city_lat=" +
        hotel_form_state.city_latitude +
        "&city_lng=" +
        hotel_form_state.city_longitude +
        "&ppn_bundle=" +
        establishment.ppn_bundle +
        "&where=" +
        hotel_form_state.where.replace(URL_REPLACE, "_");

    mapHotels[index] = {
      establishmentPricelineID: establishment.establishmentPricelineID,
      //"neighborhood": establishment.hotel_zone,
      neighborhood: establishment.neighborhood,
      establishmentName: establishment.establishmentName,
      establishmentDescription: establishment.establishmentDescription,
      establishmentNeighborhood: establishment.establishmentNeighborhood,
      five_star_rating: establishment.establishmentStarRating,
      //  "uri": "27657-The_Metropolitan_Museum_of_Art-New_York-USA",
      uri: uri,
      latitude: establishment.latitude,
      longitude: establishment.longitude,
      distance: distance, // calculated distance from hotel_form_state.city_latitude +
      city_id: hotel_form_state.city_id,
      cityName: establishment.establishmentCity,
      stateName: establishment.establishmentState,
      stateCode: establishment.establishmentStateCode,
      countryName: establishment.establishmentCountry,
      countryCode: establishment.establishmentCountryCode,
      address: establishment.address_line_one,
      image: {
        //    "bucketName": "muvimages",
        //    "folderName": "establishments",
        imageName: establishment.estabPicture.imageName,
        description: establishment.estabPicture.description,
      },
    };
  });

  return mapHotels;
}

export const removeDuplicateObjectFromArray = (array, key) => {
  var check = new Set();
  return array.filter((obj) => !check.has(obj[key]) && check.add(obj[key]));
};

export const getPropertyType = (id) => {
  const types = [
    {
      property_type_id: "2",
      property_type_name: "Apartments",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "3",
      property_type_name: "Guest Accommodations",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "13",
      property_type_name: "Hostels",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "14",
      property_type_name: "Hotels",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "19",
      property_type_name: "Motels",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "21",
      property_type_name: "Resorts",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "23",
      property_type_name: "Residences",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "24",
      property_type_name: "Bed and Breakfasts",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "25",
      property_type_name: "Ryokans",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "210",
      property_type_name: "Farm Stays",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "212",
      property_type_name: "Holiday Parks",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "213",
      property_type_name: "Villas",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "214",
      property_type_name: "Campsites",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "215",
      property_type_name: "Boats",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "216",
      property_type_name: "Guest Houses",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "217",
      property_type_name: "Uncertain",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "218",
      property_type_name: "Inns",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "219",
      property_type_name: "Aparthotels",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "220",
      property_type_name: "Holiday Homes",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "221",
      property_type_name: "Lodges",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "222",
      property_type_name: "Homestays",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "223",
      property_type_name: "Country Houses",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "224",
      property_type_name: "Luxury Tents",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "225",
      property_type_name: "Capsule Hotels",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "226",
      property_type_name: "Love Hotels",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "227",
      property_type_name: "Riads",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "228",
      property_type_name: "Chalets",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "229",
      property_type_name: "Condos",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "230",
      property_type_name: "Cottages",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "231",
      property_type_name: "Economy Hotels",
      creation_date_time: "2021-06-04 12:34:43",
    },
    {
      property_type_id: "232",
      property_type_name: "Gites",
      creation_date_time: "2021-06-04 12:34:43",
    },
  ];

  const foundItem = types?.find((item) => item?.property_type_id == id);
  return foundItem;
};

export const getMuvHotels =
  (hotel_form_state, currency, limit = 15, offset = 0, isLazyLoad = false) =>
    async (dispatch) => {
      //console.log("getPriceLineHotels", hotel_form_state, lazyLoading);


      try {
        const loggedIn = await isAuthenticated();
        const ipAddress = await getUserIp();

        // Only clear state on initial load, not on lazy load
        if (!isLazyLoad) {
          dispatch({
            type: SET_HOTEL_SEARCH_IS_NEW,
            isNew: false,
          });
          dispatch({
            type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
            establishments: [],
          });
          dispatch({
            type: SET_HOTEL_ESTABLISHMENTS_COPY,
            filteredEstablishments: [],
          });
          dispatch({
            type: CLEAN_SELECTED_SUBTYPES_HOTELS_LIST,
          });
        }

        const url = `${environment.apiUrl}muv-meta-engine/meta-hotels/getHotelListing?`;
        const body = {
          "commonData[check_in]": hotel_form_state.check_in,
          "commonData[check_out]": hotel_form_state.check_out,
          "commonData[rooms]": hotel_form_state.rooms,
          "commonData[adults]": hotel_form_state.adults,
          "commonData[currency]": currency,
          "commonData[customerUserAgent]": "Chrome",
          "commonData[muv_city_id]": hotel_form_state?.muv_id,
          "commonData[customerPlatform]": hotel_form_state?.customerPlatform,
          "commonData[customerUserAgent]": hotel_form_state?.customerUserAgent,
          "commonData[userIp]": ipAddress || "38.80.69.245",
          uuid: hotel_form_state?.uuid,
          proxyApiMethod: "GET",
          proxyApiProperty: "hotel",
          proxyApiEndpoint: "getExpress.Availability",
        };
        const urlParams = new URLSearchParams(body).toString();

        // Add limit and offset as URL parameters
        const limitParam = limit || 15;
        const offsetParam = offset || 0;
        const finalUrl = `${url}${urlParams}&limit=${limitParam}&offset=${offsetParam}`;

        //console.log(api_url, obj);
        dispatch({
          type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
          no_more: false,
        });

        dispatch({
          type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
          no_progress: false,
        });

        PostAsyncHelper(finalUrl).then((response) => {
          if (response !== undefined && response.statusText === "OK") {
            // Handle the new API response format
            if (response?.data?.ProxyResult && Array.isArray(response.data.ProxyResult)) {
              // New API format - hotels are directly in ProxyResult array
              const hotels = response.data.ProxyResult || [];
              const totalHotels = response.data.total_number_of_hotels || 0;

              if (hotels.length > 0 || isLazyLoad) {
                // Convert hotels to establishments format
                let establishments = [];
                let subtypes = [];
                let catSubTypes = [];
                let neighborhoodSubTypes = [];
                let hotel_chainSubTypes = [];
                let lowPrice = 999999;
                let highPrice = 0;
                let lowGuestScore = 999999;
                let highGuestScore = 0;

                let currencyLetters = hotels[0]?.price_details?.display_currency;
                let currencySymbol = hotels[0]?.price_details?.display_symbol;

                hotels.forEach((hotel, index) => {
                  const roomPrice = hotel?.price_details?.display_sub_total || hotel?.mincost || 0;
                  if (roomPrice > highPrice) highPrice = roomPrice;
                  if (roomPrice < lowPrice) lowPrice = roomPrice;

                  const guestScore = hotel.review_rating;
                  if (guestScore > highGuestScore) highGuestScore = guestScore;
                  if (guestScore < lowGuestScore) lowGuestScore = guestScore;

                  establishments[index] = {
                    establishmentID: hotel?.id,
                    establishmentPricelineID: hotel?.hotelid_ppn,
                    establishmentHPID: hotel?.hotelplanner_id,
                    establishmentName: hotel.name,
                    establishmentDescription: hotel.property_description,
                    establishmentStarRating: hotel.star_rating,
                    establishmentReviewRating: hotel.review_rating,
                    latitude: hotel.geo?.latitude,
                    longitude: hotel.geo?.longitude,
                    city_id: hotel_form_state.city_id,
                    address_line_one: hotel.address?.address_line_one,
                    establishmentCity: hotel.address?.city_name,
                    establishmentState: hotel.address?.state_name,
                    establishmentCountry: hotel.address?.country_name,
                    establishmentCityCode: hotel.address?.city_code,
                    establishmentStateCode: hotel.address?.state_code,
                    establishmentCountryCode: hotel.address?.country_code,
                    amenity_data: hotel.amenity_data,
                    display_price: hotel?.price_details?.display_sub_total || hotel?.mincost || "",
                    display_currency: hotel?.price_details?.display_currency || "",
                    display_symbol: hotel?.price_details?.display_symbol || "",
                    price_details: hotel?.price_details,
                    imageUrl: hotel?.image?.url,
                    estabPicture: {
                      imageName: hotel?.thumbnail,
                      description: hotel.name,
                    },
                    hotelType: hotel?.provier || hotel?.provider,
                    numberOfRooms: hotel?.numberOfRooms,
                    mincost: hotel?.mincost,
                    provider: hotel?.provier,
                    hotelid_ppn: hotel?.hotelid_ppn,
                    hotelplanner_id: hotel?.hotelplanner_id,
                    exp_id: hotel?.exp_id,
                    distanceFromCity: calcDistance(
                      Number(hotel.geo?.latitude),
                      Number(hotel.geo?.longitude),
                      Number(hotel_form_state.city_latitude),
                      Number(hotel_form_state.city_longitude)
                    ),
                  };

                  // Process amenities for subtypes (only on initial load)
                  if (!isLazyLoad && hotel?.amenity_data) {
                    hotel.amenity_data.forEach((amenity) => {
                      catSubTypes.push({
                        title: amenity.name,
                        id: "a-" + amenity.id,
                        type: "amenity",
                      });
                    });
                  }
                });

                // Process subtypes only on initial load
                if (!isLazyLoad) {
                  // Remove duplicates
                  catSubTypes = removeDuplicateObjectFromArray(catSubTypes, "id");

                  const catSubType = {
                    id: 1,
                    title: "Amenities",
                    subtypes: catSubTypes,
                  };
                  subtypes.push(catSubType);

                  dispatch({
                    type: FETCH_SUBTYPES_HOTELS_LIST,
                    subtypes: subtypes,
                    lowPrice: Math.floor(lowPrice),
                    highPrice: Math.ceil(highPrice),
                    lowGuestScore,
                    highGuestScore,
                    currencyLetters,
                    currencySymbol,
                    establishmentsToFilter: establishments,
                  });
                }

                if (isLazyLoad) {

                  // Append new establishments for lazy loading
                  dispatch({
                    type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
                    establishments: establishments,
                    isLazyLoad: true,
                  });

                  // Check if we've reached the end
                  if (establishments.length < limitParam) {
                    dispatch({
                      type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
                      no_more: true,
                    });
                  }
                } else {
                  // Initial load - show only first 15 establishments
                  const initEstablishments = establishments.slice(0, 15);
                  dispatch({
                    type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
                    establishments: initEstablishments,
                  });
                  dispatch({
                    type: SET_FILTERED_ESTABLISHMENTS,
                    filteredEstablishments: establishments,
                  });
                  dispatch({
                    type: SET_HOTEL_ESTABLISHMENTS_COPY,
                    filteredEstablishments: establishments,
                  });

                  // Store total count for Virtuoso
                  dispatch({
                    type: UPDATE_LAZYLOADING_TOTAL_HOTELS,
                    totalHotels: totalHotels,
                  });

                  // Set initial offset to the number of hotels loaded (15)
                  dispatch({
                    type: UPDATE_LAZYLOADING_OFFSET_HOTELS_LIST,
                    offset: 15,
                  });
                }

                dispatch({
                  type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
                  no_progress: true, // hide progress circle
                });
                dispatch({
                  type: SET_LOADER,
                  payload: false,
                });
              } else {
                // No hotels found
                dispatch({
                  type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
                  establishments: [],
                });
                dispatch({
                  type: SET_FILTERED_ESTABLISHMENTS,
                  filteredEstablishments: [],
                });
                dispatch({
                  type: SET_HOTEL_ESTABLISHMENTS_COPY,
                  filteredEstablishments: [],
                });
                dispatch({
                  type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
                  no_more: true,
                });
                dispatch({
                  type: SET_LOADER,
                  payload: false,
                });
              }
            } else {
              // Handle old API format or error cases
              if (
                (response?.data?.ProxyResult["getHotelExpress.Results"]?.results &&
                  response?.data?.ProxyResult["getHotelExpress.Results"]?.results
                    ?.status !== "Success") ||
                (response?.data?.ProxyResult["getHotelExpress.Results"]?.error &&
                  response?.data?.ProxyResult["getHotelExpress.Results"]?.error
                    ?.status !== "")
              ) {
                // if status: "Hotel.Express.Results: All enabled inventories returned without rates"
                if (
                  response.data.ProxyResult["getHotelExpress.Results"].error
                    .status ==
                  "Hotel.Express.Results: All enabled inventories returned without rates"
                ) {
                  // set found to []
                  let establishments = [];

                  dispatch({
                    type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
                    establishments: establishments,
                  });
                  dispatch({
                    type: SET_LOADER,
                    payload: false,
                  });
                  dispatch({
                    type: SET_FILTERED_ESTABLISHMENTS,
                    filteredEstablishments: establishments,
                  });
                  dispatch({
                    type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
                    no_more: true,
                  });
                } else {
                  //throw Error(response.data.ProxyResult["getHotelExpress.Results"].error.status);
                  dispatch({
                    type: PL_FETCH_HOTELS_LIST_FAILURE,
                    payload:
                      response.data.ProxyResult["getHotelExpress.Results"].error
                        .status,
                  });
                  dispatch({
                    type: FETCH_API_ERROR_HOTELS_LIST, //?
                    api_error: true,
                  });
                }

                dispatch({
                  type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
                  no_progress: true,
                });
              } else {
                // Handle old format response processing...
                // (keeping the existing logic for backward compatibility)
                const responseResults = response?.data?.ProxyResult;
                let muvHotels = [];
                let muvResponse = responseResults;
                if (muvResponse) {
                  for (const key in muvResponse) {
                    const data = muvResponse[key];
                    muvHotels.push(data);
                  }
                }

                //sort by rating
                if (muvHotels?.length > 0) {
                  muvHotels = muvHotels.map((hotel) => { return { ...hotel, hotelType: hotel?.provier || hotel?.provider } })
                  muvHotels.sort((a, b) => Number(b?.review_rating) - Number(a?.review_rating))
                }

                const arry = muvHotels;
                let establishments = [];

                if (arry) {
                  let subtypes = [];
                  let catSubTypes = [];
                  let neighborhoodSubTypes = [];
                  let hotel_chainSubTypes = [];
                  let lowPrice = 999999;
                  let highPrice = 0;
                  let lowGuestScore = 999999;
                  let highGuestScore = 0;

                  let currencyLetters =
                    arry &&
                    arry?.[0]?.room_data?.[0]?.rate_data?.[0]?.price_details
                      .display_currency;
                  let currencySymbol =
                    arry &&
                    arry?.[0]?.room_data?.[0].rate_data?.[0]?.price_details.display_symbol;

                  Object.values(arry).forEach((rate_data, index) => {
                    const roomPrice =
                      rate_data?.room_data?.[0]?.rate_data?.[0]?.price_details
                        ?.display_price;
                    if (roomPrice > highPrice) highPrice = roomPrice;
                    if (roomPrice < lowPrice) lowPrice = roomPrice;

                    const guestScore = rate_data.review_rating;
                    if (guestScore > highGuestScore) highGuestScore = guestScore;
                    if (guestScore < lowGuestScore) lowGuestScore = guestScore;

                    const roomRate =
                      rate_data?.room_data && rate_data?.room_data?.length > 0
                        ? rate_data?.room_data[0]?.rate_data[0]?.rate_type
                        : null;
                    const resortDetails =
                      rate_data?.room_data && rate_data?.room_data?.length > 0
                        ? rate_data?.room_data[0]?.rate_data[0]?.price_details
                          ?.mandatory_fee_details?.display_total
                        : null;
                    const roomData = getRoomData(
                      rate_data?.room_data,
                      loggedIn ? "SMOP" : null
                    )?.rate_data;
                    const room = getHotelRate(roomData, loggedIn ? "SMOP" : null);
                    const roomInfo = rate_data?.room_data;

                    establishments[index] = {
                      establishmentID: rate_data?.id,
                      establishmentPricelineID: rate_data?.hotelid_ppn,
                      establishmentHPID: rate_data?.hotelplanner_id,
                      ppn_bundle: rate_data.ppn_bundle,
                      rate_tracking_id: rate_data.rate_tracking_id,
                      hotel_zone: rate_data.neighborhood
                        ? rate_data.neighborhood.name
                        : rate_data.hotel_zone,
                      neighborhood: rate_data.neighborhood
                        ? rate_data.neighborhood
                        : null,
                      establishmentName: rate_data.name || rate_data?.property_name,
                      propertyType: rate_data?.property_type_id,
                      smopRate: roomRate === "SMOP" ? "SMOP" : null,
                      resortFees: !resortDetails ? "resortFees" : null,
                      establishmentDescription: rate_data.description || rate_data.hotel_description || rate_data?.property_description,
                      establishmentNeighborhood: rate_data.hotel_zone
                        ? rate_data.hotel_zone
                        : "",
                      establishmentStarRating: rate_data.star_rating,
                      establishmentReviewRating: rate_data.review_rating,
                      latitude: rate_data.geo.latitude,
                      longitude: rate_data.geo.longitude,
                      city_id: hotel_form_state.city_id,
                      address_line_one: rate_data.address.address_line_one,
                      establishmentCity: rate_data.address.city_name,
                      establishmentState: rate_data.address.state_name,
                      establishmentCountry: rate_data.address.country_name,
                      establishmentCityCode: rate_data.address.city_code,
                      establishmentStateCode: rate_data.address.state_code,
                      establishmentCountryCode: rate_data.address.country_code,
                      amenity_data: rate_data.amenity_data,
                      display_price: room?.price_details?.display_price || rate_data?.price_details?.display_sub_total || "",
                      display_currency: room?.price_details?.display_currency || rate_data?.price_details?.display_currency || "",
                      display_symbol: room?.price_details?.display_symbol || rate_data?.price_details?.display_symbol || "",
                      price_details: room?.price_details || rate_data?.price_details,
                      imageUrl: rate_data?.image?.url,
                      muverRate: getSmopRate(loggedIn ? roomData : null),
                      estabPicture: {
                        imageName: rate_data?.thumbnail || rate_data?.thumbnail_hq?.three_hundred_square,
                        description: rate_data.name,
                      },
                      hotelType: rate_data?.hotelType,
                      roomInfo: roomInfo,
                      hotel_chain: {
                        id:
                          rate_data?.hotel_chain !== null
                            ? rate_data?.hotel_chain?.id
                            : null,
                        name:
                          rate_data?.hotel_chain !== null
                            ? rate_data?.hotel_chain?.name
                            : null,
                      },
                      distanceFromCity: calcDistance(
                        Number(rate_data.geo.latitude),
                        Number(rate_data.geo.longitude),
                        Number(hotel_form_state.city_latitude),
                        Number(hotel_form_state.city_longitude)
                      ),
                    };

                    if (rate_data?.amenity_data) {
                      rate_data.amenity_data.forEach((amenity, idx) => {
                        catSubTypes.push({
                          title: amenity.name,
                          id: "a-" + amenity.id,
                          type: "amenity",
                        });
                      });
                    }

                    if (
                      rate_data?.neighborhood?.name !== undefined &&
                      rate_data?.neighborhood !== null
                    ) {
                      neighborhoodSubTypes.push({
                        title: rate_data?.neighborhood?.name,
                        id: "n-" + rate_data.neighborhood?.id,
                        type: "neighborhood",
                      });
                    }

                    if (
                      rate_data.hotel_chain !== undefined &&
                      rate_data.hotel_chain !== null &&
                      rate_data.hotel_chain.name !== null
                    ) {
                      hotel_chainSubTypes.push({
                        title: rate_data.hotel_chain.name,
                        id: "b-" + rate_data.hotel_chain.id,
                        type: "hotel_chain",
                      });
                    }
                  });

                  dispatch({
                    type: SET_FILTERED_ESTABLISHMENTS,
                    filteredEstablishments: establishments,
                  });
                  dispatch({
                    type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
                    no_progress: true, // hide progress circle
                  });

                  const starsSubType = {
                    id: 0,
                    title: "Star Rating",
                    subtypes: [{ id: "stars-5", title: "5 stars", type: "stars" }],
                  };

                  // remove duplicates
                  catSubTypes = removeDuplicateObjectFromArray(catSubTypes, "id");

                  const catSubType = {
                    id: 1,
                    title: "Amenities",
                    subtypes: catSubTypes,
                  };
                  subtypes.push(catSubType);

                  neighborhoodSubTypes = removeDuplicateObjectFromArray(
                    neighborhoodSubTypes,
                    "id"
                  );

                  ///sort neighborhoods
                  if (neighborhoodSubTypes?.length > 0) {
                    neighborhoodSubTypes = neighborhoodSubTypes.sort(function (
                      a,
                      b
                    ) {
                      if (a?.title < b?.title) {
                        return -1;
                      }
                      if (a?.title > b?.title) {
                        return 1;
                      }
                      return 0;
                    });
                  }

                  const neighborhoodSubType = {
                    id: 2,
                    title: "Neighborhood",
                    subtypes: neighborhoodSubTypes,
                  };

                  subtypes.push(neighborhoodSubType);

                  hotel_chainSubTypes = removeDuplicateObjectFromArray(
                    hotel_chainSubTypes,
                    "id"
                  );

                  const hotel_chainSubType = {
                    id: 3,
                    title: "Brands",
                    subtypes: hotel_chainSubTypes,
                  };

                  subtypes.push(hotel_chainSubType);

                  dispatch({
                    type: FETCH_SUBTYPES_HOTELS_LIST,
                    subtypes: subtypes,
                    lowPrice: Math.floor(lowPrice),
                    highPrice: Math.ceil(highPrice),
                    lowGuestScore,
                    highGuestScore,
                    currencyLetters,
                    currencySymbol,
                    establishmentsToFilter: establishments,
                  });
                }

                // show first results
                const initEstablishments = establishments.slice(
                  0,
                  LAZYLOADING_HOTELS_INIT_LIMIT
                );

                dispatch({
                  type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
                  establishments: initEstablishments,
                });
                dispatch({
                  type: SET_LOADER,
                  payload: false,
                });
                dispatch({
                  type: SET_FILTERED_ESTABLISHMENTS,
                  filteredEstablishments: establishments,
                });

                dispatch({
                  type: SET_HOTEL_ESTABLISHMENTS_COPY,
                  filteredEstablishments: establishments,
                });
              }
            }
          } else {
            // error Posting to api_url
            dispatch({
              type: PL_FETCH_HOTELS_LIST_FAILURE,
              payload: response.statusText,
            });
            dispatch({
              type: FETCH_API_ERROR_HOTELS_LIST, //?
              api_error: true,
            });
            dispatch({
              type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
              no_progress: true,
            });
          }
        });
      } catch (error) {
        dispatch({
          type: PL_FETCH_HOTELS_LIST_FAILURE,
          payload: error.message,
        });
      }
    };

export const fetchMuvHotelsLazyLoad =
  (hotel_form_state, currency, lazyLoading) => async (dispatch) => {
    const offset = lazyLoading.offset || 0;
    const limit = 15;

    dispatch({ type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST, no_progress: false });
    await dispatch(getMuvHotels(hotel_form_state, currency, limit, offset, true));
    dispatch({ type: UPDATE_LAZYLOADING_OFFSET_HOTELS_LIST, offset: offset + limit });
  };

/*  get homepage cities list -search  */
export const getPriceLineHotels =
  (hotel_form_state, lazyLoading, currency, featuredHotels, limit) =>
    async (dispatch) => {
      //console.log("getPriceLineHotels", hotel_form_state, lazyLoading);

      try {
        const loggedIn = await isAuthenticated();
        dispatch({
          type: SET_HOTEL_SEARCH_IS_SEARCHING,
          isSearching: true,
        })
        dispatch({
          type: SET_HOTEL_SEARCH_IS_NEW,
          isNew: false,
        });
        dispatch({
          type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
          establishments: [],
        });
        dispatch({
          type: SET_HOTEL_ESTABLISHMENTS_COPY,
          filteredEstablishments: [],
        });
        dispatch({
          type: CLEAN_SELECTED_SUBTYPES_HOTELS_LIST,
        });

        let obj = {
          "proxyData[format]": "json2",
          "proxyData[check_in]": hotel_form_state.check_in,
          "proxyData[check_out]": hotel_form_state.check_out,
          "proxyData[rooms]": hotel_form_state.rooms,
          "proxyData[adults]": hotel_form_state.adults,
          "proxyData[currency]": currency,
          //"proxyData[limit]": lazyLoading.requests["proxyData[limit]"],      // LAZYLOADING_ESTABLISHMENTS_LIMIT
          // "proxyData[limit]": limit ? limit : LAZYLOADING_HOTELS_INIT_LIMIT,
          "proxyData[sort_by]": lazyLoading.requests["proxyData[sort_by]"], // guest score
          proxyApiMethod: "GET",
          proxyApiProperty: "hotel",
          proxyApiEndpoint: "getExpress.Results",
        };
        const hasHotels =
          featuredHotels &&
          featuredHotels !== undefined &&
          featuredHotels !== "undefined" &&
          featuredHotels.length > 0;
        if (hotel_form_state && hotel_form_state.city_id && !hasHotels) {
          //search by city
          obj["proxyData[city_id]"] = hotel_form_state.city_id;
        }
        if (
          hotel_form_state &&
          hotel_form_state?.latitude &&
          hotel_form_state?.longitude &&
          !hasHotels
        ) {
          //search by city
          obj["proxyData[latitude]"] = hotel_form_state.latitude;
          obj["proxyData[longitude]"] = hotel_form_state.longitude;
        }
        if (hasHotels) {
          //search by hotel
          obj["proxyData[hotel_ids]"] = featuredHotels;
        }

        let api_url = `${environment.apiUrl}proxy/dispatchRequest`;

        //console.log(api_url, obj);
        dispatch({
          type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
          no_more: false,
        });

        dispatch({
          type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
          no_progress: false, // show progress circle
        });

        PostAsyncHelper(api_url, obj).then((response) => {
          //console.log(response);
          if (response !== undefined && response.statusText === "OK") {
            // successful Post to api_url
            if (
              (response?.data?.ProxyResult["getHotelExpress.Results"]?.results &&
                response?.data?.ProxyResult["getHotelExpress.Results"]?.results
                  ?.status !== "Success") ||
              (response?.data?.ProxyResult["getHotelExpress.Results"]?.error &&
                response?.data?.ProxyResult["getHotelExpress.Results"]?.error
                  ?.status !== "")
            ) {
              // if status: "Hotel.Express.Results: All enabled inventories returned without rates"
              if (
                response.data.ProxyResult["getHotelExpress.Results"].error
                  .status ==
                "Hotel.Express.Results: All enabled inventories returned without rates"
              ) {
                // set found to []
                let establishments = [];

                dispatch({
                  type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
                  establishments: establishments,
                });
                dispatch({
                  type: SET_LOADER,
                  payload: false,
                });
                dispatch({
                  type: SET_FILTERED_ESTABLISHMENTS,
                  filteredEstablishments: establishments,
                });
                dispatch({
                  type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
                  no_more: true,
                });

              } else {
                //throw Error(response.data.ProxyResult["getHotelExpress.Results"].error.status);
                dispatch({
                  type: PL_FETCH_HOTELS_LIST_FAILURE,
                  payload:
                    response.data.ProxyResult["getHotelExpress.Results"].error
                      .status,
                });
                dispatch({
                  type: FETCH_API_ERROR_HOTELS_LIST, //?
                  api_error: true,
                });

              }

              dispatch({
                type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
                no_progress: true,
              });

              dispatch({
                type: SET_HOTEL_SEARCH_IS_SEARCHING,
                isSearching: false,
              })

            } else {
              // convert pl results into establishments

              dispatch({
                type: SET_HOTEL_SEARCH_IS_SEARCHING,
                isSearching: false,
              })

              const arry =
                response?.data?.ProxyResult["getHotelExpress.Results"]?.results
                  ?.hotel_data;
              // console.log("arry ", arry);
              // console.log("arry ", response?.data?.ProxyResult["getHotelExpress.Results"]?.results);
              let establishments = [];

              if (arry) {
                let subtypes = [];
                let catSubTypes = [];
                let neighborhoodSubTypes = [];
                let hotel_chainSubTypes = [];
                let lowPrice = 999999;
                let highPrice = 0;
                let lowGuestScore = 999999;
                let highGuestScore = 0;

                let currencyLetters =
                  arry &&
                  arry[0].room_data[0].rate_data[0]?.price_details
                    .display_currency;
                let currencySymbol =
                  arry &&
                  arry[0].room_data[0].rate_data[0]?.price_details.display_symbol;

                Object.values(arry).forEach((rate_data, index) => {
                  //    citiesArry.push(cities[key])
                  //console.log("xx", index, rate_data.id);
                  const roomPrice =
                    rate_data.room_data[0].rate_data[0]?.price_details
                      .display_price;
                  if (roomPrice > highPrice) highPrice = roomPrice;
                  if (roomPrice < lowPrice) lowPrice = roomPrice;

                  const guestScore = rate_data.review_rating;
                  if (guestScore > highGuestScore) highGuestScore = guestScore;
                  if (guestScore < lowGuestScore) lowGuestScore = guestScore;

                  const roomRate =
                    rate_data?.room_data && rate_data?.room_data?.length > 0
                      ? rate_data?.room_data[0]?.rate_data[0]?.rate_type
                      : null;
                  const resortDetails =
                    rate_data?.room_data && rate_data?.room_data?.length > 0
                      ? rate_data?.room_data[0]?.rate_data[0]?.price_details
                        ?.mandatory_fee_details?.display_total
                      : null;
                  const roomData = getRoomData(
                    rate_data?.room_data,
                    loggedIn ? "SMOP" : null
                  )?.rate_data;
                  const room = getHotelRate(roomData, loggedIn ? "SMOP" : null);
                  const roomInfo = rate_data?.room_data;

                  establishments[index] = {
                    establishmentID: "",
                    establishmentPricelineID: rate_data.id,
                    ppn_bundle: rate_data.ppn_bundle,
                    rate_tracking_id: rate_data.rate_tracking_id,
                    hotel_zone: rate_data.neighborhood
                      ? rate_data.neighborhood.name
                      : rate_data.hotel_zone,
                    neighborhood: rate_data.neighborhood
                      ? rate_data.neighborhood
                      : null,
                    establishmentName: rate_data.name,
                    propertyType: rate_data?.property_type_id,
                    smopRate: roomRate === "SMOP" ? "SMOP" : null,
                    resortFees: !resortDetails ? "resortFees" : null,
                    establishmentDescription: rate_data.hotel_description,
                    establishmentNeighborhood: rate_data.hotel_zone
                      ? rate_data.hotel_zone
                      : "",
                    establishmentStarRating: rate_data.star_rating,
                    establishmentReviewRating: rate_data.review_rating,
                    //  "uri": "27657-The_Metropolitan_Museum_of_Art-New_York-USA",
                    latitude: rate_data.geo.latitude,
                    longitude: rate_data.geo.longitude,
                    city_id: hotel_form_state.city_id,
                    address_line_one: rate_data.address.address_line_one,
                    establishmentCity: rate_data.address.city_name,
                    establishmentState: rate_data.address.state_name,
                    establishmentCountry: rate_data.address.country_name,
                    establishmentCityCode: rate_data.address.city_code,
                    establishmentStateCode: rate_data.address.state_code,
                    establishmentCountryCode: rate_data.address.country_code,
                    amenity_data: rate_data.amenity_data,
                    display_price: room?.price_details.display_price,
                    display_currency: room?.price_details.display_currency,
                    display_symbol: room?.price_details.display_symbol,
                    price_details: room?.price_details,
                    muverRate: getSmopRate(loggedIn ? roomData : null),
                    estabPicture: {
                      imageName: rate_data?.thumbnail_hq?.three_hundred_square,
                      description: rate_data.name,
                    },
                    roomInfo: roomInfo,
                    hotel_chain: {
                      id:
                        rate_data.hotel_chain !== null
                          ? rate_data.hotel_chain.id
                          : null,
                      name:
                        rate_data.hotel_chain !== null
                          ? rate_data.hotel_chain.name
                          : null,
                    },

                    distanceFromCity: calcDistance(
                      Number(rate_data.geo.latitude),
                      Number(rate_data.geo.longitude),
                      Number(hotel_form_state.city_latitude),
                      Number(hotel_form_state.city_longitude)
                    ),
                  };

                  //console.log(rate_data.amenity_data);
                  rate_data.amenity_data.forEach((amenity, idx) => {
                    //console.log(idx);
                    catSubTypes.push({
                      title: amenity.name,
                      id: "a-" + amenity.id,
                      type: "amenity",
                    });
                  });

                  if (
                    rate_data?.neighborhood?.name !== undefined &&
                    rate_data?.neighborhood !== null
                  ) {
                    neighborhoodSubTypes.push({
                      title: rate_data?.neighborhood?.name,
                      id: "n-" + rate_data.neighborhood?.id,
                      type: "neighborhood",
                    });
                  }

                  if (
                    rate_data.hotel_chain !== undefined &&
                    rate_data.hotel_chain !== null &&
                    rate_data.hotel_chain.name !== null
                  ) {
                    hotel_chainSubTypes.push({
                      title: rate_data.hotel_chain.name,
                      id: "b-" + rate_data.hotel_chain.id,
                      type: "hotel_chain",
                    });
                  }
                });

                establishments = removeDuplicateObjectFromArray(
                  establishments,
                  "establishmentPricelineID"
                );

                dispatch({
                  type: SET_FILTERED_ESTABLISHMENTS,
                  filteredEstablishments: establishments,
                });
                dispatch({
                  type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
                  no_progress: true, // hide progress circle
                });

                const starsSubType = {
                  id: 0,
                  title: "Star Rating",
                  subtypes: [{ id: "stars-5", title: "5 stars", type: "stars" }],
                };
                //subtypes.push(catSubType)

                // remove duplicates
                catSubTypes = removeDuplicateObjectFromArray(catSubTypes, "id");

                const catSubType = {
                  id: 1,
                  title: "Amenities",
                  subtypes: catSubTypes,
                };
                subtypes.push(catSubType);

                neighborhoodSubTypes = removeDuplicateObjectFromArray(
                  neighborhoodSubTypes,
                  "id"
                );

                ///sort neighborhoods
                if (neighborhoodSubTypes?.length > 0) {
                  neighborhoodSubTypes = neighborhoodSubTypes.sort(function (
                    a,
                    b
                  ) {
                    if (a?.title < b?.title) {
                      return -1;
                    }
                    if (a?.title > b?.title) {
                      return 1;
                    }
                    return 0;
                  });
                }

                const neighborhoodSubType = {
                  id: 2,
                  title: "Neighborhood",
                  subtypes: neighborhoodSubTypes,
                };

                subtypes.push(neighborhoodSubType);

                hotel_chainSubTypes = removeDuplicateObjectFromArray(
                  hotel_chainSubTypes,
                  "id"
                );

                const hotel_chainSubType = {
                  id: 3,
                  title: "Brands",
                  subtypes: hotel_chainSubTypes,
                };

                subtypes.push(hotel_chainSubType);

                dispatch({
                  type: FETCH_SUBTYPES_HOTELS_LIST,
                  subtypes: subtypes,
                  lowPrice: Math.floor(lowPrice),
                  highPrice: Math.ceil(highPrice),
                  lowGuestScore,
                  highGuestScore,
                  currencyLetters,
                  currencySymbol,
                  establishmentsToFilter: establishments,
                });
              }

              // show first results
              const initEstablishments = establishments

              dispatch({
                type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
                establishments: initEstablishments,
              });
              dispatch({
                type: SET_LOADER,
                payload: false,
              });
              dispatch({
                type: SET_FILTERED_ESTABLISHMENTS,
                filteredEstablishments: establishments,
              });

              dispatch({
                type: SET_HOTEL_ESTABLISHMENTS_COPY,
                filteredEstablishments: establishments,
              });

              // do 2nd api call to get all results, no limit
              // delete obj["proxyData[limit]"];

              // PostAsyncHelper(api_url, obj).then((response) => {
              //   //console.log(response);
              //   if (response !== undefined && response.statusText === "OK") {
              //     // successful Post to api_url
              //     if (
              //       response?.data?.ProxyResult["getHotelExpress.Results"]
              //         ?.results &&
              //       response?.data?.ProxyResult["getHotelExpress.Results"]
              //         ?.results?.status !== "Success"
              //     ) {
              //       //throw Error(response.data.ProxyResult["getHotelExpress.Results"].error.status);
              //       dispatch({
              //         type: PL_FETCH_HOTELS_LIST_FAILURE,
              //         payload:
              //           response.data.ProxyResult["getHotelExpress.Results"].error
              //             .status,
              //       });
              //       dispatch({
              //         type: FETCH_API_ERROR_HOTELS_LIST, //?
              //         api_error: true,
              //       });
              //       dispatch({
              //         type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
              //         no_progress: true,
              //       });
              //     } else {
              //       // convert pl results into establishments

              //       const arry =
              //         response?.data?.ProxyResult["getHotelExpress.Results"]
              //           ?.results?.hotel_data;

              //       let establishments = [];
              //       let subtypes = [];
              //       let catSubTypes = [];
              //       let neighborhoodSubTypes = [];
              //       let hotel_chainSubTypes = [];
              //       let lowPrice = 999999;
              //       let highPrice = 0;
              //       let lowGuestScore = 999999;
              //       let highGuestScore = 0;
              //       let propertyTypes = [];
              //       let smopRates = [];
              //       let resortFees = [];
              //       let currencyLetters =
              //         arry &&
              //         arry[0].room_data[0].rate_data[0]?.price_details
              //           .display_currency;
              //       let currencySymbol =
              //         arry &&
              //         arry[0].room_data[0].rate_data[0]?.price_details
              //           .display_symbol;

              //       if (arry) {
              //         Object.values(arry).forEach((rate_data, index) => {
              //           //    citiesArry.push(cities[key])
              //           //console.log("xx", index, rate_data.id);
              //           const roomPrice =
              //             rate_data.room_data[0].rate_data[0]?.price_details
              //               .display_price;
              //           if (roomPrice > highPrice) highPrice = roomPrice;
              //           if (roomPrice < lowPrice) lowPrice = roomPrice;

              //           const guestScore = rate_data.review_rating;
              //           if (guestScore > highGuestScore)
              //             highGuestScore = guestScore;
              //           if (guestScore < lowGuestScore)
              //             lowGuestScore = guestScore;

              //           const roomRate =
              //             rate_data?.room_data && rate_data?.room_data?.length > 0
              //               ? rate_data?.room_data[0]?.rate_data[0]?.rate_type
              //               : null;
              //           const resortDetails =
              //             rate_data?.room_data && rate_data?.room_data?.length > 0
              //               ? rate_data?.room_data[0]?.rate_data[0]?.price_details
              //                 ?.mandatory_fee_details?.display_total
              //               : null;
              //           const roomData = getRoomData(
              //             rate_data?.room_data,
              //             loggedIn ? "SMOP" : null
              //           )?.rate_data;
              //           const room = getHotelRate(
              //             roomData,
              //             loggedIn ? "SMOP" : null
              //           );
              //           const roomInfo = rate_data?.room_data;
              //           establishments[index] = {
              //             establishmentID: "",
              //             establishmentPricelineID: rate_data.id,
              //             ppn_bundle: rate_data.ppn_bundle,
              //             rate_tracking_id: rate_data.rate_tracking_id,
              //             hotel_zone: rate_data.neighborhood
              //               ? rate_data.neighborhood.name
              //               : rate_data.hotel_zone,
              //             neighborhood: rate_data.neighborhood
              //               ? rate_data.neighborhood
              //               : null,
              //             propertyType: rate_data?.property_type_id,
              //             smopRate: roomRate === "SMOP" ? "SMOP" : null,
              //             roomInfo: roomInfo,
              //             resortFees: !resortDetails ? "resortFees" : null,
              //             establishmentName: rate_data.name,
              //             establishmentDescription: rate_data.hotel_description,
              //             establishmentNeighborhood: rate_data.hotel_zone
              //               ? rate_data.hotel_zone
              //               : "",
              //             establishmentStarRating: rate_data.star_rating,
              //             establishmentReviewRating: rate_data.review_rating,
              //             //  "uri": "27657-The_Metropolitan_Museum_of_Art-New_York-USA",
              //             latitude: rate_data.geo.latitude,
              //             longitude: rate_data.geo.longitude,
              //             city_id: hotel_form_state.city_id,
              //             address_line_one: rate_data.address.address_line_one,
              //             establishmentCity: rate_data.address.city_name,
              //             establishmentState: rate_data.address.state_name,
              //             establishmentCountry: rate_data.address.country_name,
              //             establishmentCityCode: rate_data.address.city_code,
              //             establishmentStateCode: rate_data.address.state_code,
              //             establishmentCountryCode:
              //               rate_data.address.country_code,
              //             amenity_data: rate_data.amenity_data,
              //             display_price: room?.price_details.display_price,
              //             display_currency: room?.price_details.display_currency,
              //             display_symbol: room?.price_details.display_symbol,
              //             muverRate: getSmopRate(loggedIn ? roomData : null),
              //             estabPicture: {
              //               imageName:
              //                 rate_data?.thumbnail_hq?.three_hundred_square,
              //               description: rate_data.name,
              //             },

              //             hotel_chain: {
              //               id:
              //                 rate_data.hotel_chain !== null
              //                   ? rate_data.hotel_chain.id
              //                   : null,
              //               name:
              //                 rate_data.hotel_chain !== null
              //                   ? rate_data.hotel_chain.name
              //                   : null,
              //             },

              //             distanceFromCity: calcDistance(
              //               Number(rate_data.geo.latitude),
              //               Number(rate_data.geo.longitude),
              //               Number(hotel_form_state.city_latitude),
              //               Number(hotel_form_state.city_longitude)
              //             ),
              //           };

              //           //console.log(rate_data.amenity_data);
              //           rate_data.amenity_data.forEach((amenity, idx) => {
              //             //console.log(idx);
              //             catSubTypes.push({
              //               title: amenity.name,
              //               id: "a-" + amenity.id,
              //               type: "amenity",
              //             });
              //           });

              //           if (
              //             rate_data?.neighborhood?.name !== undefined &&
              //             rate_data?.neighborhood !== null
              //           ) {
              //             neighborhoodSubTypes.push({
              //               title: rate_data?.neighborhood?.name,
              //               id: "n-" + rate_data.neighborhood?.id,
              //               type: "neighborhood",
              //             });
              //           }

              //           if (
              //             rate_data.hotel_chain !== undefined &&
              //             rate_data.hotel_chain !== null &&
              //             rate_data.hotel_chain.name !== null
              //           ) {
              //             hotel_chainSubTypes.push({
              //               title: rate_data.hotel_chain.name,
              //               id: "b-" + rate_data.hotel_chain.id,
              //               type: "hotel_chain",
              //             });
              //           }

              //           const propertyObj = getPropertyType(
              //             rate_data?.property_type_id
              //           );

              //           if (
              //             propertyObj &&
              //             rate_data?.property_type_id !== undefined &&
              //             rate_data?.property_type_id !== null
              //           ) {
              //             propertyTypes.push({
              //               title: propertyObj?.property_type_name,
              //               id: "n-" + propertyObj?.property_type_id,
              //               type: "type",
              //             });
              //           }

              //           if (roomRate && roomRate === "SMOP") {
              //             smopRates.push({
              //               title: "Special Prices",
              //               id: "n-" + "SMOP",
              //               type: "smopRate",
              //               rate: rate_data,
              //             });
              //           }

              //           if (resortDetails) {
              //             resortFees.push({
              //               title: "Resort fees",
              //               id: "n-" + "resortFees",
              //               type: "resortFees",
              //               rate: rate_data,
              //             });
              //           }
              //         });
              //       }

              //       establishments = initEstablishments.concat(establishments);

              //       establishments = removeDuplicateObjectFromArray(
              //         establishments,
              //         "establishmentPricelineID"
              //       );

              //       dispatch({
              //         type: SET_FILTERED_ESTABLISHMENTS,
              //         filteredEstablishments: establishments,
              //       });
              //       dispatch({
              //         type: SET_HOTEL_ESTABLISHMENTS_COPY,
              //         filteredEstablishments: establishments,
              //       });

              //       dispatch({
              //         type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
              //         no_progress: true, // hide progress circle
              //       });

              //       const starsSubType = {
              //         id: 0,
              //         title: "Star Rating",
              //         subtypes: [
              //           { id: "stars-5", title: "5 stars", type: "stars" },
              //         ],
              //       };
              //       //subtypes.push(catSubType)

              //       propertyTypes = removeDuplicateObjectFromArray(
              //         propertyTypes,
              //         "id"
              //       );
              //       const typeSubType = {
              //         id: 1,
              //         title: "Type",
              //         subtypes: propertyTypes,
              //       };

              //       subtypes.push(typeSubType);

              //       // remove duplicates
              //       catSubTypes = removeDuplicateObjectFromArray(
              //         catSubTypes,
              //         "id"
              //       );

              //       const catSubType = {
              //         id: 2,
              //         title: "Amenities",
              //         subtypes: catSubTypes,
              //       };
              //       subtypes.push(catSubType);

              //       hotel_chainSubTypes = removeDuplicateObjectFromArray(
              //         hotel_chainSubTypes,
              //         "id"
              //       );

              //       const hotel_chainSubType = {
              //         id: 3,
              //         title: "Brands",
              //         subtypes: hotel_chainSubTypes,
              //       };

              //       subtypes.push(hotel_chainSubType);

              //       neighborhoodSubTypes = removeDuplicateObjectFromArray(
              //         neighborhoodSubTypes,
              //         "id"
              //       );

              //       ///sort neighborhoods
              //       if (neighborhoodSubTypes?.length > 0) {
              //         neighborhoodSubTypes = neighborhoodSubTypes.sort(function (
              //           a,
              //           b
              //         ) {
              //           if (a?.title < b?.title) {
              //             return -1;
              //           }
              //           if (a?.title > b?.title) {
              //             return 1;
              //           }
              //           return 0;
              //         });
              //       }
              //       const neighborhoodSubType = {
              //         id: 4,
              //         title: "Neighborhood",
              //         subtypes: neighborhoodSubTypes,
              //       };

              //       subtypes.push(neighborhoodSubType);

              //       dispatch({
              //         type: FETCH_SUBTYPES_HOTELS_LIST,
              //         subtypes: subtypes,
              //         lowPrice: Math.floor(lowPrice),
              //         highPrice: Math.ceil(highPrice),
              //         smopRates,
              //         resortFees,
              //         lowGuestScore,
              //         highGuestScore,
              //         currencyLetters,
              //         currencySymbol,
              //         establishmentsToFilter: establishments,
              //       });

              //       let objLazy = Object.assign(obj, {
              //         // "proxyData[limit]": lazyLoading.requests["proxyData[limit]"] + LAZYLOADING_HOTELS_INCREMENT})
              //         "proxyData[limit]":
              //           LAZYDISPLAY_INIT_LIMIT + LAZYDISPLAY_INCREMENT,
              //       });
              //       //console.log("objLazy ", objLazy);

              //       dispatch({
              //         type: UPDATE_LAZYLOADING_URL_REQUESTS_HOTELS_LIST,
              //         api_url: api_url,
              //         offset: LAZYDISPLAY_INIT_LIMIT + LAZYDISPLAY_INCREMENT,
              //         requests: objLazy,
              //       });
              //       dispatch({
              //         type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
              //         no_more: false,
              //       });

              //       const mapHotels = getMapHotels(
              //         establishments,
              //         hotel_form_state
              //       );

              //       dispatch({
              //         type: FETCH_PLACES_NEAR_BY_CENTER,
              //         places_near_by_center: mapHotels,
              //       });

              //       // dispatch({
              //       //     type: SET_HOTEL_SEARCH_IS_SEARCHING,
              //       //     isSearching: false,
              //       // })
              //     }
              //   } else {
              //     // error Posting to api_url
              //     dispatch({
              //       type: PL_FETCH_HOTELS_LIST_FAILURE,
              //       payload: response.statusText,
              //     });
              //     dispatch({
              //       type: FETCH_API_ERROR_HOTELS_LIST, //?
              //       api_error: true,
              //     });
              //     dispatch({
              //       type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
              //       no_progress: true,
              //     });
              //   }
              // });
            }
          } else {
            // error Posting to api_url
            dispatch({
              type: PL_FETCH_HOTELS_LIST_FAILURE,
              payload: response.statusText,
            });
            dispatch({
              type: FETCH_API_ERROR_HOTELS_LIST, //?
              api_error: true,
            });
            dispatch({
              type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
              no_progress: true,
            });
          }
        });
      } catch (error) {
        dispatch({
          type: PL_FETCH_HOTELS_LIST_FAILURE,
          payload: error.message,
        });
      }
    };

export const handleGroupSubTypeHotels =
  (establishments, subtypesGroup, lazyLoading, selectedSubtypes) =>
    (dispatch) => {
      const intersections = selectedSubtypes.filter(
        (subtype) => subtypesGroup.indexOf(subtype) !== -1
      );
      const difference = selectedSubtypes.filter(
        (subtype) => subtypesGroup.indexOf(subtype) === -1
      );
      // merge two or more arrays. This method does not change the existing arrays, but instead returns a new array
      let subtypes =
        intersections.length === 0
          ? selectedSubtypes.concat(subtypesGroup)
          : difference;
      let obj = {
        featureID: lazyLoading.requests.featureID,
        typeID: lazyLoading.requests.typeID,
        limit: LAZYLOADING_ESTABLISHMENTS_LIMIT,
        offset: 0,
        subtype: subtypes,
        sortingOrder: lazyLoading.requests.sortingOrder,
        sortingDirection: lazyLoading.requests.sortingDirection,
        searchquery: lazyLoading.requests.searchquery,
      };

      dispatch({
        type: UPDATE_SELECTED_SUBTYPES_HOTELS_LIST,
        selectedSubtypes: selectedSubtypes,
      });
    };

export const cleanSelectedSubTypeHotels =
  (establishmentsToFilter, hotel_form_state) => (dispatch) => {
    dispatch({
      type: CLEAN_SELECTED_SUBTYPES_HOTELS_LIST,
    });

    dispatch({
      type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
      establishments: establishmentsToFilter,
    });
    dispatch({
      type: SET_FILTERED_ESTABLISHMENTS,
      filteredEstablishments: establishmentsToFilter,
    });
    dispatch({
      type: UPDATE_LAZYLOADING_OFFSET_HOTELS_LIST,
      offset: LAZYDISPLAY_INIT_LIMIT + LAZYDISPLAY_INCREMENT,
    });
    dispatch({
      type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
      no_more: false,
    });

    const mapHotels = getMapHotels(establishmentsToFilter, hotel_form_state);

    dispatch({
      type: FETCH_PLACES_NEAR_BY_CENTER,
      places_near_by_center: mapHotels,
    });
  };

export const clearHotelFilters = (establishments) => async (dispatch) => {
  dispatch({
    type: SET_FILTERED_ESTABLISHMENTS,
    filteredEstablishments: establishments,
  });
};

export const filterEstablishments = (subtypes, establishments, sortBy) => {

  const selectedSubtypes = [...subtypes];
  const establishmentsToFilter = [...establishments];


  let filteredEstablishments =
    selectedSubtypes.length == 0
      ? establishmentsToFilter
      : establishmentsToFilter.filter((establishment) => {
        let showQuery = false;
        let showNeighborhoods = false;
        let showAmenities = true;
        let showBrands = false;
        let showLowPrice = false;
        let showHighPrice = false;
        let showLowScore = false;
        let showHighScore = false;
        let showType = false;
        let showStars = false;
        let filterQuery = false;
        let filterNeighborhoods = false;
        let filterAmenities = false;
        let filterBrands = false;
        let filterLowPrice = false;
        let filterHighPrice = false;
        let filterLowScore = false;
        let filterHighScore = false;
        let filterStars = false;
        let filterType = false;
        let filterSmop = false;
        let showSmop = false;
        let filterResort = false;
        let showResort = false;


        selectedSubtypes.forEach((subtype, subtype_idx) => {
          if (subtype.type === "smopRate") {
            filterSmop = true;
            //return establishment.neighborhood!==null && establishment.neighborhood.id===subtype.id
            showSmop =
              showSmop ||
              (establishment.smopRate !== null &&
                "n-" + establishment?.smopRate === subtype.id);
          }

          if (subtype.type === "resortFees") {
            filterResort = true;
            //return establishment.neighborhood!==null && establishment.neighborhood.id===subtype.id
            // showResort =
            //   showResort ||
            //   (establishment.resortFees !== null &&
            //     "n-" + establishment?.resortFees === subtype.id);
            showResort = showResort || (establishment?.price_details?.mandatory_fee_details?.breakdown?.postpaid?.display_total == 0);


          }

          if (subtype.type === "lowPrice") {
            filterLowPrice = true;
            const lowPrice = Number(subtype.id.replace("lp-", ""));
            console.log(
              "lowPrice",
              subtype,
              establishment.display_price,
              lowPrice
            );
            //return establishment.neighborhood!==null && establishment.neighborhood.id===subtype.id
            showLowPrice =
              showLowPrice || establishment.display_price >= lowPrice;
          }

          if (subtype.type === "highPrice") {
            filterHighPrice = true;
            const highPrice = Number(subtype.id.replace("hp-", ""));
            console.log(
              "lowPrice",
              subtype,
              establishment.display_price,
              highPrice
            );
            //return establishment.neighborhood!==null && establishment.neighborhood.id===subtype.id
            showHighPrice =
              showHighPrice || establishment.display_price <= highPrice;
          }

          if (subtype.type === "lowGuestScore") {
            filterLowScore = true;
            const lowScore = Number(subtype.id.replace("ls-", ""));
            console.log(
              "lowGuestScore",
              subtype,
              establishment.establishmentReviewRating,
              lowScore
            );
            //return establishment.neighborhood!==null && establishment.neighborhood.id===subtype.id
            showLowScore =
              showLowScore ||
              (establishment.establishmentReviewRating !== null &&
                establishment.establishmentReviewRating >= lowScore);
          }

          if (subtype.type === "highGuestScore") {
            filterHighScore = true;
            const highScore = Number(subtype.id.replace("hs-", ""));
            console.log(
              "highGuestScore",
              subtype,
              establishment.establishmentReviewRating,
              highScore
            );
            //return establishment.neighborhood!==null && establishment.neighborhood.id===subtype.id
            showHighScore =
              showHighScore ||
              (establishment.establishmentReviewRating !== null &&
                establishment.establishmentReviewRating <= highScore);
          }

          if (subtype.type === "query") {
            filterQuery = true;
            const query = subtype.title;
            console.log(
              "query",
              subtype,
              establishment.establishmentName,
              query
            );
            //return establishment.neighborhood!==null && establishment.neighborhood.id===subtype.id
            showQuery =
              showQuery ||
              (establishment.establishmentName !== null &&
                establishment.establishmentName
                  .toLowerCase()
                  .indexOf(query.toLowerCase()) > -1);
          }

          if (subtype.type === "type") {
            filterType = true;
            //return establishment.neighborhood!==null && establishment.neighborhood.id===subtype.id
            showType =
              showType ||
              (establishment.propertyType !== null &&
                "n-" + establishment?.propertyType === subtype.id);
          }

          if (subtype.type === "neighborhood") {
            filterNeighborhoods = true;
            console.log("neighborhood", subtype, establishment.hotel_zone);
            //return establishment.neighborhood!==null && establishment.neighborhood.id===subtype.id
            showNeighborhoods =
              showNeighborhoods ||
              (establishment.neighborhood?.name !== null &&
                "n-" + establishment.neighborhood?.id === subtype.id);
          }

          if (subtype.type === "stars") {
            filterStars = true;
            console.log(
              "stars",
              subtype,
              establishment.establishmentStarRating
            );
            //return establishment.neighborhood!==null && establishment.neighborhood.id===subtype.id
            const rating =
              establishment.establishmentStarRating !== null
                ? establishment.establishmentStarRating
                : 0;
            showStars =
              showStars ||
              (rating !== 0 &&
                rating < Number(subtype.id.replace("stars-", "")) + 0.5 &&
                rating >= Number(subtype.id.replace("stars-", "")) - 0.5);
          }

          if (subtype.type === "amenity") {
            filterAmenities = true;
            let found = false;
            establishment.amenity_data.forEach((amenity, ix) => {
              //console.log("amenity", amenity.id, subtype.id);
              found = found || "a-" + amenity.id === subtype.id;
            });

            showAmenities = showAmenities && found;
          }

          if (subtype.type === "hotel_chain") {
            filterBrands = true;
            console.log("hotel_chain", subtype, establishment.hotel_chain);
            //return establishment.hotel_chain!==null && establishment.hotel_chain.id===subtype.id
            showBrands =
              showBrands ||
              (establishment.hotel_chain !== null &&
                "b-" + establishment.hotel_chain.id === subtype.id);
          }
        });

        return (
          (filterNeighborhoods ? showNeighborhoods : true) &&
          (filterStars ? showStars : true) &&
          (filterQuery ? showQuery : true) &&
          (filterAmenities ? showAmenities : true) &&
          (filterBrands ? showBrands : true) &&
          (filterLowPrice ? showLowPrice : true) &&
          (filterHighPrice ? showHighPrice : true) &&
          (filterLowScore ? showLowScore : true) &&
          (filterHighScore ? showHighScore : true) &&
          (filterType ? showType : true) &&
          (filterResort ? showResort : true) &&
          (filterSmop ? showSmop : true)
        );
      });

  //console.log(filteredEstablishments);

  // sort by guest score
  if (sortBy == "gs") {
    filteredEstablishments = filteredEstablishments.sort((a, b) =>
      a.establishmentReviewRating < b.establishmentReviewRating ? 1 : -1
    );
  }


  // sort by lowest price
  if (sortBy == "lp") {
    filteredEstablishments = filteredEstablishments.sort((a, b) => {
      if (a?.muverRate?.price_details?.baseline_price && b?.muverRate?.price_details?.baseline_price) {
        return a?.muverRate?.price_details?.baseline_price > b?.muverRate?.price_details?.baseline_price ? 1 : -1
      }
      return a.display_price > b.display_price ? 1 : -1
    });
  }

  // sort by highest price
  if (sortBy == "hp") {
    filteredEstablishments = filteredEstablishments.sort((a, b) => {
      //console.log(a.display_price, b.display_price);
      if (a?.muverRate?.price_details?.baseline_price && b?.muverRate?.price_details?.baseline_price) {
        return a?.muverRate?.price_details?.baseline_price < b?.muverRate?.price_details?.baseline_price ? 1 : -1
      }
      return a.display_price < b.display_price ? 1 : -1;
    });
  }

  // sort by star rating
  if (sortBy == "sr") {
    filteredEstablishments = filteredEstablishments.sort((a, b) =>
      a.establishmentStarRating < b.establishmentStarRating ? 1 : -1
    );
  }

  // sort by guest score
  if (sortBy == "ds") {
    filteredEstablishments = filteredEstablishments.sort((a, b) =>
      a.distanceFromCity > b.distanceFromCity ? 1 : -1
    );
  }



  return filteredEstablishments;
};

export const deleteSelectedSubTypeHotels =
  (
    subtype,
    selectedSubtypes,
    establishmentsToFilter,
    hotel_form_state,
    lazyLoading
  ) =>
    (dispatch) => {
      let selectedSubtypesNew = selectedSubtypes.filter(
        (val) => val.id !== subtype.id
      );

      dispatch({
        type: UPDATE_SELECTED_SUBTYPES_HOTELS_LIST,
        selectedSubtypes: selectedSubtypesNew,
      });

      const filteredEstablishments = filterEstablishments(
        selectedSubtypesNew,
        establishmentsToFilter,
        lazyLoading.sortCode
      );

      dispatch({
        type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
        establishments: filteredEstablishments
      });
      dispatch({
        type: SET_FILTERED_ESTABLISHMENTS,
        filteredEstablishments: filteredEstablishments,
      });
      dispatch({
        type: UPDATE_LAZYLOADING_OFFSET_HOTELS_LIST,
        offset: LAZYDISPLAY_INIT_LIMIT + LAZYDISPLAY_INCREMENT,
      });
      dispatch({
        type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
        no_more: false,
      });

      const mapHotels = getMapHotels(filteredEstablishments, hotel_form_state);

      dispatch({
        type: FETCH_PLACES_NEAR_BY_CENTER,
        places_near_by_center: mapHotels,
      });
    };

export const addSelectedSubTypeHotels =
  (
    establishmentsToFilter,
    subtype,
    selectedSubtypes,
    hotel_form_state,
    lazyLoading
  ) =>
    (dispatch) => {
      let selectedSubtypesNew = selectedSubtypes.slice();
      selectedSubtypesNew.push(subtype);

      dispatch({
        type: UPDATE_SELECTED_SUBTYPES_HOTELS_LIST,
        selectedSubtypes: selectedSubtypesNew,
      });

      const filteredEstablishments = filterEstablishments(
        selectedSubtypesNew,
        establishmentsToFilter,
        lazyLoading.sortCode
      );




      //console.log(filteredEstablishments);

      dispatch({
        type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
        establishments: filteredEstablishments
      });
      dispatch({
        type: SET_FILTERED_ESTABLISHMENTS,
        filteredEstablishments: filteredEstablishments,
      });
      dispatch({
        type: UPDATE_LAZYLOADING_OFFSET_HOTELS_LIST,
        offset: LAZYDISPLAY_INIT_LIMIT + LAZYDISPLAY_INCREMENT,
      });
      dispatch({
        type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
        no_more: false,
      });

      const mapHotels = getMapHotels(filteredEstablishments, hotel_form_state);

      dispatch({
        type: FETCH_PLACES_NEAR_BY_CENTER,
        places_near_by_center: mapHotels,
      });
    };

export const fetchHotelListingSortingOptions = (lang) => async (dispatch) => {
  // may need to pull from muv - see fetchEstablishmentSortingOptions in DestinationActions
  const sorting_options = [
    { title: "Guest Score", code: "gs" },
    { title: "Lowest Price", code: "lp" },
    { title: "Highest Price", code: "hp" },
    { title: "Rating", code: "sr" },
    { title: "Distance", code: "ds" },
  ];

  dispatch({
    type: FETCH_SORTING_OPTION_HOTELS_LIST, // FETCH_SORTING_OPTION_HOTEL_LISTING
    sorting_options: sorting_options,
  });
};

export const clearEstablishments = () => async (dispatch) => {
  // clear current establishments array
  dispatch({
    type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
    establishments: [],
  });
  dispatch({
    type: SET_HOTEL_SEARCH_IS_NEW,
    isNew: false,
  });
  dispatch({
    type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
    no_progress: false, // show progress circle
  });
};

// TODO  SEE setSortingOptionsDestination
export const setSortingOptionsHotelListings =
  (selectedOption, selectedSubtypes, hotel_form_state) => async (dispatch) => {
    const loggedIn = await isAuthenticated();
    const sorting_titles = {
      gs: "Guest Score",
      lp: "Lowest Price",
      hp: "Highest Price",
      sr: "Rating",
      ds: "Distance",
    };

    // data objects for the post to priceline
    console.log("setSortingOptionsHotelListings", hotel_form_state);
    let obj = {
      "proxyData[format]": "json2",
      "proxyData[check_in]": hotel_form_state.check_in,
      "proxyData[check_out]": hotel_form_state.check_out,
      "proxyData[rooms]": hotel_form_state.rooms,
      "proxyData[adults]": hotel_form_state.adults,
      "proxyData[city_id]": hotel_form_state.city_id,
      //"proxyData[limit]": lazyLoading.requests["proxyData[limit]"],      // LAZYLOADING_ESTABLISHMENTS_LIMIT
      "proxyData[limit]": LAZYLOADING_HOTELS_INIT_LIMIT,
      "proxyData[sort_by]": selectedOption.code, // guest score
      proxyApiMethod: "GET",
      proxyApiProperty: "hotel",
      proxyApiEndpoint: "getExpress.Results",
    };

    let api_url = `${environment.apiUrl}proxy/dispatchRequest`;

    dispatch({
      type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
      no_more: false,
    });

    dispatch({
      type: UPDATE_LAZYLOADING_SORT_BY,
      sortCode: selectedOption.code,
      sortTitle: sorting_titles[selectedOption.code],
    });

    PostAsyncHelper(api_url, obj).then((response) => {
      //console.log(response);
      if (response !== undefined && response.statusText === "OK") {
        // successful Post to api_url
        if (
          response.data.ProxyResult["getHotelExpress.Results"].results &&
          response.data.ProxyResult["getHotelExpress.Results"].results
            .status !== "Success"
        ) {
          //throw Error(response.data.ProxyResult["getHotelExpress.Results"].error.status);
          dispatch({
            type: PL_FETCH_HOTELS_LIST_FAILURE,
            payload:
              response.data.ProxyResult["getHotelExpress.Results"].error.status,
          });
          dispatch({
            type: FETCH_API_ERROR_HOTELS_LIST, //?
            api_error: true,
          });
          dispatch({
            type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
            no_progress: true,
          });
        } else {
          // success in proxy results
          // convert pl results into establishments

          const arry =
            response.data.ProxyResult["getHotelExpress.Results"].results
              .rate_data;
          console.log("arry ", arry);

          let establishments = [];

          Object.values(arry).forEach((rate_data, index) => {
            //    citiesArry.push(cities[key])
            //console.log("xx", index, rate_data.id);
            const roomRate =
              rate_data?.room_data && rate_data?.room_data?.length > 0
                ? rate_data?.room_data[0]?.rate_data[0]?.rate_type
                : null;
            const resortDetails =
              rate_data?.room_data && rate_data?.room_data?.length > 0
                ? rate_data?.room_data[0]?.rate_data[0]?.price_details
                  ?.mandatory_fee_details?.display_total
                : null;
            const roomData = getRoomData(
              rate_data?.room_data,
              loggedIn ? "SMOP" : null
            )?.rate_data;
            const room = getHotelRate(roomData, loggedIn ? "SMOP" : null);
            const roomInfo = rate_data?.room_data;
            establishments[index] = {
              establishmentID: "",
              establishmentPricelineID: rate_data.id,
              ppn_bundle: rate_data.ppn_bundle,
              rate_tracking_id: rate_data.rate_tracking_id,
              hotel_zone: rate_data.neighborhood
                ? rate_data.neighborhood.name
                : rate_data.hotel_zone,
              neighborhood: rate_data.neighborhood
                ? rate_data.neighborhood
                : null,
              establishmentName: rate_data.name,
              propertyType: rate_data?.property_type_id,
              smopRate: roomRate === "SMOP" ? "SMOP" : null,
              roomInfo: roomInfo,
              resortFees: !resortDetails ? "resortFees" : null,
              establishmentDescription: rate_data.hotel_description,
              establishmentNeighborhood: rate_data.hotel_zone
                ? rate_data.hotel_zone
                : "",
              establishmentStarRating: rate_data.star_rating,
              establishmentReviewRating: rate_data.review_rating,
              //  "uri": "27657-The_Metropolitan_Museum_of_Art-New_York-USA",
              latitude: rate_data.geo.lat,
              longitude: rate_data.geo.lng,
              city_id: hotel_form_state.city_id,
              address_line_one: rate_data.address.address_line_one,
              establishmentCity: rate_data.address.city_name,
              establishmentState: rate_data.address.state_name,
              establishmentCountry: rate_data.address.country_name,
              establishmentCityCode: rate_data.address.city_code,
              establishmentStateCode: rate_data.address.state_code,
              establishmentCountryCode: rate_data.address.country_code,
              amenity_data: rate_data.amenity_data,
              display_price: room?.price_details.display_price,
              display_currency: room?.price_details.display_currency,
              display_symbol: room?.price_details.display_symbol,
              muverRate: getSmopRate(loggedIn ? roomData : null),
              estabPicture: {
                imageName: rate_data?.thumbnail_hq?.three_hundred_square,
                description: rate_data.name,
              },

              hotel_chain: {
                id:
                  rate_data.hotel_chain !== null
                    ? rate_data.hotel_chain.id
                    : null,
                name:
                  rate_data.hotel_chain !== null
                    ? rate_data.hotel_chain.name
                    : null,
              },
            };
          });

          // apply subtypes filter
          let filteredEstablishments = filterEstablishments(
            selectedSubtypes,
            establishments
          );

          // show first results

          dispatch({
            type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
            establishments: filteredEstablishments.slice(
              0,
              LAZYLOADING_HOTELS_INIT_LIMIT
            ), // just use 4 first
          });
          dispatch({
            type: SET_LOADER,
            payload: false,
          });

          dispatch({
            type: SET_FILTERED_ESTABLISHMENTS,
            filteredEstablishments: filteredEstablishments,
          });

          // do 2nd api call to get all results, no limit
          delete obj["proxyData[limit]"];

          PostAsyncHelper(api_url, obj).then((response) => {
            //console.log(response);
            if (response !== undefined && response.statusText === "OK") {
              // successful Post to api_url
              if (
                response.data.ProxyResult["getHotelExpress.Results"].results &&
                response.data.ProxyResult["getHotelExpress.Results"].results
                  .status !== "Success"
              ) {
                //throw Error(response.data.ProxyResult["getHotelExpress.Results"].error.status);
                dispatch({
                  type: PL_FETCH_HOTELS_LIST_FAILURE,
                  payload:
                    response.data.ProxyResult["getHotelExpress.Results"].error
                      .status,
                });
                dispatch({
                  type: FETCH_API_ERROR_HOTELS_LIST, //?
                  api_error: true,
                });
                dispatch({
                  type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
                  no_progress: true,
                });
              } else {
                // convert pl results into establishments

                const arry =
                  response.data.ProxyResult["getHotelExpress.Results"].results
                    .rate_data;
                console.log("arry ", arry);

                let establishments = [];
                let subtypes = [];
                let catSubTypes = [];
                let neighborhoodSubTypes = [];
                let hotel_chainSubTypes = [];
                let lowPrice = 999999;
                let highPrice = 0;
                let lowGuestScore = 999999;
                let highGuestScore = 0;
                let currencyLetters =
                  arry[0].room_data[0].price_details.display_currency;
                let currencySymbol =
                  arry[0].room_data[0].price_details.display_symbol;

                Object.values(arry).forEach((rate_data, index) => {
                  //    citiesArry.push(cities[key])
                  //console.log("xx", index, rate_data.id);
                  const roomPrice =
                    rate_data.room_data[0].price_details.display_price;
                  if (roomPrice > highPrice) highPrice = roomPrice;
                  if (roomPrice < lowPrice) lowPrice = roomPrice;

                  const guestScore = rate_data.review_rating;
                  if (guestScore > highGuestScore) highGuestScore = guestScore;
                  if (guestScore < lowGuestScore) lowGuestScore = guestScore;
                  const roomRate =
                    rate_data?.room_data && rate_data?.room_data?.length > 0
                      ? rate_data?.room_data[0]?.rate_data[0]?.rate_type
                      : null;
                  const resortDetails =
                    rate_data?.room_data && rate_data?.room_data?.length > 0
                      ? rate_data?.room_data[0]?.rate_data[0]?.price_details
                        ?.mandatory_fee_details?.display_total
                      : null;
                  const roomData = getRoomData(
                    rate_data?.room_data,
                    loggedIn ? "SMOP" : null
                  )?.rate_data;
                  const room = getHotelRate(roomData, loggedIn ? "SMOP" : null);

                  establishments[index] = {
                    establishmentID: "",
                    establishmentPricelineID: rate_data.id,
                    ppn_bundle: rate_data.ppn_bundle,
                    propertyType: rate_data?.property_type_id,
                    smopRate: roomRate === "SMOP" ? "SMOP" : null,
                    resortFees: !resortDetails ? "resortFees" : null,
                    rate_tracking_id: rate_data.rate_tracking_id,
                    hotel_zone: rate_data.neighborhood
                      ? rate_data.neighborhood.name
                      : rate_data.hotel_zone,
                    neighborhood: rate_data.neighborhood
                      ? rate_data.neighborhood
                      : null,
                    establishmentName: rate_data.name,
                    establishmentDescription: rate_data.hotel_description,
                    establishmentNeighborhood: rate_data.hotel_zone
                      ? rate_data.hotel_zone
                      : "",
                    establishmentStarRating: rate_data.star_rating,
                    establishmentReviewRating: rate_data.review_rating,
                    //  "uri": "27657-The_Metropolitan_Museum_of_Art-New_York-USA",
                    latitude: rate_data.geo.lat,
                    longitude: rate_data.geo.lng,
                    city_id: hotel_form_state.city_id,
                    address_line_one: rate_data.address.address_line_one,
                    establishmentCity: rate_data.address.city_name,
                    establishmentState: rate_data.address.state_name,
                    establishmentCountry: rate_data.address.country_name,
                    establishmentCityCode: rate_data.address.city_code,
                    establishmentStateCode: rate_data.address.state_code,
                    establishmentCountryCode: rate_data.address.country_code,
                    amenity_data: rate_data.amenity_data,
                    display_price: room?.price_details.display_price,
                    display_currency: room?.price_details.display_currency,
                    display_symbol: room?.price_details.display_symbol,
                    muverRate: getSmopRate(loggedIn ? roomData : null),
                    estabPicture: {
                      imageName: rate_data?.thumbnail_hq?.three_hundred_square,
                      description: rate_data.name,
                    },

                    hotel_chain: {
                      id:
                        rate_data.hotel_chain !== null
                          ? rate_data.hotel_chain.id
                          : null,
                      name:
                        rate_data.hotel_chain !== null
                          ? rate_data.hotel_chain.name
                          : null,
                    },
                  };

                  //console.log(rate_data.amenity_data);
                  rate_data.amenity_data.forEach((amenity, idx) => {
                    //console.log(idx);
                    catSubTypes.push({
                      title: amenity.name,
                      id: "a-" + amenity.id,
                      type: "amenity",
                    });
                  });

                  if (
                    rate_data?.neighborhood?.name !== undefined &&
                    rate_data?.neighborhood !== null
                  ) {
                    neighborhoodSubTypes.push({
                      title: rate_data?.neighborhood?.name,
                      id: "n-" + rate_data.neighborhood?.id,
                      type: "neighborhood",
                    });
                  }

                  if (
                    rate_data.hotel_chain !== undefined &&
                    rate_data.hotel_chain !== null
                  ) {
                    hotel_chainSubTypes.push({
                      title: rate_data.hotel_chain.name,
                      id: "b-" + rate_data.hotel_chain.id,
                      type: "hotel_chain",
                    });
                  }
                });

                // apply subtypes filter
                filteredEstablishments = filterEstablishments(
                  selectedSubtypes,
                  establishments
                );

                dispatch({
                  type: SET_FILTERED_ESTABLISHMENTS,
                  filteredEstablishments: filteredEstablishments,
                });
                dispatch({
                  type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
                  no_progress: true, // hide progress circle
                });

                // remove duplicates
                catSubTypes = removeDuplicateObjectFromArray(catSubTypes, "id");

                const catSubType = {
                  id: 1,
                  title: "Amenities",
                  subtypes: catSubTypes,
                };
                subtypes.push(catSubType);

                neighborhoodSubTypes = removeDuplicateObjectFromArray(
                  neighborhoodSubTypes,
                  "id"
                );

                ///sort neighborhoods
                if (neighborhoodSubTypes?.length > 0) {
                  neighborhoodSubTypes = neighborhoodSubTypes.sort(function (
                    a,
                    b
                  ) {
                    if (a?.title < b?.title) {
                      return -1;
                    }
                    if (a?.title > b?.title) {
                      return 1;
                    }
                    return 0;
                  });
                }

                const neighborhoodSubType = {
                  id: 2,
                  title: "Neighborhood",
                  subtypes: neighborhoodSubTypes,
                };

                subtypes.push(neighborhoodSubType);

                hotel_chainSubTypes = removeDuplicateObjectFromArray(
                  hotel_chainSubTypes,
                  "id"
                );

                const hotel_chainSubType = {
                  id: 3,
                  title: "Brands",
                  subtypes: hotel_chainSubTypes,
                };

                subtypes.push(hotel_chainSubType);

                dispatch({
                  type: FETCH_SUBTYPES_HOTELS_LIST,
                  subtypes: subtypes,
                  lowPrice: Math.floor(lowPrice),
                  highPrice: Math.ceil(highPrice),
                  lowGuestScore,
                  highGuestScore,
                  currencyLetters,
                  currencySymbol,
                  establishmentsToFilter: establishments,
                });

                let objLazy = Object.assign(obj, {
                  // "proxyData[limit]": lazyLoading.requests["proxyData[limit]"] + LAZYLOADING_HOTELS_INCREMENT})
                  "proxyData[limit]":
                    LAZYDISPLAY_INIT_LIMIT + LAZYDISPLAY_INCREMENT,
                });
                console.log("objLazy ", objLazy);

                dispatch({
                  type: UPDATE_LAZYLOADING_URL_REQUESTS_HOTELS_LIST,
                  api_url: api_url,
                  offset: LAZYDISPLAY_INIT_LIMIT + LAZYDISPLAY_INCREMENT,
                  requests: objLazy,
                });
                dispatch({
                  type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
                  no_more: false,
                });

                const mapHotels = getMapHotels(
                  establishments,
                  hotel_form_state
                );

                dispatch({
                  type: FETCH_PLACES_NEAR_BY_CENTER,
                  places_near_by_center: mapHotels,
                });
              }
            } else {
              // error Posting to api_url
              dispatch({
                type: PL_FETCH_HOTELS_LIST_FAILURE,
                payload: response.statusText,
              });
              dispatch({
                type: FETCH_API_ERROR_HOTELS_LIST, //?
                api_error: true,
              });
              dispatch({
                type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
                no_progress: true,
              });
            }
          });
        }
      } else {
        // error Posting to api_url
        dispatch({
          type: PL_FETCH_HOTELS_LIST_FAILURE,
          payload: response.statusText,
        });
        dispatch({
          type: FETCH_API_ERROR_HOTELS_LIST, //?
          api_error: true,
        });
        dispatch({
          type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
          no_progress: true,
        });
      }
    });
  };

// Sort Filtered hotels
export const sortHotelListings =
  (
    establishmentsToFilter,
    selectedOption,
    selectedSubtypes,
    hotel_form_state
  ) =>
    async (dispatch) => {
      //console.log("sortHotelListings", hotel_form_state, establishmentsToFilter);

      const sorting_titles = {
        gs: "Guest Score",
        lp: "Lowest Price",
        hp: "Highest Price",
        sr: "Rating",
        ds: "Distance",
      };

      dispatch({
        type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
        no_more: false,
      });

      dispatch({
        type: UPDATE_LAZYLOADING_SORT_BY,
        sortCode: selectedOption.code,
        sortTitle: sorting_titles[selectedOption.code],
      });

      // apply subtypes filter
      let filteredEstablishments = filterEstablishments(
        selectedSubtypes,
        establishmentsToFilter,
        selectedOption.code
      );

      dispatch({
        type: SET_FILTERED_ESTABLISHMENTS,
        filteredEstablishments: filteredEstablishments,
      });

      // dispatch establishments
      // dispatch({
      //   type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
      //   establishments: filteredEstablishments.slice(0, LAZYDISPLAY_INIT_LIMIT),
      // });
      dispatch({
        type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
        establishments: filteredEstablishments
      });
      dispatch({
        type: UPDATE_LAZYLOADING_OFFSET_HOTELS_LIST,
        offset: LAZYDISPLAY_INIT_LIMIT + LAZYDISPLAY_INCREMENT,
      });
      dispatch({
        type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
        no_progress: true,
      });
    };

/*  get establishments */
export const setLazyloadingIsHotelListings =
  (isFetching) => async (dispatch) => {
    console.log("setLazyloadingIsHotelListings isFetching ", isFetching);
    dispatch({
      type: UPDATE_LAZYLOADING_HOTELS_LIST,
      is_fetching: isFetching,
    });
  };
export const fetchHotelsLazyDisplay =
  (lazyLoading, filteredEstablishments) => async (dispatch) => {
    //console.log("fetchHotelsLazyDisplay", lazyLoading, filteredEstablishments);
    let no_limit = false;

    // if noMore == true
    if (!lazyLoading.noMore) {
      //no more true, no limit true
      let offset = lazyLoading.offset;
      let establishments =
        offset > LAZYDISPLAY_SHOW_ALL_AFTER
          ? filteredEstablishments
          : filteredEstablishments.slice(0, offset);

      dispatch({
        type: UPDATE_LAZYLOADING_OFFSET_HOTELS_LIST,
        offset: offset + LAZYDISPLAY_INCREMENT,
      });

      dispatch({
        type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
        establishments: establishments,
      });

      if (offset > LAZYDISPLAY_SHOW_ALL_AFTER) {
        dispatch({
          type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
          no_more: true,
        });
      }
    }
  };

export const fetchHotelsLazyloading =
  (lazyLoading, hotel_form_state) => async (dispatch) => {
    console.log("fetchHotelsLazyloading", lazyLoading);
    let no_limit = false;
    // todo - do this only once
    // if noMore == true
    const loggedIn = await isAuthenticated();
    if (!lazyLoading.noMore) {
      // if offset + increment > LAZYLOADING_HOTELS_LIMIT
      //no more true, no limit true
      if (lazyLoading.offset >= LAZYLOADING_HOTELS_MAX) {
        dispatch({
          type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
          no_more: true,
        });
      }

      // obj already set in lazyLoading.requests
      let obj = {
        "proxyData[format]": lazyLoading.requests["proxyData[format]"],
        "proxyData[check_in]": lazyLoading.requests["proxyData[check_in]"],
        "proxyData[check_out]": lazyLoading.requests["proxyData[check_out]"],
        "proxyData[rooms]": lazyLoading.requests["proxyData[rooms]"],
        "proxyData[adults]": lazyLoading.requests["proxyData[adults]"],
        "proxyData[city_id]": lazyLoading.requests["proxyData[city_id]"],
        "proxyData[limit]": lazyLoading.requests["proxyData[limit]"], // LAZYLOADING_ESTABLISHMENTS_LIMIT
        "proxyData[sort_by]": lazyLoading.requests["proxyData[sort_by]"], // guest score
        proxyApiMethod: "GET",
        proxyApiProperty: "hotel",
        proxyApiEndpoint: "getExpress.Results",
        //featureID: lazyLoading.requests.featureID,
        //typeID: lazyLoading.requests.typeID,
        //limit: LAZYLOADING_ESTABLISHMENTS_LIMIT,
        //offset: offset,
        //noMore: true,
        //subtype: lazyLoading.requests.subtype,
        //sortingOrder: lazyLoading.requests.sortingOrder,
        //sortingDirection: lazyLoading.requests.sortingDirection,
        //searchquery: lazyLoading.requests.searchquery,
      };
      let api_url = lazyLoading.url;

      dispatch({
        type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
        no_progress: false,
      });

      dispatch({
        type: UPDATE_LAZYLOADING_OFFSET_HOTELS_LIST,
        offset: lazyLoading.offset + LAZYLOADING_HOTELS_INCREMENT,
      });

      //  lazyLoading.requests.limit !== LAZYLOADING_ESTABLISHMENTS_LIMIT &&
      //      dispatch({
      //          type: UPDATE_LAZYLOADING_LIMIT_HOTELS_LIST,
      //          limit: LAZYLOADING_ESTABLISHMENTS_LIMIT,
      //      })

      // const onDownloadProgressConfig = (progressEvent) => {
      //     const percentage = Math.round(
      //         (progressEvent.loaded * 100) / progressEvent.total
      //     );
      //     dispatch({
      //         type: UPDATE_LAZYLOADING_PROGRESS_DESTINATION,
      //         progress: percentage,
      //     })
      // }
      PostAsyncHelper(api_url, obj).then((response) => {
        if (response !== undefined && response.statusText === "OK") {
          if (
            response.data.ProxyResult["getHotelExpress.Results"].results &&
            response.data.ProxyResult["getHotelExpress.Results"].results
              .status !== "Success"
          ) {
            //throw Error(response.data.ProxyResult["getHotelExpress.Results"].error.status);
            dispatch({
              type: PL_FETCH_HOTELS_LIST_FAILURE,
              payload:
                response.data.ProxyResult["getHotelExpress.Results"].error
                  .status,
            });
            dispatch({
              type: FETCH_API_ERROR_HOTELS_LIST, //?
              api_error: true,
            });
            dispatch({
              type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
              no_progress: true,
            });
          } else {
            // success in proxy results
            dispatch({
              type: PL_FETCH_HOTELS_LIST_SUCCESS,
              results:
                response.data.ProxyResult["getHotelExpress.Results"].results,
            });

            // convert pl results into establishments

            const arry =
              response.data.ProxyResult["getHotelExpress.Results"].results
                .rate_data;

            let establishments = [];
            Object.values(arry).forEach((rate_data, index) => {
              //    citiesArry.push(cities[key])
              console.log("xx", index, rate_data.id);
              const roomRate =
                rate_data?.room_data && rate_data?.room_data?.length > 0
                  ? rate_data?.room_data[0]?.rate_data[0]?.rate_type
                  : null;
              const resortDetails =
                rate_data?.room_data && rate_data?.room_data?.length > 0
                  ? rate_data?.room_data[0]?.rate_data[0]?.price_details
                    ?.mandatory_fee_details?.display_total
                  : null;
              const roomData = getRoomData(
                rate_data?.room_data,
                loggedIn ? "SMOP" : null
              )?.rate_data;
              const room = getHotelRate(roomData, loggedIn ? "SMOP" : null);

              establishments[index] = {
                establishmentID: "",
                establishmentPricelineID: rate_data.id,
                ppn_bundle: rate_data.ppn_bundle,
                rate_tracking_id: rate_data.rate_tracking_id,
                hotel_zone: rate_data.neighborhood
                  ? rate_data.neighborhood.name
                  : rate_data.hotel_zone,
                neighborhood: rate_data.neighborhood
                  ? rate_data.neighborhood
                  : null,
                establishmentName: rate_data.name,
                propertyType: rate_data?.property_type_id,
                smopRate: roomRate === "SMOP" ? "SMOP" : null,
                resortFees: !resortDetails ? "resortFees" : null,
                establishmentDescription: rate_data.hotel_description,
                establishmentNeighborhood: rate_data.hotel_zone
                  ? rate_data.hotel_zone
                  : "",
                establishmentStarRating: rate_data.star_rating,
                establishmentReviewRating: rate_data.review_rating,
                //  "uri": "27657-The_Metropolitan_Museum_of_Art-New_York-USA",
                latitude: rate_data.geo.lat,
                longitude: rate_data.geo.lng,
                city_id: lazyLoading.requests["proxyData[city_id]"],
                address_line_one: rate_data.address.address_line_one,
                establishmentCity: rate_data.address.city_name,
                establishmentState: rate_data.address.state_name,
                establishmentCountry: rate_data.address.country_name,
                establishmentCityCode: rate_data.address.city_code,
                establishmentStateCode: rate_data.address.state_code,
                establishmentCountryCode: rate_data.address.country_code,
                amenity_data: rate_data.amenity_data,
                display_price: room?.price_details.display_price,
                display_currency: room?.price_details.display_currency,
                display_symbol: room?.price_details.display_symbol,
                muverRate: getSmopRate(loggedIn ? roomData : null),
                estabPicture: {
                  imageName: rate_data?.thumbnail_hq?.three_hundred_square,
                  description: rate_data.name,
                },
              };
            });

            // dispatch establishments
            dispatch({
              type: SET_LOADER,
              payload: false,
            });
            dispatch({
              type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
              establishments: establishments,
            });
            dispatch({
              type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
              no_progress: true,
            });
            let offset = lazyLoading.offset + LAZYLOADING_HOTELS_INCREMENT;
            if (offset > LAZYLOADING_HOTELS_LIMIT) {
              offset = LAZYLOADING_HOTELS_MAX;
            }
            let objLazy = Object.assign(obj, {
              "proxyData[limit]": offset,
            });

            dispatch({
              type: UPDATE_LAZYLOADING_URL_REQUESTS_HOTELS_LIST,
              api_url: api_url,
              offset: offset,
              requests: objLazy,
            });
            dispatch({
              type: SET_FILTERED_ESTABLISHMENTS,
              filteredEstablishments: establishments,
            });

            const mapHotels = getMapHotels(establishments, hotel_form_state);

            dispatch({
              type: FETCH_PLACES_NEAR_BY_CENTER,
              places_near_by_center: mapHotels,
            });
          }

          dispatch({
            type: UPDATE_LAZYLOADING_HOTELS_LIST,
            is_fetching: false,
          });
          dispatch({
            type: SET_LOADER,
            payload: false,
          });
          dispatch({
            type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
            no_progress: true,
          });
        }
      });
    } else {
      dispatch({
        type: UPDATE_LAZYLOADING_HOTELS_LIST,
        is_fetching: false,
      });
      dispatch({
        type: SET_LOADER,
        payload: false,
      });
      dispatch({
        type: UPDATE_LAZYLOADING_NO_PROGRESS_HOTELS_LIST,
        no_progress: true,
      });
    }
  };

export const getHotelsNearbyMapCenter =
  (lat, lng, zoom, hotel_form_state) => async (dispatch) => {
    const loggedIn = await isAuthenticated();
    const obj_get_establishments = {
      latitude: lat,
      longitude: lng,
      zoom: zoom,
      limit: GET_ESTABLISHMENTS_NEAR_BY_MAP_CENTER,
    };

    let obj = {
      "proxyData[format]": "json2",
      "proxyData[latitude]": lat,
      "proxyData[longitude]": lng,
      "proxyData[radius]": GET_ESTABLISHMENTS_WITHIN, // 30 miles
      "proxyData[limit]": GET_ESTABLISHMENTS_NEAR_BY_MAP_CENTER,
      "proxyData[check_in]": hotel_form_state.check_in,
      "proxyData[check_out]": hotel_form_state.check_out,
      "proxyData[rooms]": hotel_form_state.rooms,
      "proxyData[adults]": hotel_form_state.adults,
      "proxyData[sort_by]": hotel_form_state.sort_by, // guest score
      proxyApiMethod: "GET",
      proxyApiProperty: "hotel",
      proxyApiEndpoint: "getExpress.Results",
    };
    let api_url = `${environment.apiUrl}proxy/dispatchRequest`;

    PostAsyncHelper(api_url, obj).then((response) => {
      //console.log(response);
      if (response !== undefined && response.statusText === "OK") {
        // successful Post to api_url
        if (
          response.data.ProxyResult["getHotelExpress.Results"].results &&
          response.data.ProxyResult["getHotelExpress.Results"].results
            .status !== "Success"
        ) {
          //throw Error(response.data.ProxyResult["getHotelExpress.Results"].error.status);
          dispatch({
            type: PL_FETCH_HOTELS_LIST_FAILURE,
            payload:
              response.data.ProxyResult["getHotelExpress.Results"].error.status,
          });
        } else {
          // success in proxy results
          dispatch({
            type: PL_FETCH_HOTELS_LIST_SUCCESS,
            results:
              response.data.ProxyResult["getHotelExpress.Results"].results,
          });

          // convert pl results into establishments

          const arry =
            response.data.ProxyResult["getHotelExpress.Results"].results
              .rate_data;
          //console.log("arry ", arry);

          let establishments = [];
          console.log(arry);
          Object.values(arry).forEach((rate_data, index) => {
            //console.log(rate_data, index);
            const roomData = rate_data?.room_data[0]?.rate_data;

            const room = getHotelRate(roomData, loggedIn ? "SMOP" : null);

            establishments[index] = {
              establishmentID: "",
              establishmentPricelineID: rate_data.id,
              ppn_bundle: rate_data.ppn_bundle,
              hotel_zone: rate_data.neighborhood
                ? rate_data.neighborhood.name
                : rate_data.hotel_zone,
              neighborhood: rate_data.neighborhood
                ? rate_data.neighborhood
                : null,
              establishmentName: rate_data.name,
              establishmentDescription: rate_data.hotel_description,
              establishmentNeighborhood: rate_data.hotel_zone
                ? rate_data.hotel_zone
                : "",
              establishmentStarRating: rate_data.star_rating,
              establishmentReviewRating: rate_data.review_rating,
              //  "uri": "27657-The_Metropolitan_Museum_of_Art-New_York-USA",
              latitude: rate_data.geo.lat,
              longitude: rate_data.geo.lng,
              city_id: hotel_form_state.city_id,

              address_line_one: rate_data.address.address_line_one,
              establishmentCity: rate_data.address.city_name,
              establishmentState: rate_data.address.state_name,
              establishmentCountry: rate_data.address.country_name,
              establishmentCityCode: rate_data.address.city_code,
              establishmentStateCode: rate_data.address.state_code,
              establishmentCountryCode: rate_data.address.country_code,
              amenity_data: rate_data.amenity_data,
              display_price: room?.price_details.display_price,
              display_currency: room?.price_details.display_currency,
              display_symbol: room?.price_details.display_symbol,

              estabPicture: {
                //    "bucketName": "muvimages",
                //    "folderName": "establishments",
                imageName: rate_data?.thumbnail_hq?.three_hundred_square,
                description: rate_data.name,
              },
            };
          });

          // dispatch establishments
          dispatch({
            type: CONVERT_HOTELS_TO_ESTABLISHMENTS,
            establishments: establishments.slice(0, LAZYDISPLAY_INIT_LIMIT),
          });

          dispatch({
            type: SET_FILTERED_ESTABLISHMENTS,
            filteredEstablishments: establishments,
          });
          dispatch({
            type: UPDATE_LAZYLOADING_OFFSET_HOTELS_LIST,
            offset: LAZYDISPLAY_INIT_LIMIT + LAZYDISPLAY_INCREMENT,
          });
          dispatch({
            type: UPDATE_LAZYLOADING_NO_MORE_HOTELS,
            no_more: false,
          });

          const mapHotels = getMapHotels(establishments, hotel_form_state);

          dispatch({
            type: FETCH_PLACES_NEAR_BY_CENTER,
            places_near_by_center: mapHotels,
          });
        }
      } else {
        // error Posting to api_url
        dispatch({
          type: PL_FETCH_HOTELS_LIST_FAILURE,
          payload: response.statusText,
        });
        dispatch({
          type: FETCH_API_ERROR_HOTELS_LIST, //?
          api_error: true,
        });
      }
    });
  };

export const setHotelSearchState = (hotel_form_state) => (dispatch) => {
  dispatch({
    type: SET_HOTEL_FORM_STATE,
    hotel_form_state: hotel_form_state,
  });
};

export const setHotelBookingState = (booking_form_state) => (dispatch) => {
  dispatch({
    type: SET_BOOKING_FORM_STATE,
    booking_form_state: booking_form_state,
  });
};

export const removeBundleFromHotelBooking =
  (idx, ppn_bundles) => (dispatch) => {
    dispatch({
      type: REMOVE_BUNDLE_TO_HOTEL_BOOKING,
      booking_bundles: ppn_bundles,
    });
  };

export const fetchHotelEstablishment =
  (hotel_id, ppn_bundle, hotel_form_state) => async (dispatch) => {
    try {
      //const endpoint = "getHotelExpress.Results";     // getHotelDetails
      const endpoint = "getHotelDetails"; // getHotelDetails

      let obj = {
        "proxyData[format]": "json2",
        "proxyData[hotel_id]": hotel_id,
        "proxyData[ppn_bundle]": ppn_bundle,
        "proxyData[photos]": true,
        "proxyData[reviews]": true,
        "proxyData[guest_score_breakdown]": true,
        "proxyData[nearby]": true,
        "proxyData[check_in]": hotel_form_state.check_in,
        "proxyData[check_out]": hotel_form_state.check_out,
        "proxyData[rooms]": hotel_form_state.rooms,
        "proxyData[adults]": hotel_form_state.adults,
        "proxyData[id_lookup]": "true",
        "proxyData[image_size]": "large",
        "proxyData[important_info]": "true",
        proxyApiMethod: "GET",
        proxyApiProperty: "hotel",
        proxyApiEndpoint: endpoint,
      };
      let api_url = `${environment.apiUrl}proxy/dispatchRequest`;
      PostAsyncHelper(api_url, obj).then((response) => {
        //console.log(response);
        if (response !== undefined && response.statusText === "OK") {
          // successful Post to api_url

          const results =
            response.data.ProxyResult["getHotelHotelDetails"]?.results;
          if ((results && results.status !== "Success") || !results) {
            dispatch({
              type: SET_LOADER,
              payload: false,
            });
            // throw Error(response.data.ProxyResult[endpoint].error.status);
          } else {
            const hotel_data = results.hotel_data[0]; // getHotelDetails
            //const hotel_data = results.hotel_data.hotel_0       // getHotelExpress.Results

            let general_info = {
              establishmentID: "",
              establishmentPricelineID: hotel_data.id,
              booking_dot_com_id: hotel_data.id_b,
              ppn_bundle,
              neighborhood: hotel_data.neighborhood
                ? hotel_data.neighborhood.name
                : "",
              name: hotel_data.name,
              about: hotel_data.hotel_description,
              establishmentStarRating: hotel_data.star_rating,
              check_in_time: hotel_data.check_in_time,
              check_out_time: hotel_data.check_out_time,
              //  uri: "1501-1_Hotel_Central_Park-New_York-USA",
              address: hotel_data.address.address_line_one,
              //phone: null,
              postalCode: hotel_data.address.zip,
              //email: null,
              latitude: hotel_data.geo.latitude,
              longitude: hotel_data.geo.longitude,
              cityName: hotel_data.address.city_name,
              stateName: hotel_data.address.state_name,
              countryName: hotel_data.address.country_name,

              about: hotel_data.hotel_description,
              city_id: hotel_data?.city?.id || hotel_data.city_id,
              stateCode: hotel_data.address.state_code,
              countryCode: hotel_data.address.country_code,
              //    "website": hotel_data.,
              reviewsAverage: hotel_data.review_rating,
              reviewsDescription: hotel_data.review_rating_desc,
              star_rating: hotel_data.star_rating,
              rating_count: hotel_data.rating_count,
              review_count: hotel_data.review_count,

              amenities: hotel_data.amenity_data,
              guest_score_categories: hotel_data.guest_score_categories,
              //    experiences: hotel_data.,
              //    menu: hotel_data.,
              //    selectedMenu: hotel_data.,
              //    error: hotel_data.error,
              estabPicture: {
                //    "bucketName": "muvimages",
                //    "folderName": "establishments",
                imageName:
                  hotel_data?.thumbnail_hq?.three_hundred_square ||
                  hotel_data?.thumbnail,
                description: hotel_data?.name,
              },
            };
            // success in proxy results
            setHotelEstablishmentId(hotel_data.id);

            dispatch({
              type: FETCH_GENERAL_INFO_HOTEL_ESTABLISHMENT,
              general_info: general_info,
            });

            dispatch({
              type: SET_LOADER,
              payload: false,
            });

            // convert pl results into establishments

            const arry = hotel_data.photo_data;
            //console.log("arry ", arry);

            let sliderImages = [];
            arry.forEach((photo_url, index) => {
              //console.log(photo_url, index);

              sliderImages.push({
                imageName: photo_url,
                description: hotel_data.name,
              });
            });

            dispatch({
              type: FETCH_SLIDER_IMAGES_HOTEL_ESTABLISHMENT,
              slider_images: sliderImages,
              sliderIndex: 0,
            });

            const objs = hotel_data.review_data;
            //console.log("objs ", objs);

            let reviewsPriceline = null;
            if (objs) {
              reviewsPriceline = {};
              Object.values(objs).forEach((review_data, index) => {
                //console.log(review_data, index);

                reviewsPriceline = {
                  ...reviewsPriceline,
                  ["priceline_review_" + (index + 1) + "_rating"]:
                    Number(review_data.average_rating) / 2,
                  ["priceline_review_" + (index + 1) + "_text"]:
                    review_data.good_description, //bad_description
                  ["priceline_review_" + (index + 1) + "_user"]:
                    review_data.user_name,
                  ["priceline_review_" + (index + 1) + "_date"]:
                    review_data.creation_date,
                };
              });
              reviewsPriceline = [reviewsPriceline];
            }

            dispatch({
              type: FETCH_REVIEWS_HOTEL_ESTABLISHMENT,
              reviewsAverage: hotel_data.review_rating,
              review_rating_desc: hotel_data.review_rating_desc,
              reviewsPriceline: reviewsPriceline,
            });
          }
        } else {
          // error Posting to api_url
          dispatch({
            type: FETCH_GENERAL_INFO_HOTEL_ESTABLISHMENT_FAILURE,
            payload: response.statusText,
          });
        }
      });

      /*

        const feature = {
            featureId: "1",
            slug: "places",
            title: "Places",
            color: "#19BC9B",
            disable: "0",
        }
        dispatch({
            type: SET_FEATURE_FORMAT,
            featureSelected: feature
        })
        const response = await Axios.get('https://devapi.muvtravel.com/api/public/establishment/main/' + lang + '/' + id)
        if (response.statusText !== "OK") {
            throw Error(response.statusText);
        }
        dispatch({
            type: FETCH_GENERAL_INFO_ESTABLISHMENT,
            general_info: response.data.generalInfo,
        })
        dispatch({
            type: SET_LOADER,
            payload: false
        })
        let obj_reviews = {
            featureId: features_router.places.featureId,
            featureTypeId: response.data.generalInfo.typeId,
            featureUnitId: id,
        }

    
        const api_url_reviews = "https://devapi.muvtravel.com/api/public/simpleRating/getMuvReviewsAndRatingsforFeatureUnit/en?featureId=" + obj_reviews.featureId + "&featureUnitId=" + obj_reviews.featureUnitId
        GetAsyncHelper(api_url_reviews)
            .then(responseBucketlistReviews => {
                if (responseBucketlistReviews !== undefined && responseBucketlistReviews.statusText === "OK") {
                    dispatch({
                        type: FETCH_REVIEWS_ESTABLISHMENT,
                        reviews: responseBucketlistReviews.data.result,
                    })
                } else {
                    dispatch({
                        type: FETCH_API_ERROR_ESTABLISHMENT,
                        api_error: true
                    })
                    dispatch({
                        type: FETCH_REVIEWS_ESTABLISHMENT,
                        reviews: null,
                    })
                }
            })

        */
    } catch (error) {
      dispatch({
        type: FETCH_GENERAL_INFO_HOTEL_ESTABLISHMENT_FAILURE,
        api_error: error.text,
      });
    }
  };

const GetHotelReviews = (hotel_id, dispatch) => { };

export const fetchHotelRooms =
  (hotel_id, ppn_bundle, hotel_form_state, currency) => async (dispatch) => {
    try {
      const endpoint = "getExpress.MultiContract";
      //const endpoint = "getHotelDetails";     // getHotelDetails
      let obj = {
        "proxyData[format]": "json2",
        //"proxyData[city_id]": hotel_form_state.city_id,
        "proxyData[hotel_id]": hotel_id,
        "proxyData[ppn_bundle]": ppn_bundle,
        "proxyData[check_in]": hotel_form_state.check_in,
        "proxyData[check_out]": hotel_form_state.check_out,
        "proxyData[rooms]": hotel_form_state.rooms,
        "proxyData[output_version]": 4,
        "proxyData[currency]": currency,
        "proxyData[rate_identifier]": 1,
        "proxyData[adults]": hotel_form_state.adults,
        proxyApiMethod: "GET",
        proxyApiProperty: "hotel",
        proxyApiEndpoint: endpoint,
      };
      let api_url = `${environment.apiUrl}proxy/dispatchRequest`;

      PostAsyncHelper(api_url, obj).then((response) => {
        //console.log(response);
        if (response !== undefined && response.statusText === "OK") {
          // successful Post to api_url
          const results =
            response.data.ProxyResult["getHotelExpress.MultiContract"]?.results;

          //if (results && results.status !== "Success") {
          if (!results) {
            if (
              response.data.ProxyResult["getHotelExpress.MultiContract"]?.error
                ?.status == "Hotel.Express.Contract: Rates not found"
            ) {
              // set found to []
              dispatch({
                type: FETCH_GENERAL_INFO_ROOMS,
                room_data: [],
                amenity_data: [],
                allowed_cards_data: [],
              });
            } else {
              // throw Error(response.data.ProxyResult["getHotelExpress.MultiContract"].error.status)
            }
          }
          // if status: "Hotel.Express.Results: All enabled inventories returned without rates"
          else {
            let hotel_data = results?.hotel_data[0]; // getHotelExpress.MultiContract
            const amenity_data = results.hotel_data[0]?.amenity_data; // getHotelExpress.MultiContract
            //const room_data = results.hotel_data.hotel_0.room_data       // getHotelExpress.Results
            // ProxyResult["getHotelExpress.Results"].results.rate_data[0].room_data[0].description
            //data.ProxyResult["getHotelExpress.Results"].results.rate_data[0].room_data[0].available_rooms

            const sorted = hotel_data?.room_data?.sort((a, b) =>
              a.room_id < b.room_id ? 1 : -1
            );
            hotel_data["room_data"] = sorted;
            const allowed_cards_data = results.allowed_cards_data;

            // getHotelDetails
            //const hotel_data = results.hotel_data.hotel_0       // getHotelExpress.Results

            let general_info = {
              establishmentID: "",
              establishmentPricelineID: hotel_data.id,
              booking_dot_com_id: hotel_data.id_b,
              ppn_bundle,
              neighborhood: hotel_data.neighborhood
                ? hotel_data.neighborhood.name
                : "",
              name: hotel_data.name,
              about: hotel_data.hotel_description,
              establishmentStarRating: hotel_data.star_rating,
              check_in_time: hotel_data.check_in_time,
              check_out_time: hotel_data.check_out_time,
              //  uri: "1501-1_Hotel_Central_Park-New_York-USA",
              address: hotel_data.address.address_line_one,
              //phone: null,
              postalCode: hotel_data.address.zip,
              //email: null,
              latitude: hotel_data.geo.latitude,
              longitude: hotel_data.geo.longitude,
              cityName: hotel_data.address.city_name,
              stateName: hotel_data.address.state_name,
              countryName: hotel_data.address.country_name,

              about: hotel_data.hotel_description,
              city_id: hotel_data.city_id,
              stateCode: hotel_data.address.state_code,
              countryCode: hotel_data.address.country_code,
              //    "website": hotel_data.,
              reviewsAverage: hotel_data.review_rating,
              reviewsDescription: hotel_data.review_rating_desc,
              star_rating: hotel_data.star_rating,
              rating_count: hotel_data.rating_count,
              review_count: hotel_data.review_count,

              amenities: hotel_data.amenity_data,
              guest_score_categories: hotel_data.guest_score_categories,
              //    experiences: hotel_data.,
              //    menu: hotel_data.,
              //    selectedMenu: hotel_data.,
              //    error: hotel_data.error,
              estabPicture: {
                //    "bucketName": "muvimages",
                //    "folderName": "establishments",
                imageName:
                  hotel_data?.thumbnail_hq?.three_hundred_square ||
                  hotel_data?.thumbnail,
                description: hotel_data?.name,
              },
            };
            // success in proxy results
            setHotelEstablishmentId(hotel_data.id);

            dispatch({
              type: FETCH_GENERAL_INFO_HOTEL_ESTABLISHMENT,
              general_info: general_info,
            });

            dispatch({
              type: SET_LOADER,
              payload: false,
            });

            // convert pl results into establishments

            const arry = hotel_data.photo_data;
            //console.log("arry ", arry);

            let sliderImages = [];
            arry.forEach((photo_url, index) => {
              sliderImages.push({
                imageName: photo_url,
                description: hotel_data.name,
              });
            });

            dispatch({
              type: FETCH_SLIDER_IMAGES_HOTEL_ESTABLISHMENT,
              slider_images: sliderImages,
              sliderIndex: 0,
            });

            dispatch({
              type: FETCH_GENERAL_INFO_ROOMS,
              room_data: hotel_data,
              amenity_data,
              allowed_cards_data,
            });
            // getHotelExpress.MultiContract
            //const room_data = results.hotel_data.hotel_0.room_data       // getHotelExpress.Results
            // ProxyResult["getHotelExpress.Results"].results.rate_data[0].room_data[0].description
            //data.ProxyResult["getHotelExpress.Results"].results.rate_data[0].room_data[0].available_rooms

            //      dispatch({
            //          type: FETCH_GENERAL_INFO_ROOMS,
            //          room_data: room_data,
            //      })
          }
        } else {
          // error Posting to api_url
          dispatch({
            type: FETCH_GENERAL_INFO_ROOMS_FAILURE,
            payload: response.statusText,
          });
        }
      });
    } catch (error) {
      dispatch({
        type: FETCH_GENERAL_INFO_ROOMS_FAILURE,
        payload: error.text,
      });
    }
  };

export const fetchMuvHotelPhotos =
  (hotel_id, findBy = "pl") => async (dispatch) => {
    try {

      const url = `${environment.apiUrl}muv-meta-engine/hotels/muvMetaHotelPhotos?`;
      const body = {
        findBy: findBy, //or hp
        id: hotel_id
      };
      const urlParams = new URLSearchParams(body).toString();


      const response = await PostAsyncHelper(url + urlParams);
      return response?.data?.result
    }
    catch {

    }
  }

export const addToShoppingCart =
  (uuid) => async (dispatch) => {
    try {

      const url = `${environment.apiUrl}muv-meta-engine/cart/createCart?`;
      const body = {
        uuid: uuid,
      };
      const urlParams = new URLSearchParams(body).toString();


      const response = await PostAsyncHelper(url + urlParams);
      return response?.data?.result
    }
    catch {

    }
  }

export const addHotelItemToCart =
  (query) => async (dispatch) => {
    try {

      const url = `${environment.apiUrl}muv-meta-engine/cart/addHotelItemToCart`;
      const body = query;


      const response = await PostAsyncHelper(url, query);
      return response?.data?.result
    }
    catch {

    }
  }


export const fetchMuvRoomsLight =
  (data, findBy = "pl") => async (dispatch) => {
    try {

      const url = `${environment.apiUrl}muv-meta-engine/hotels/muvMetaHotelRoomsLight?`;
      const body = data;
      const urlParams = new URLSearchParams(body).toString();


      const response = await PostAsyncHelper(url + urlParams);

      return response?.data?.result
    }
    catch {

    }
  }

export const fetchMuvRooms =
  (data, findBy = "pl") => async (dispatch) => {
    try {

      const url = `${environment.apiUrl}muv-meta-engine/hotels/muvMetaHotelRooms?`;
      const body = data;
      const urlParams = new URLSearchParams(body).toString();


      const response = await PostAsyncHelper(url + urlParams);

      return response?.data?.result
    }
    catch {

    }
  }

export const fetchHPHotelRooms =
  (hotel_id, findBy = "pl") => async (dispatch) => {
    try {

      const url = `${environment.apiUrl}muv-meta-engine/hotels/MuvMetaHotelDetails?`;
      const body = {
        id: hotel_id
      };
      const urlParams = new URLSearchParams(body).toString();


      PostAsyncHelper(url + urlParams).then((response) => {
        //console.log(response);

        if (response !== undefined && response.statusText === "OK") {
          // successful Post to api_url
          const results = response?.data?.result



          if (!results) {
            dispatch({
              type: FETCH_GENERAL_INFO_ROOMS,
              room_data: [],
              amenity_data: [],
              allowed_cards_data: [],
            });
          }
          else {
            let hotel_data = results?.hotel_data[0]; // getHotelExpress.MultiContract
            const amenity_data = results.hotel_data[0]?.amenity_data; // getHotelExpress.MultiContract
            const sorted = hotel_data?.room_data?.sort((a, b) =>
              a.room_id < b.room_id ? 1 : -1
            );
            hotel_data["room_data"] = sorted;
            const allowed_cards_data = results.allowed_cards_data;
            let general_info = {
              establishmentID: "",
              establishmentPricelineID: hotel_data.id || hotel_data?.hotelid_ppn,
              establishmentHPID: hotel_data?.hotelplanner_id,
              booking_dot_com_id: hotel_data.id_b,
              neighborhood: hotel_data.neighborhood
                ? hotel_data.neighborhood.name
                : "",
              name: hotel_data.name || hotel_data?.property_name,
              about: hotel_data.hotel_description,
              establishmentStarRating: hotel_data.star_rating,
              check_in_time: hotel_data.check_in_time,
              check_out_time: hotel_data.check_out_time,
              address: hotel_data.address.address_line_one,
              postalCode: hotel_data.address.zip,
              latitude: hotel_data.geo.latitude,
              longitude: hotel_data.geo.longitude,
              cityName: hotel_data.address.city_name,
              stateName: hotel_data.address.state_name,
              countryName: hotel_data.address.country_name,
              about: hotel_data.hotel_description,
              city_id: hotel_data.city_id,
              stateCode: hotel_data.address.state_code,
              countryCode: hotel_data.address.country_code,
              reviewsAverage: hotel_data.review_rating,
              reviewsDescription: hotel_data.review_rating_desc,
              star_rating: hotel_data.star_rating,
              rating_count: hotel_data.rating_count,
              review_count: hotel_data.review_count,
              amenities: hotel_data.amenity_data,
              guest_score_categories: hotel_data.guest_score_categories,
              estabPicture: {
                imageName:
                  hotel_data?.thumbnail_hq?.three_hundred_square ||
                  hotel_data?.thumbnail,
                description: hotel_data?.name,
              },
              hotel_data: hotel_data,
              ...hotel_data?.city?.MuvMetaCity
            };

            if (hotel_data?.city?.MuvMetaCity) {
              general_info['city'] = hotel_data?.city?.MuvMetaCity;
              general_info['country_code'] = hotel_data?.city?.MuvMetaCity?.country;
            }

            setHotelEstablishmentId(hotel_data.id);

            dispatch({
              type: FETCH_GENERAL_INFO_HOTEL_ESTABLISHMENT,
              general_info: general_info,
            });

            dispatch({
              type: SET_LOADER,
              payload: false,
            });



            const arry = hotel_data.photo_data;


            let sliderImages = [];
            arry.forEach((photo_url, index) => {
              sliderImages.push({
                imageName: photo_url,
                description: hotel_data.name,
              });
            });

            dispatch({
              type: FETCH_SLIDER_IMAGES_HOTEL_ESTABLISHMENT,
              slider_images: sliderImages,
              sliderIndex: 0,
            });

            dispatch({
              type: FETCH_GENERAL_INFO_ROOMS,
              room_data: hotel_data,
              amenity_data,
              allowed_cards_data,
            });

          }
        } else {
          dispatch({
            type: FETCH_GENERAL_INFO_ROOMS_FAILURE,
            payload: response.statusText,
          });
        }
      });
    } catch (error) {
      dispatch({
        type: FETCH_GENERAL_INFO_ROOMS_FAILURE,
        payload: error.text,
      });
    }
  };

export const setSliderIndex = (index) => async (dispatch) => {
  dispatch({
    type: SET_SLIDER_INDEX,
    sliderIndex: index,
  });
};

export const fetchTimeToReachOptions =
  (lang, uuid, activityID) => async (dispatch) => {
    if (uuid !== "") {
      let api_url =
        environment.apiUrl +
        "timeline/getActivityTimeToReachOptions/" +
        lang +
        "/" +
        uuid +
        "?activityId=" +
        activityID;
      GetAsyncHelper(api_url).then((response) => {
        if (response !== undefined && response.statusText === "OK") {
          const results = response.data.result;
          if (results) {
            dispatch({
              type: FETCH_TIME_TO_REACH_OPTIONS,
              timeToReachOptionsSet: results,
            });
          }
        } else {
          dispatch({
            type: FETCH_TIME_TO_REACH_OPTIONS,
            timeToReachOptionsSet: [],
          });
        }
      });
    }
  };

export const fetchTransportModes =
  (uuid, tripId, destinationId = "") =>
    async (dispatch) => {
      if (uuid !== "") {
        let api_url =
          environment.apiUrl +
          "transitOtions/getTransitOptionsForTrip/" +
          uuid +
          "?tripId=" +
          tripId +
          "&tripDestinationId=" +
          destinationId;
        GetAsyncHelper(api_url).then((response) => {
          if (response !== undefined && response.statusText === "OK") {
            const results = response.data.result;
            if (results) {
              dispatch({
                type: FETCH_TRANSPORT_MODES,
                transportModes: results,
              });
            }
          } else {
            dispatch({
              type: FETCH_TRANSPORT_MODES,
              transportModes: [],
            });
          }
        });
      }
    };

export const setTransportMode =
  (uuid, tripDestinationId, data) => async (dispatch) => {
    if (uuid !== "") {
      let obj = {
        uuid: uuid,
        transportMod: {
          code: data?.code,
          cost: data?.cost,
          currency: data?.currency,
          duration: data?.duration,
          full_json: data?.full_json,
        },
        tripDestinationId: tripDestinationId,
      };
      let api_url =
        environment.apiUrl +
        "memberarea/trip/setTripDestinationTransportMod/en/" +
        uuid;

      PostAsyncHelper(api_url, obj).then((response) => {
        if (response && response.statusText === "OK") {
          const result = response.data.result;
          if (result) {
            const tripId = result?.trip_id;
            dispatch(setTripToTimeline(tripId, uuid));
            dispatch({
              type: ALERT_BARS_HANDLE,
              message_type: "success",
              message: "Transportation Updated!",
            });
          }
        }
      });
    }
  };

export const setTimeToReachOptions =
  (lang, uuid, activityID, timeToReach, tripId) => async (dispatch) => {
    if (uuid !== "") {
      let obj = {
        lang: lang,
        uuid: uuid,
        activityId: activityID,
        timeToReach: timeToReach,
      };
      let api_url =
        environment.apiUrl +
        "timeline/setActivityTimeToReach/" +
        lang +
        "/" +
        uuid;

      PostAsyncHelper(api_url, obj).then((response) => {
        if (response && response.statusText === "OK") {
          const results = response.data.result;
          if (results) {
            const fetch_active_trip_activities_api_url =
              environment.apiUrl +
              "timeline/getTripActivities/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripActivities";

            GetAsyncHelper(fetch_active_trip_activities_api_url).then(
              (responseTripActivities) => {
                if (responseTripActivities.statusText === "OK") {
                  dispatch({
                    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                    activities: responseTripActivities.data.result,
                  });
                  dispatch({
                    type: ALERT_BARS_HANDLE,
                    message_type: "success",
                    message: "saved",
                  });
                } else {
                }
              }
            );
          }
        }
      });
    }
  };

export const setHotelEstablishmentId = (id) => (dispatch) => {
  dispatch({
    type: SET_HOTEL_ESTABLISHMENT_ID_ESTABLISHMENT,
    active_id: id,
  });
};

export const fetchHotelBooking =
  ({ hotel_id, ppn_book_bundles, check_in, check_out, rooms, adults }) =>
    async (dispatch) => {
      try {
        // for each bundle, getExpress.Contract
        ppn_book_bundles.forEach((ppn_book_bundle, bidx) => {
          const endpoint = "getExpress.Contract"; // getHotelDetails
          //const endpoint = "getHotelDetails";     // getHotelDetails

          let obj = {
            "proxyData[format]": "json2",
            "proxyData[hotel_id]": hotel_id,
            "proxyData[ppn_bundle]": ppn_book_bundle,
            "proxyData[check_in]": check_in,
            "proxyData[check_out]": check_out,
            "proxyData[rooms]": rooms,
            "proxyData[adults]": adults,
            proxyApiMethod: "GET",
            proxyApiProperty: "hotel",
            proxyApiEndpoint: endpoint,
          };
          let api_url = `${environment.apiUrl}proxy/dispatchRequest`;

          PostAsyncHelper(api_url, obj).then((response) => {
            //console.log(response);
            if (response !== undefined && response.statusText === "OK") {
              // successful Post to api_url
              const results =
                response.data.ProxyResult["getHotelExpress.Contract"]?.results;
              if (results && results.status !== "Success") {
                throw Error(
                  response.data.ProxyResult["getHotelExpress.Contract"].error
                    .status
                );
              } else {
                //const hotel_data = results.hotel_data[0]               // getHotelDetails
                const hotel_data = results?.hotel_data; // getHotelExpress.Results
                const input_data = results?.input_data;
                const bundle_data = results?.bundle_data;

                const booking_bundles = {
                  ppn_book_bundle: bundle_data.ppn_book_bundle,
                  check_in: bundle_data.check_in,
                  check_out: bundle_data.check_out,
                  rate_currency: bundle_data.rate_currency,
                  rate_symbol: results.room_data.price_details.display_symbol,
                  rate_avg: bundle_data.rate_avg,
                  rate_processing_fee: bundle_data.rate_processing_fee,
                  rate_fee: bundle_data.rate_fee,
                  rate_total: bundle_data.rate_total,
                  room_text: bundle_data.room_text,
                  room_id: bundle_data.room_id,
                  pcln_id: bundle_data.pcln_id,
                };

                let booking_info = {
                  establishmentID: "",
                  establishmentPricelineID: hotel_data.id,
                  booking_dot_com_id: hotel_data.id_b,
                  hotel_id: hotel_data.id,
                  name: hotel_data.hotel_name,
                  establishmentStarRating: hotel_data.star_rating,
                  address: hotel_data.address.address_line_one,
                  //phone: null,
                  postalCode: hotel_data.address.zip,
                  //email: null,
                  //latitude: hotel_data.geo.latitude,
                  //longitude: hotel_data.geo.longitude,
                  cityName: hotel_data.address.city_name,
                  stateName: hotel_data.address.state_name,
                  countryName: hotel_data.address.country_name,
                  city_id: hotel_data.city_id,
                  stateCode: hotel_data.address.state_code,
                  countryCode: hotel_data.address.country_code,
                  reviewsAverage: hotel_data.review_rating,
                  reviewsDescription: hotel_data.review_rating_desc,
                  star_rating: hotel_data.star_rating,
                  rating_count: hotel_data.rating_count,
                  review_count: hotel_data.review_count,

                  num_rooms: input_data.num_rooms,
                  num_adults: input_data.num_adults,
                  num_children: input_data.num_children,
                  num_nights: input_data.num_nights,

                  estabPicture: {
                    imageName: hotel_data.thumbnail,
                    description: hotel_data.name,
                  },
                };

                // success in proxy results
                setHotelEstablishmentId(hotel_data.id);

                dispatch({
                  type: FETCH_CONTRACT_INFO_HOTEL_BOOKING,
                  booking_info: booking_info,
                });

                dispatch({
                  type: SET_LOADER,
                  payload: false,
                });

                // convert pl results into establishments
              }
            } else {
              // error Posting to api_url
              dispatch({
                type: FETCH_CONTRACT_INFO_HOTEL_BOOKING_FAILURE,
                payload: response.statusText,
              });
            }
          });
        });
      } catch (error) {
        dispatch({
          type: FETCH_CONTRACT_INFO_HOTEL_BOOKING_FAILURE,
          api_error: error.text,
        });
      }
    };

export const clearHotelBooking = () => async (dispatch) => {
  dispatch({
    type: REMOVE_BUNDLE_TO_HOTEL_BOOKING,
    booking_bundles: [],
  });
};

export const batchAddBundleToHotelBooking =
  ({
    hotel_id,
    ppn_book_bundle,
    check_in,
    check_out,
    rooms,
    adults,
    booking_bundles,
  }) =>
    async (dispatch) => {
      try {
        const endpoint = "getExpress.Contract"; // getHotelDetails
        //const endpoint = "getHotelDetails";     // getHotelDetails
        let ppn_bundles = [];
        let booking_info;
        if (booking_bundles && booking_bundles?.length > 0) {
          booking_bundles.forEach((bundle) => {
            let obj = {
              "proxyData[format]": "json2",
              "proxyData[hotel_id]": hotel_id,
              "proxyData[ppn_bundle]": bundle,
              "proxyData[check_in]": check_in,
              "proxyData[check_out]": check_out,
              "proxyData[rooms]": rooms,
              "proxyData[adults]": adults,
              proxyApiMethod: "GET",
              proxyApiProperty: "hotel",
              proxyApiEndpoint: endpoint,
            };
            let api_url = `${environment.apiUrl}proxy/dispatchRequest`;

            PostAsyncHelper(api_url, obj).then((response) => {
              console.log(response);
              if (response !== undefined && response.statusText === "OK") {
                // successful Post to api_url
                const results =
                  response.data.ProxyResult["getHotelExpress.Contract"]?.results;
                if (results && results.status !== "Success") {
                  throw Error(
                    response.data.ProxyResult["getHotelExpress.Contract"].error
                      .status
                  );
                } else {
                  //const hotel_data = results.hotel_data[0]               // getHotelDetails

                  try {
                    const hotel_data = results?.hotel_data[0]; // getHotelExpress.Results
                    const input_data = results?.input_data;
                    const bundle_data = hotel_data?.room_data[0]?.rate_data[0];
                    const room_data = hotel_data?.room_data[0];

                    let booking_bundle = {
                      hotel_id: hotel_data?.id,
                      name: hotel_data?.name,
                      ppn_book_bundle: bundle_data?.ppn_bundle,
                      check_in: input_data?.check_in,
                      check_out: input_data?.check_out,
                      rate_currency: bundle_data?.price_details?.display_currency,
                      rate_symbol: bundle_data?.price_details?.display_symbol,
                      rate_avg: bundle_data?.price_details?.display_price,
                      rate_insurance_fee:
                        bundle_data?.price_details?.display_insurance_fee,
                      rate_property_fee:
                        bundle_data?.price_details?.display_property_fee,
                      rate_processing_fee: 0,
                      rate_sub_total:
                        bundle_data?.price_details?.display_sub_total,
                      rate_fee: bundle_data?.price_details?.display_taxes,
                      rate_total: bundle_data?.price_details?.display_total,
                      room_data: room_data,
                      room_text: room_data?.title,
                      room_id: room_data?.id,
                      pcln_id: bundle_data?.pcln_id,
                      is_cancellable:
                        bundle_data?.refund_type &&
                          bundle_data?.refund_type !== "NONE"
                          ? true
                          : false,
                      details_summary: {
                        freeRefundableFlag:
                          bundle_data?.refund_type &&
                            bundle_data?.refund_type === "NONE"
                            ? 0
                            : 1,
                      },
                    };

                    booking_info = {
                      establishmentID: "",
                      establishmentPricelineID: hotel_data.id,
                      booking_dot_com_id: hotel_data.id_t,
                      hotel_id: hotel_data.id,
                      name: hotel_data.name,
                      establishmentStarRating: hotel_data.review_rating,
                      address: hotel_data.address.address_line_one,
                      occupancyLimit: bundle_data?.occupancy_limit,
                      mandatory_fee:
                        bundle_data?.price_details?.mandatory_fee_details,
                      rate_symbol: bundle_data?.price_details.display_symbol,
                      //phone: null,
                      postalCode: hotel_data?.address?.zip,
                      //email: null,
                      //latitude: hotel_data.geo.latitude,
                      //longitude: hotel_data.geo.longitude,
                      cityName: hotel_data.address.city_name,
                      stateName: hotel_data.address.state_name,
                      countryName: hotel_data.address.country_name,
                      city_id: hotel_data.city_id,
                      stateCode: hotel_data.address.state_code,
                      countryCode: hotel_data.address.country_code,

                      check_in: input_data.check_in,
                      check_out: input_data.check_out,
                      room_text: room_data.title,
                      room_data: room_data,
                      reviewsAverage: hotel_data.hotel_score.guest_score,
                      review_rating: hotel_data.hotel_rating,
                      reviewsDescription: hotel_data.review_rating_desc,
                      star_rating: hotel_data.star_rating,
                      rating_count: hotel_data.hotel_score.guest_score_count,
                      review_count: hotel_data.review_count,

                      num_rooms: input_data.num_rooms,
                      num_adults: input_data.num_adults,
                      num_children: input_data.num_children,
                      num_nights: input_data.num_nights,

                      estabPicture: {
                        imageName: hotel_data.thumbnail,
                        description: hotel_data.name,
                      },
                    };

                    // success in proxy results
                    setHotelEstablishmentId(hotel_data.id);

                    booking_bundle["booking_info"] = booking_info;

                    ppn_bundles.push(booking_bundle);

                    dispatch({
                      //type: FETCH_CONTRACT_INFO_HOTEL_BOOKING,
                      type: ADD_BUNDLE_TO_HOTEL_BOOKING,
                      booking_info: booking_info,
                      booking_bundles: ppn_bundles,
                    });
                  } catch { }
                }
              } else {
                // error Posting to api_url
                dispatch({
                  type: FETCH_CONTRACT_INFO_HOTEL_BOOKING_FAILURE,
                  payload: response.statusText,
                });
              }
            });
          });
        }

        dispatch({
          type: SET_LOADER,
          payload: false,
        });

        // convert pl results into establishments
      } catch (error) {
        dispatch({
          type: FETCH_CONTRACT_INFO_HOTEL_BOOKING_FAILURE,
          api_error: error.text,
        });
      }
    };

export const addBundleToHotelBooking =
  ({
    hotel_id,
    ppn_book_bundle,
    check_in,
    check_out,
    rooms,
    adults,
    booking_bundles,
  }) =>
    async (dispatch) => {
      try {
        const endpoint = "getExpress.Contract"; // getHotelDetails
        //const endpoint = "getHotelDetails";     // getHotelDetails

        let obj = {
          "proxyData[format]": "json2",
          "proxyData[hotel_id]": hotel_id,
          "proxyData[ppn_bundle]": ppn_book_bundle,
          "proxyData[check_in]": check_in,
          "proxyData[check_out]": check_out,
          "proxyData[rooms]": rooms,
          "proxyData[adults]": adults,
          proxyApiMethod: "GET",
          proxyApiProperty: "hotel",
          proxyApiEndpoint: endpoint,
        };
        let api_url = `${environment.apiUrl}proxy/dispatchRequest`;

        PostAsyncHelper(api_url, obj).then((response) => {
          console.log(response);
          if (response !== undefined && response.statusText === "OK") {
            // successful Post to api_url
            const results =
              response.data.ProxyResult["getHotelExpress.Contract"]?.results;
            if (results && results.status !== "Success") {
              throw Error(
                response.data.ProxyResult["getHotelExpress.Contract"].error.status
              );
            } else {
              //const hotel_data = results.hotel_data[0]               // getHotelDetails

              try {
                const hotel_data = results?.hotel_data[0]; // getHotelExpress.Results
                const input_data = results?.input_data;
                const bundle_data = hotel_data?.room_data[0]?.rate_data[0];
                const room_data = hotel_data?.room_data[0];

                let booking_bundle = {
                  hotel_id: hotel_data?.id,
                  name: hotel_data?.name,
                  ppn_book_bundle: bundle_data?.ppn_bundle,
                  check_in: input_data?.check_in,
                  check_out: input_data?.check_out,
                  rate_currency: bundle_data?.price_details?.display_currency,
                  rate_symbol: bundle_data?.price_details?.display_symbol,
                  rate_avg: bundle_data?.price_details?.display_price,
                  rate_insurance_fee:
                    bundle_data?.price_details?.display_insurance_fee,
                  rate_property_fee:
                    bundle_data?.price_details?.display_property_fee,
                  rate_processing_fee: 0,
                  rate_sub_total: bundle_data?.price_details?.display_sub_total,
                  rate_fee: bundle_data?.price_details?.display_taxes,
                  rate_total: bundle_data?.price_details?.display_total,
                  room_text: room_data?.title,
                  room_data: room_data,
                  room_id: room_data?.id,
                  pcln_id: bundle_data?.pcln_id,
                  is_cancellable:
                    bundle_data?.refund_type &&
                      bundle_data?.refund_type !== "NONE"
                      ? true
                      : false,
                  details_summary: {
                    freeRefundableFlag:
                      bundle_data?.refund_type &&
                        bundle_data?.refund_type === "NONE"
                        ? 0
                        : 1,
                  },
                };

                let booking_info = {
                  establishmentID: "",
                  establishmentPricelineID: hotel_data.id,
                  booking_dot_com_id: hotel_data.id_t,
                  hotel_id: hotel_data.id,
                  name: hotel_data.name,
                  establishmentStarRating: hotel_data.review_rating,
                  address: hotel_data.address.address_line_one,
                  occupancyLimit: bundle_data?.occupancy_limit,
                  mandatory_fee:
                    bundle_data?.price_details?.mandatory_fee_details,
                  rate_symbol: bundle_data?.price_details.display_symbol,
                  //phone: null,
                  postalCode: hotel_data?.address?.zip,
                  //email: null,
                  //latitude: hotel_data.geo.latitude,
                  //longitude: hotel_data.geo.longitude,
                  cityName: hotel_data.address.city_name,
                  stateName: hotel_data.address.state_name,
                  countryName: hotel_data.address.country_name,
                  city_id: hotel_data.city_id,
                  stateCode: hotel_data.address.state_code,
                  countryCode: hotel_data.address.country_code,

                  check_in: input_data.check_in,
                  check_out: input_data.check_out,
                  room_text: room_data.title,
                  room_data: room_data,
                  reviewsAverage: hotel_data.hotel_score.guest_score,
                  review_rating: hotel_data.hotel_rating,
                  reviewsDescription: hotel_data.review_rating_desc,
                  star_rating: hotel_data.star_rating,
                  rating_count: hotel_data.hotel_score.guest_score_count,
                  review_count: hotel_data.review_count,

                  num_rooms: input_data.num_rooms,
                  num_adults: input_data.num_adults,
                  num_children: input_data.num_children,
                  num_nights: input_data.num_nights,

                  estabPicture: {
                    imageName: hotel_data.thumbnail,
                    description: hotel_data.name,
                  },
                  price_details: bundle_data?.price_details,
                };

                // success in proxy results
                setHotelEstablishmentId(hotel_data.id);

                booking_bundle["booking_info"] = booking_info;
                let ppn_bundles = [...booking_bundles];
                ppn_bundles.push(booking_bundle);

                dispatch({
                  //type: FETCH_CONTRACT_INFO_HOTEL_BOOKING,
                  type: ADD_BUNDLE_TO_HOTEL_BOOKING,
                  booking_info: booking_info,
                  booking_bundles: ppn_bundles,
                });

                dispatch({
                  type: SET_LOADER,
                  payload: false,
                });

                // convert pl results into establishments
              } catch { }
            }
          } else {
            // error Posting to api_url
            dispatch({
              type: FETCH_CONTRACT_INFO_HOTEL_BOOKING_FAILURE,
              payload: response.statusText,
            });
          }
        });
      } catch (error) {
        dispatch({
          type: FETCH_CONTRACT_INFO_HOTEL_BOOKING_FAILURE,
          api_error: error.text,
        });
      }
    };

export const addPricelineHotelToMuvDb =
  ({
    establishmentPricelineID,
    lengthOfStay,
    lang,
    uuid,
    activeTripDestinationId,
    activeDayInTripDestination,
    establishmentID,
    activeTripId,
    last_establishmentId,
    tripDuration,
    destinationId,
    activeTripDestinationIds,
  }) =>
    async (dispatch) => {
      // (establishment, hotel_form_state, lang, uuid, activeTripDestinationId, activeDayInTripDestination,
      //  establishmentID, activeTripId, last_establishmentId, tripDuration, destinationId,
      //  activeTripDestinationIds)
      try {
        console.log("addPricelineHotelToMuvDb");

        //fetchHotelEstablishment(establishment.hotel_id, establishment.ppn_bundle, hotel_form_state)
        //addActivityToTripDestinationInTrip(lang, uuid, activeTripDestinationId, activeDayInTripDestination, establishmentID, activeTripId, last_establishmentId, tripDuration, destinationId, activeTripDestinationIds)

        //fetchHotelEstablishment(establishment.hotel_id, establishment.ppn_bundle, hotel_form_state)
        const endpoint = "getHotelDetails"; // getHotelDetails

        let obj = {
          "proxyData[format]": "json2",
          "proxyData[hotel_id]": establishmentPricelineID,
          //"proxyData[ppn_bundle]": establishment.ppn_bundle,
          //"proxyData[photos]": true,
          //"proxyData[reviews]": true,
          //"proxyData[guest_score_breakdown]": true,
          //"proxyData[nearby]": true,
          //"proxyData[check_in]": hotel_form_state.check_in,
          //"proxyData[check_out]": hotel_form_state.check_out,
          //"proxyData[rooms]": hotel_form_state.rooms,
          //"proxyData[adults]": hotel_form_state.adults,
          proxyApiMethod: "GET",
          proxyApiProperty: "hotel",
          proxyApiEndpoint: endpoint,
        };
        let api_url = `${environment.apiUrl}proxy/dispatchRequest`;

        console.log(api_url, obj);
        PostAsyncHelper(api_url, obj).then((response) => {
          //console.log(response);
          if (response !== undefined && response.statusText === "OK") {
            // successful Post to api_url
            const results =
              response.data.ProxyResult["getHotelHotelDetails"].results;
            console.log(results);
            if (results && results.status !== "Success") {
              // throw Error(response.data.ProxyResult[endpoint].error.status);
            } else {
              const hotel_data = results.hotel_data[0]; // getHotelDetails
              //const hotel_data = results.hotel_data.hotel_0       // getHotelExpress.Results

              let obj = {
                priceline_id: hotel_data.id,
                booking_dot_com_id: hotel_data.id_b,
                name: hotel_data.name,
                phone: null,
                description_en: hotel_data.hotel_description,
                city_name: hotel_data.address.city_name,
                priceline_city_id: hotel_data.city.id,
                state_name: hotel_data.address.state_name,
                state_code: hotel_data.address.state_code,
                country_name: hotel_data.address.country_name,
                country_code: hotel_data.address.country_code,
                zip: hotel_data.address.zip,
                inline_full_address: hotel_data.address.address_line_one,
                latitude: hotel_data.geo.latitude,
                longitude: hotel_data.geo.longitude,
                website: null,
                amenities: JSON.stringify(hotel_data.amenity_data),
                neighborhood: hotel_data.neighborhood
                  ? JSON.stringify(hotel_data.neighborhood)
                  : "",
              };

              let general_info = {
                establishmentID: "",
                establishmentPricelineID: hotel_data.id,
                booking_dot_com_id: hotel_data.id_b,
                ppn_bundle: hotel_data.ppn_bundle,
                neighborhood: hotel_data.neighborhood
                  ? hotel_data.neighborhood.name
                  : "",
                name: hotel_data.name,
                about: hotel_data.hotel_description,
                establishmentStarRating: hotel_data.star_rating,
                check_in_time: hotel_data.check_in_time,
                check_out_time: hotel_data.check_out_time,
                //  uri: "1501-1_Hotel_Central_Park-New_York-USA",
                address: hotel_data.address.address_line_one,
                //phone: null,
                postalCode: hotel_data.address.zip,
                //email: null,
                latitude: hotel_data.geo.latitude,
                longitude: hotel_data.geo.longitude,
                cityName: hotel_data.address.city_name,
                stateName: hotel_data.address.state_name,
                countryName: hotel_data.address.country_name,

                about: hotel_data.hotel_description,
                city_id: hotel_data.city_id,
                stateCode: hotel_data.address.state_code,
                countryCode: hotel_data.address.country_code,
                //    "website": hotel_data.,
                reviewsAverage: hotel_data.review_rating,
                reviewsDescription: hotel_data.review_rating_desc,
                star_rating: hotel_data.star_rating,
                rating_count: hotel_data.rating_count,
                review_count: hotel_data.review_count,

                amenities: hotel_data.amenity_data,
                //   guest_score_categories: hotel_data.guest_score_categories,
                //    experiences: hotel_data.,
                //    menu: hotel_data.,
                //    selectedMenu: hotel_data.,
                //    error: hotel_data.error,
                estabPicture: {
                  //    "bucketName": "muvimages",
                  //    "folderName": "establishments",
                  imageName: hotel_data.thumbnail_hq.three_hundred_square,
                  description: hotel_data.name,
                },
              };

              console.log(obj);

              // add to MuvDb
              let api_url =
                environment.apiUrl +
                "customdata/addCustomHotelFromPriceline/" +
                lang +
                "/" +
                uuid;

              PostAsyncHelper(api_url, obj).then((response) => {
                //console.log(response);
                /*    const vv = {result: {
                                  amenities: "[{\"id\":\"1\",\"name\":\"Airport Shuttle\"},{\"id\":\"2\",\"name\":\"Business Center\"},{\"id\":\"5\",\"name\":\"Free Breakfast\"},{\"id\":\"6\",\"name\":\"Free Internet Available\"},{\"id\":\"7\",\"name\":\"Free Internet Access\"},{\"id\":\"8\",\"name\":\"Free Internet In Public Areas\"},{\"id\":\"9\",\"name\":\"Fitness Center or Spa\"},{\"id\":\"11\",\"name\":\"Accessible\"},{\"id\":\"12\",\"name\":\"No Smoking Rooms/Facilities\"},{\"id\":\"13\",\"name\":\"Pets Allowed\"},{\"id\":\"14\",\"name\":\"Restaurant\"},{\"id\":\"20\",\"name\":\"Laundry\"},{\"id\":\"25\",\"name\":\"Valet Parking\"},{\"id\":\"26\",\"name\":\"Room Service\"},{\"id\":\"27\",\"name\":\"Safety Deposit Box\"},{\"id\":\"29\",\"name\":\"Shops in Hotel\"},{\"id\":\"34\",\"name\":\"Terrace\"},{\"id\":\"35\",\"name\":\"Tour Desk\"},{\"id\":\"38\",\"name\":\"Air Conditioning\"},{\"id\":\"39\",\"name\":\"Babysitting/Child Services\"},{\"id\":\"40\",\"name\":\"Bar\"},{\"id\":\"45\",\"name\":\"Concierge Service\"},{\"id\":\"47\",\"name\":\"24-Hour Front Desk\"},{\"id\":\"48\",\"name\":\"Express Check-In/Check-Out\"},{\"id\":\"49\",\"name\":\"24hr room service\"},{\"id\":\"51\",\"name\":\"Elevator\"},{\"id\":\"52\",\"name\":\"Coffee shop\"},{\"id\":\"56\",\"name\":\"Hair dryer\"},{\"id\":\"59\",\"name\":\"Microwave\"},{\"id\":\"65\",\"name\":\"Family room\"},{\"id\":\"66\",\"name\":\"Smoking area\"},{\"id\":\"82\",\"name\":\"salon\"},{\"id\":\"83\",\"name\":\"bathrobes\"},{\"id\":\"88\",\"name\":\"complimentary bottled water\"},{\"id\":\"106\",\"name\":\"Library\"},{\"id\":\"118\",\"name\":\"Ticket service\"},{\"id\":\"120\",\"name\":\"Luggage storage\"},{\"id\":\"138\",\"name\":\"Private check-in/check-out\"},{\"id\":\"162\",\"name\":\"Wheelchair accessible\"},{\"id\":\"164\",\"name\":\"Grocery deliveries\"},{\"id\":\"169\",\"name\":\"internet access – wireless\"},{\"id\":\"173\",\"name\":\"television LCD/plasma screen\"},{\"id\":\"175\",\"name\":\"mini bar\"},{\"id\":\"180\",\"name\":\"fitness center\"},{\"id\":\"187\",\"name\":\"car park\"},{\"id\":\"199\",\"name\":\"telephone\"},{\"id\":\"200\",\"name\":\"toiletries\"},{\"id\":\"202\",\"name\":\"soundproofing\"},{\"id\":\"204\",\"name\":\"iPod docking station\"},{\"id\":\"220\",\"name\":\"24-hour security\"},{\"id\":\"397\",\"name\":\"Concierge services\"},{\"id\":\"420\",\"name\":\"Designated Smoking Area\"},{\"id\":\"480\",\"name\":\"Family Rooms\"},{\"id\":\"492\",\"name\":\"Fireplace\"},{\"id\":\"510\",\"name\":\"Free Wi-Fi\"},{\"id\":\"543\",\"name\":\"Hair/Beauty Salon\"},{\"id\":\"617\",\"name\":\"Kitchen\"},{\"id\":\"654\",\"name\":\"Massage services\"},{\"id\":\"706\",\"name\":\"Off-Site parking\"},{\"id\":\"784\",\"name\":\"Postal Service\"},{\"id\":\"1002\",\"name\":\"Wi-Fi In Public Areas\"},{\"id\":\"1062\",\"name\":\"Daily Housekeeping\"},{\"id\":\"1246\",\"name\":\"free Wi-Fi in all rooms\"},{\"id\":\"1247\",\"name\":\"English\"},{\"id\":\"1250\",\"name\":\"Arabic\"},{\"id\":\"1259\",\"name\":\"French\"},{\"id\":\"1260\",\"name\":\"German\"},{\"id\":\"1266\",\"name\":\"Italian\"},{\"id\":\"1273\",\"name\":\"Portuguese\"},{\"id\":\"1277\",\"name\":\"Spanish\"},{\"id\":\"1588\",\"name\":\"Slippers\"},{\"id\":\"1671\",\"name\":\"Parking Available\"},{\"id\":\"1690\",\"name\":\"private check in/check out\"},{\"id\":\"1691\",\"name\":\"taxi service\"},{\"id\":\"1713\",\"name\":\"Infirmary\"},{\"id\":\"1759\",\"name\":\"Shops on site\"},{\"id\":\"1841\",\"name\":\"24-Hour Check-In\"},{\"id\":\"2065\",\"name\":\"smoking allowed\"},{\"id\":\"2159\",\"name\":\"car park nearby\"},{\"id\":\"2162\",\"name\":\"car park charges applied\"},{\"id\":\"2165\",\"name\":\"dogs allowed\"},{\"id\":\"2168\",\"name\":\"100% non-smoking\"},{\"id\":\"2258\",\"name\":\"first aid kit\"},{\"id\":\"2390\",\"name\":\"Smoke-Free Property\"},{\"id\":\"2458\",\"name\":\"Free Internet\"},{\"id\":\"2562\",\"name\":\"Staff follow all safety protocols as directed by local authorities\"},{\"id\":\"2602\",\"name\":\"First aid kit available\"},{\"id\":\"2712\",\"name\":\"Hand sanitizer in guest accommodation and key areas\"},{\"id\":\"2992\",\"name\":\"Daily disinfection in common areas\"},{\"id\":\"3002\",\"name\":\"Doctor/nurse on call\"},{\"id\":\"3012\",\"name\":\"First aid kit\"},{\"id\":\"3022\",\"name\":\"Hand sanitizer\"},{\"id\":\"3032\",\"name\":\"Hygiene certification\"},{\"id\":\"3042\",\"name\":\"Sterilizing equipment\"},{\"id\":\"3052\",\"name\":\"Staff trained in safety protocol\"},{\"id\":\"3062\",\"name\":\"Temperature check for guests and staff\"},{\"id\":\"3082\",\"name\":\"Free face masks\"},{\"id\":\"3092\",\"name\":\"Daily disinfection in all rooms\"},{\"id\":\"3102\",\"name\":\"Protective screens in common areas\"},{\"id\":\"3112\",\"name\":\"Physical distancing of at least 1 meter\"},{\"id\":\"3122\",\"name\":\"Safe dining setup\"},{\"id\":\"3132\",\"name\":\"Face coverings on staff\"},{\"id\":\"3152\",\"name\":\"Separate shower/bathtub\"},{\"id\":\"3162\",\"name\":\"Satellite/cable channels\"},{\"id\":\"3262\",\"name\":\"Free Wi-Fi in all rooms!\"},{\"id\":\"3272\",\"name\":\"Front desk [24-hour]\"},{\"id\":\"3292\",\"name\":\"Cash withdrawal\"},{\"id\":\"3302\",\"name\":\"Chinese [Mandarin]\"},{\"id\":\"3412\",\"name\":\"Security [24-hour]\"},{\"id\":\"3422\",\"name\":\"Grocery delivery\"},{\"id\":\"3442\",\"name\":\"Check-in/out [private]\"},{\"id\":\"3452\",\"name\":\"Ticket services\"},{\"id\":\"3472\",\"name\":\"Check-in [24-hour]\"},{\"id\":\"3522\",\"name\":\"Breakfast [free]\"},{\"id\":\"3542\",\"name\":\"Car park [nearby]\"},{\"id\":\"3562\",\"name\":\"Car park [charges apply]\"},{\"id\":\"3622\",\"name\":\"Contactless check-in/out\"},{\"id\":\"3642\",\"name\":\"Food delivery\"},{\"id\":\"4492\",\"name\":\"Dog-friendly\"}]",
                                  booking_dot_com_id: "54417",
                                  city_name: "Paris",
                                  country_code: "FR",
                                  country_name: "France",
                                  created_at: "2021-03-11 21:04:30",
                                  description_en: "MGallery Nest Paris La Défense Ex Sofitel is a 5* hotel set in an ideal location, only 250 metres from the shopping centre &quot;Les Quatre Temps&quot; and a few minutes by public transport from the Champs Elysées Avenue. The modern and contemporary hotel rooms were designed by Maison Numéro 20 and are inspired by the Memphis Style. They are doted with a flat-screen TV, an iPod docking station, a welcome tray and a mini bar with 2 free bottles of water. The private, spacious bathrooms are equipped with 5 Mondes toiletries. Guests can benefit from room service and a fitness room available 24/7. Breakfast is served every morning and room service in partnership with BOCO is available. MGallery Nest Paris La Défense Ex Sofitel is only 50 metres from Metro Esplanade de La Défense and a 9-minutes walk from the Arc de Triomphe. U Arena is a 9-minute drive away.",
                                  id: 11,
                                  inline_full_address: "33 Voie Des Sculpteurs",
                                  latitude: "48.88820911",
                                  longitude: "2.24501988",
                                  name: "MGallery Nest Paris La Défense Ex Sofitel",
                                  neighborhood: "{\"id\":\"5752\",\"name\":\"La Defense - Neuilly\"}",
                                  phone: "",
                                  priceline_city_id: "800029376",
                                  priceline_id: "700030023",
                                  state_code: "",
                                  state_name: "",
                                  updated_at: "2021-03-11 21:04:30",
                                  website: "",
                                  zip: "92800",
                                  status: "success"
                                  }
                              }
                          */
                if (response !== undefined && response.statusText === "OK") {
                  // successful Post to api_url
                  const result = response.data.result;

                  const hotel_data = result; // getHotelDetails
                  //const hotel_data = results.hotel_data.hotel_0       // getHotelExpress.Results

                  console.log(result);

                  // add to trip

                  let obj = {
                    tripId: activeTripId,
                    tripDestinationId: activeTripDestinationId,
                    customHotelId: hotel_data.id,
                    startDayInDestination: 1, //activeDayInTripDestination,
                    lengthOfStay: lengthOfStay,
                  };

                  //console.log("obj", obj);

                  // addCustomHotel to timeline

                  let api_url =
                    environment.apiUrl +
                    "timeline/addCustomHotel/" +
                    lang +
                    "/" +
                    uuid;

                  PostAsyncHelper(api_url, obj).then((response) => {
                    console.log(response);

                    if (response !== undefined && response.statusText === "OK") {
                      // successful Post to api_url
                      const result = response.data.result;

                      console.log(result);

                      const activity = {
                        activityID: result.custom_hotel_id,
                        is_custom: result.is_custom,
                        tripDestinationId: destinationId,
                        activityDay: result.day_in_destination,
                        activityDayInDestination: result.day_in_destination,
                        activityEstabID: establishmentPricelineID,
                      };

                      dispatch({
                        type: ADD_ACTIVITY_IN_ACTIVE_TRIP,
                        activity: activity,
                      });

                      dispatch({
                        type: SET_ADDED_ACTIVITY_IN_TRIP,
                        activityID: result.custom_hotel_id,
                      });
                    } else {
                      // error Posting to api_url
                      console.log("error");
                      console.log(response);
                      dispatch({
                        type: FETCH_GENERAL_INFO_HOTEL_ESTABLISHMENT_FAILURE,
                        payload: response,
                      });
                    }
                  });
                } else {
                  // error Posting to api_url
                  console.log("error");
                  console.log(response);
                  dispatch({
                    type: FETCH_GENERAL_INFO_HOTEL_ESTABLISHMENT_FAILURE,
                    payload: response,
                  });
                }
              });
            }
          } else {
            // error Posting to api_url
            dispatch({
              type: FETCH_GENERAL_INFO_HOTEL_ESTABLISHMENT_FAILURE,
              payload: response.statusText,
            });
          }
        });
      } catch (error) {
        console.log(error);
        dispatch({
          type: FETCH_CONTRACT_INFO_HOTEL_BOOKING_FAILURE,
          api_error: error.text,
        });
      }
    };

export const addRoomToBooking =
  (
    lang,
    uuid,
    pricelineHotelId,
    pricelineRateId,
    room,
    booking,
    hotel_form_state,
    sid,
    ppn_bundle,
    establishmentId,
    tripId,
    tracking_id,
    tripDuration,
    destinationId,
    activeTripDestinationIds,
    isSetActiveTrip = false,
    activeDayMapDayInTrip = 1,
    duration = 3,
    activityId = "",
    partner_trip_id,
    sale_method,
    smoking
  ) =>
    async (dispatch) => {
      const newRoom =
        booking !== undefined && booking !== null
          ? booking.activeRoomIds.find((id) => id === String(pricelineRateId)) ===
          undefined
          : true;

      if (newRoom) {
        console.log("add room to booking");
        let obj = {
          lang: lang,
          uuid: uuid,
          destinationId: destinationId,
          pricelineHotelId,
          pricelineRateId,
          check_in: hotel_form_state.check_in,
          check_out: hotel_form_state.check_out,
          rooms: hotel_form_state.rooms,
          adults: hotel_form_state.adults,
          tripId: tripId,
          duration: duration,
          sid: sid,
          ppn_bundle,
          tracking_id,
          partner_trip_id,
          sale_method, // Enum: "phn" "mlb" "dsk"
          smoking, // 0 = No Preference, 1 = Non-Smoking, and 2 = Smoking
        };
        let api_url =
          environment.apiUrl +
          "timeline/addTripDestination/" +
          lang +
          "/" +
          uuid +
          "?action=addTripDestination";
        PostAsyncHelper(api_url, obj).then((responseDestinations) => {
          if (responseDestinations.statusText === "OK") {
            const destinations = responseDestinations.data.result;
            const destinationsLength = responseDestinations.data.result.length;
            dispatch({
              type: UPDATE_TRIP_DESTINATION_IN_TRIP,
              trip_destinations_rearrange: destinations,
            });
            dispatch({
              type: ADD_TRIP_DESTINATION_IN_TRIP_OPEN_STATUS,
              trip_destination_open_status: {
                tripDestinationId: destinations[destinationsLength - 1].td_id,
                openStatus: true,
              },
            });
            dispatch({
              type: SET_ACTIVE_TRIP_DESTINATION,
              trip_destination_id: destinations[destinationsLength - 1].td_id,
              destination_id: destinations[destinationsLength - 1].id,
            });
            dispatch({
              type: SET_ACTIVE_DAY_IN_TRIP,
              trip_destination_id: destinations[destinationsLength - 1].td_id,
              day_in_trip: destinations[destinationsLength - 1].startingDayInTrip,
              day_in_trip_destination: "1",
            });

            /* update trip duration */
            const diffTripdays = Number(duration) - 1;
            const obj_trip_duration = {
              lang: lang,
              uuid: uuid,
              duration: Number(tripDuration) + Number(diffTripdays),
              tripId: tripId,
            };
            const api_url_update_trip_duration =
              environment.apiUrl +
              "timeline/updateTripDuration/" +
              lang +
              "/" +
              uuid;
            PostAsyncHelper(api_url_update_trip_duration, obj_trip_duration).then(
              (responseTripDuration) => {
                responseTripDuration.statusText === "OK" &&
                  dispatch({
                    type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
                    trip_duration: Number(tripDuration) + Number(diffTripdays),
                  });
              }
            );

            // add activity
            const obj_add_activity = {
              lang: lang,
              uuid: uuid,
              tripDestinationId: destinations[destinationsLength - 1].td_id,
              dayInDestination: 1,
              placeId: establishmentId,
              afterActivityId: activityId,
            };
            let api_url_activity =
              environment.apiUrl + "timeline/addActivity/" + lang + "/" + uuid;
            PostAsyncHelper(api_url_activity, obj_add_activity).then(
              (responseActivity) => {
                if (
                  responseActivity !== undefined &&
                  responseActivity.statusText === "OK"
                ) {
                  const fetch_active_trip_activities_api_url =
                    environment.apiUrl +
                    "timeline/getTripActivities/" +
                    lang +
                    "/" +
                    uuid +
                    "?tripId=" +
                    tripId +
                    "&getTripActivities";

                  GetAsyncHelper(fetch_active_trip_activities_api_url).then(
                    (responseTripActivities) => {
                      if (responseTripActivities.statusText === "OK") {
                        dispatch({
                          type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                          activities: responseTripActivities.data.result,
                        });
                        dispatch({
                          type: ALERT_BARS_HANDLE,
                          message_type: "success",
                          message: "saved",
                        });
                      } else {
                        console.log("no permission");
                      }
                    }
                  );
                  const url_active_trip_get_cost =
                    environment.apiUrl +
                    "timeline/getTripCost/en/" +
                    uuid +
                    "?tripId=" +
                    tripId +
                    "&getTripCost";
                  dispatch({
                    type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                    status: true,
                  });
                  GetAsyncHelper(url_active_trip_get_cost).then(
                    (responseTripCost) => {
                      if (responseTripCost.statusText === "OK") {
                        dispatch({
                          type: SET_TIMELINE_ACTIVE_TRIP_COST,
                          trip_cost: responseTripCost.data.result,
                        });
                        dispatch({
                          type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                          status: false,
                        });
                      } else {
                        console.log("no permission");
                      }
                    }
                  );
                }
              }
            );
          }
        });
      } else {
        dispatch({
          type: ALERT_BARS_HANDLE,
          message_type: "warning",
          message: "You have already added this room.",
        });
      }
    };

/*  get homepage create trip */
export const createMultipleDestinationTrip =
  (
    uuid_auth,
    lang,
    dataToCreateTrip,
    previousTripId = "",
    startingPoint,
    showTimeline
  ) =>
    async (dispatch) => {
      const uuid = uuid_auth === "" ? "TMPUUID" : uuid_auth;
      dispatch({
        type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
        activities: [],
      });
      const url_post =
        environment.apiUrl +
        "memberarea/trip/createTripMultiDestination/" +
        lang +
        "/" +
        uuid;
      PostAsyncHelper(url_post, dataToCreateTrip).then((responseTrip) => {
        if (
          responseTrip === undefined ||
          responseTrip.statusText === undefined ||
          responseTrip.statusText !== "OK"
        ) {
          dispatch({
            type: ALERT_BARS_HANDLE,
            message_type: "warning",
            message: "failure",
          });
        } else {
          uuid_auth === "" &&
            previousTripId !== "" &&
            Axios.post(
              environment.apiUrl +
              "memberarea/trip/deletetrip/en/TMPUUID?tripId=" +
              previousTripId
            );
          const trip = responseTrip.data.result.trip;
          const url_active_trip_get =
            environment.apiUrl +
            "timeline/getTripInfo/en/" +
            uuid +
            "?tripId=" +
            trip.id +
            "&getTripInfo";
          GetAsyncHelper(url_active_trip_get).then((responseTrip) => {
            if (responseTrip.statusText === "OK") {
              const trip = responseTrip.data.result;
              dispatch(
                setTripStartingPoint({ trip: trip, uuid: uuid, startingPoint })
              );
              dispatch(updateActiveTrip(trip));
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_ID,
                trip_id: trip.tripID,
              });

              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_NAME,
                trip_name: trip.tripName,
              });

              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_START_DATE,
                trip_start_date:
                  trip.noDate === "0" ? trip.tripStartDate : "0000-00-00",
              });

              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
                trip_no_date: trip.noDate,
              });

              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
                trip_duration: trip.tripDaysCount,
              });
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
                trip_description: trip.tripDescription,
              });
              dispatch({
                type: SET_TRIP_TYPE_SELECTED,
                type_id: trip.typeId,
              });
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
                trip_auth_status: trip.isPublic,
              });
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_IMAGE,
                trip_image: trip.headerImage,
              });

              ///show timeline if more than 1 destination
              const destinations = dataToCreateTrip?.destinations;
              if ((destinations && destinations?.length > 1) || showTimeline) {
                dispatch({
                  type: SET_TIMELINE_WIZARD_STATUS,
                  status: true,
                });
              }

              dispatch({
                type: SET_LEAVING_FROM_AIRPORT_SELECTED,
                airport_selected: trip.leavingFromAirport,
              });
              dispatch({
                type: SET_RETURNING_TO_AIRPORT_SELECTED,
                airport_selected: trip.returningToAirport,
              });
            } else {
              console.log("no permission");
            }
          });
          const url_active_trip_get_cost =
            environment.apiUrl +
            "timeline/getTripCost/en/" +
            uuid +
            "?tripId=" +
            trip.id +
            "&getTripCost";
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
            status: true,
          });
          GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
            if (responseTripCost.statusText === "OK") {
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_COST,
                trip_cost: responseTripCost.data.result,
              });
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                status: false,
              });
            } else {
              console.log("no permission");
            }
          });
          const url_active_trip_get_destinations =
            environment.apiUrl +
            "timeline/getTripDestinations/en/" +
            uuid +
            "?tripId=" +
            trip.id +
            "&getTripDestinations";
          GetAsyncHelper(url_active_trip_get_destinations).then(
            (responseTripDestinations) => {
              if (responseTripDestinations.statusText === "OK") {
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
                  trip_destinations: responseTripDestinations.data,
                });
                responseTripDestinations.data.length > 0 &&
                  responseTripDestinations.data[0] !== undefined &&
                  dispatch({
                    type: SET_ACTIVE_TRIP_DESTINATION,
                    trip_destination_id: responseTripDestinations.data[0].td_id,
                    destination_id: responseTripDestinations.data[0].id,
                  });

                responseTripDestinations.data.length > 0 &&
                  responseTripDestinations.data[0] !== undefined &&
                  dispatch({
                    type: SET_ACTIVE_DAY_IN_TRIP,
                    trip_destination_id: responseTripDestinations.data[0].td_id,
                    day_in_trip: "1",
                    day_in_trip_destination: "1",
                  });
              } else {
                console.log("no permission");
              }
            }
          );
          dispatch({
            type: ALERT_BARS_HANDLE,
            message_type: "success",
            message: trip.trip_name + " created",
          });
          /* set to cookies active trip */
          // uuid_auth === "" &&
          Cookies.set("muv_active_trip", trip.id, {
            expires: 365,
          });
          /* update destination page */
          let destinationId = "";
          if (trip.tripDestinations.length > 0) {
            destinationId = trip.tripDestinations[0].destinations_id;
            dispatch({
              type: SET_DESTINATION_ID_DESTINATION,
              active_id: destinationId,
            });
            GetAsyncHelper(
              environment.apiUrl +
              "destination/main/" +
              lang +
              "/" +
              destinationId
            ).then((responseDestination) => {
              if (
                responseDestination === undefined ||
                responseDestination.statusText === undefined ||
                responseDestination.statusText !== "OK"
              ) {
                throw Error(responseDestination.statusText);
              }
              dispatch({
                type: FETCH_GENERAL_INFO_DESTINATION,
                general_info: responseDestination.data.result.generalInfo,
              });
              dispatch({
                type: FETCH_BREADCRUMB_DESTINATION,
                breadcrumb: responseDestination.data.result.destinationTree,
              });

              dispatch({
                type: FETCH_NESTED_IDS_DESTINATION,
                nested_ids: responseDestination.data.result.destinationNestedIds,
              });
            });
            GetAsyncHelper(
              environment.apiUrl +
              "destination/getavailablefeatures/" +
              lang +
              "/" +
              destinationId
            ).then((response) => {
              if (response.statusText !== "OK") {
                throw Error(response.statusText);
              }
              dispatch({
                type: FETCH_FEATURES_DESTINATION,
                features: response.data.features,
              });
              if (
                response.data.features.length > 0 &&
                response.data.features[0] !== undefined
              ) {
                dispatch({
                  type: SET_FEATURE_FORMAT,
                  featureSelected: response.data.features[0],
                });
                /*  get first feature's types */
                GetAsyncHelper(
                  environment.apiUrl +
                  "destination/getfeaturetypes/" +
                  lang +
                  "/" +
                  destinationId +
                  "?featureID=" +
                  response.data.features[0].feature_id
                ).then((responseTypes) => {
                  if (responseTypes.statusText === "OK") {
                    dispatch({
                      type: FETCH_FEATURE_TYPES_DESTINATION,
                      types: responseTypes.data.types,
                    });
                    if (
                      responseTypes.data.types.length > 0 &&
                      responseTypes.data.types[0] !== undefined
                    ) {
                      dispatch({
                        type: DESTINATION_SWITCH_FEATURE_TYPE_CONTAINER,
                        typeSelected: responseTypes.data.types[0],
                      });
                      /*  get first feature's type's subtype */
                      GetAsyncHelper(
                        environment.apiUrl +
                        "destination/getfeaturesubtypes/" +
                        lang +
                        "/" +
                        destinationId +
                        "?featureid=" +
                        response.data.features[0].feature_id +
                        "&typeID=" +
                        responseTypes.data.types[0].typeID
                      ).then((responseSubtypes) => {
                        if (responseSubtypes.statusText === "OK") {
                          dispatch({
                            type: FETCH_FEATURE_SUBTYPES_DESTINATION,
                            subtypes: responseSubtypes.data,
                          });
                        } else {
                          dispatch({
                            type: FETCH_API_ERROR_DESTINATION,
                            api_error: true,
                          });
                        }
                      });
                      dispatch({
                        type: UPDATE_SEARCH_QUERY_DESTINATION,
                        search_query: "",
                      });
                      let obj = {
                        featureID: response.data.features[0].feature_id,
                        typeID: responseTypes.data.types[0].typeID,
                        limit: LAZYLOADING_ESTABLISHMENTS_LIMIT,
                        offset: 0,
                        subtype: [],
                        sortingOrder: {
                          title: response.data.features[0].sorting.title,
                          code: response.data.features[0].sorting.code,
                        },
                        sortingDirection: "",
                        searchquery: "",
                      };
                      let api_url =
                        environment.apiUrl +
                        "destination/getlistoffeatures/" +
                        lang +
                        "/" +
                        destinationId;
                      dispatch({
                        type: UPDATE_LAZYLOADING_URL_REQUESTS_DESTINATION,
                        api_url: api_url,
                        requests: obj,
                      });
                      PostAsyncHelper(api_url, obj).then(
                        (responseEstablishments) => {
                          if (
                            responseEstablishments !== undefined &&
                            responseEstablishments.statusText === "OK"
                          ) {
                            response.data.features.length > 0 &&
                              response.data.features[0].feature_id ===
                              features_router.places.featureId &&
                              dispatch({
                                type: FETCH_ESTABLISMENT_SETS_DESTINATION,
                                result_sets_establishments:
                                  responseEstablishments.data.results,
                              });
                            response.data.features.length > 0 &&
                              response.data.features[0].feature_id ===
                              features_router.trips.featureId &&
                              dispatch({
                                type: FETCH_TRIP_SETS_DESTINATION,
                                result_sets_trips:
                                  responseEstablishments.data.results,
                              });
                            if (responseEstablishments.data.results.length < 5) {
                              dispatch({
                                type: UPDATE_LAZYLOADING_IS_FATCH_ALL_DESTINATION,
                                no_progress: true,
                              });
                            } else {
                              dispatch({
                                type: UPDATE_LAZYLOADING_IS_FATCH_ALL_DESTINATION,
                                no_progress: false,
                              });
                            }
                          } else {
                            dispatch({
                              type: FETCH_API_ERROR_DESTINATION,
                              api_error: true,
                            });
                          }
                        }
                      );
                    }
                  } else {
                    dispatch({
                      type: FETCH_API_ERROR_DESTINATION,
                      api_error: true,
                    });
                  }
                });
              }
            });
          } else {
            dispatch({
              type: SET_FEATURE_FORMAT,
              featureSelected: null,
            });
            dispatch({
              type: FETCH_FEATURE_TYPES_DESTINATION,
              types: [],
            });
            let obj = {
              featureID: 0,
              typeID: 0,
              limit: LAZYLOADING_ESTABLISHMENTS_LIMIT,
              offset: 0,
              subtype: [],
              sortingOrder: {
                title: "",
                code: "",
              },
              sortingDirection: "",
              searchquery: "",
            };
            let api_url = "";
            dispatch({
              type: UPDATE_LAZYLOADING_URL_REQUESTS_DESTINATION,
              api_url: api_url,
              requests: obj,
            });
            dispatch({
              type: FETCH_FEATURE_SUBTYPES_DESTINATION,
              subtypes: [],
            });
            dispatch({
              type: UPDATE_LAZYLOADING_IS_FATCH_ALL_DESTINATION,
              no_progress: true,
            });
          }
          GetAsyncHelper(
            environment.apiUrl +
            "destination/getinfluencers/" +
            lang +
            "/" +
            destinationId
          ).then((responseInfluencer) => {
            if (responseInfluencer.statusText !== "OK") {
              throw Error(responseInfluencer.statusText);
            }
            dispatch({
              type: FETCH_INFLUENCERS_DESTINATION,
              influencers: responseInfluencer.data.influencers,
            });
          });
          GetAsyncHelper(
            environment.apiUrl +
            "destination/suggestedtrips/" +
            lang +
            "/" +
            destinationId +
            "?limit=10"
          ).then((responseSuggestedTrip) => {
            if (responseSuggestedTrip.statusText !== "OK") {
              throw Error(responseSuggestedTrip.statusText);
            }
            dispatch({
              type: FETCH_SUGGESTEDTRIPS_DESTINATION,
              suggested_trips: responseSuggestedTrip.data.results,
            });
          });
          GetAsyncHelper(
            environment.apiUrl +
            "destination/photogallery/" +
            lang +
            "/" +
            destinationId
          ).then((responsePhotoGallery) => {
            if (responsePhotoGallery.statusText !== "OK") {
              throw Error(responsePhotoGallery.statusText);
            }
            dispatch({
              type: FETCH_SLIDER_IMAGES_DESTINATION,
              slider_images: responsePhotoGallery.data.results,
            });
          });
          const sortingOptionsRequests = {
            featureId: 1,
          };
          PostAsyncHelper(
            environment.apiUrl + "featurelist/getFeatureSortingOptions/" + lang,
            sortingOptionsRequests
          ).then((responseSortingOptions) => {
            if (responseSortingOptions.statusText !== "OK") {
              // throw Error(responseSortingOptions.statusText);
            }
            dispatch({
              type: FETCH_SORTING_OPTION_DESTINATION,
              sorting_options: responseSortingOptions?.data?.results,
            });
          });
        }
      });
    };

/* get search information */
export const fetchSearchDestinationTextField =
  (query, fromTimeline = false) =>
    async (dispatch) => {
      try {
        const response = await Axios.get(
          environment.apiUrl + "muvsearch/topsearch/" + query + "/en"
        );
        if (response.statusText !== "OK") {
          throw Error(response.statusText);
        }
        dispatch({
          type: FETCH_SEARCH_DESTINATION_DATA,
          search_destination_set: response.data.destinations,
        });

        dispatch({
          type: FETCH_SEARCH_DESTINATION_API_ERROR,
          error_api: false,
        });
        if (
          response.data.destinations !== undefined &&
          response.data.destinations.length === 0
        ) {
          dispatch({
            type: SET_SEARCH_DESTINATION_ERROR,
            error: false,
          });
          dispatch({
            type: SET_SEARCH_DESTINATION_TEXT_HELPER,
            text_helper: "",
          });
          if (!fromTimeline) {
            dispatch({
              type: SET_SEARCH_DESTINATION_AUTOCOMPLETE_STATUS,
              open: false,
            });
          }
        } else {
          dispatch({
            type: SET_SEARCH_DESTINATION_ERROR,
            error: false,
          });
          dispatch({
            type: SET_SEARCH_DESTINATION_TEXT_HELPER,
            text_helper: "",
          });
          dispatch({
            type: SET_SEARCH_DESTINATION_AUTOCOMPLETE_STATUS,
            open: true,
          });
        }
      } catch (error) {
        dispatch({
          type: FETCH_SEARCH_DESTINATION_DATA,
          search_destination_set: [],
        });
        dispatch({
          type: FETCH_SEARCH_DESTINATION_API_ERROR,
          error_api: true,
        });
        dispatch({
          type: SET_SEARCH_DESTINATION_ERROR,
          error: false,
        });
        dispatch({
          type: SET_SEARCH_DESTINATION_AUTOCOMPLETE_STATUS,
          open: false,
        });
        dispatch({
          type: SET_SEARCH_DESTINATION_TEXT_HELPER,
          text_helper: "",
        });
      }
    };

export const setSearchDestinationSelected = (destination) => (dispatch) => {
  dispatch({
    type: SET_SEARCH_DESTINATION_SELECTED,
    destination_selected: destination,
  });
  dispatch({
    type: SET_SEARCH_DESTINATION_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: FETCH_SEARCH_DESTINATION_DATA,
    search_destination_set: [],
  });
};

//START ADDRESS SEARCH
export const fetchSearchAddressTextField =
  (query, fromTimeline = false) =>
    async (dispatch) => {
      try {
        const response = await Axios.get(
          environment.apiUrl + "muvsearch/topsearch/" + query + "/en"
        );
        if (response.statusText !== "OK") {
          throw Error(response.statusText);
        }
        dispatch({
          type: FETCH_SEARCH_ADDRESS_DATA,
          search_address_set: response.data.destinations,
        });
        dispatch({
          type: SET_SEARCH_ADDRESS_AUTOCOMPLETE_STATUS,
          open: true,
        });
        dispatch({
          type: FETCH_SEARCH_ADDRESS_API_ERROR,
          error_api: false,
        });
        if (
          response.data.destinations !== undefined &&
          response.data.destinations.length === 0
        ) {
          dispatch({
            type: SET_SEARCH_ADDRESS_ERROR,
            error: false,
          });
          dispatch({
            type: SET_SEARCH_ADDRESS_TEXT_HELPER,
            text_helper: "",
          });
          if (!fromTimeline) {
            dispatch({
              type: SET_SEARCH_ADDRESS_AUTOCOMPLETE_STATUS,
              open: false,
            });
          }
        } else {
          dispatch({
            type: SET_SEARCH_ADDRESS_ERROR,
            error: false,
          });
          dispatch({
            type: SET_SEARCH_ADDRESS_TEXT_HELPER,
            text_helper: "",
          });
          dispatch({
            type: SET_SEARCH_ADDRESS_AUTOCOMPLETE_STATUS,
            open: true,
          });
        }
      } catch (error) {
        dispatch({
          type: FETCH_SEARCH_ADDRESS_DATA,
          search_address_set: [],
        });
        dispatch({
          type: FETCH_SEARCH_ADDRESS_API_ERROR,
          error_api: true,
        });
        dispatch({
          type: SET_SEARCH_ADDRESS_ERROR,
          error: false,
        });
        dispatch({
          type: SET_SEARCH_ADDRESS_AUTOCOMPLETE_STATUS,
          open: false,
        });
        dispatch({
          type: SET_SEARCH_ADDRESS_TEXT_HELPER,
          text_helper: "",
        });
      }
    };

export const setSearchAddressSelected = (place) => (dispatch) => {
  dispatch({
    type: SET_SEARCH_ADDRESS_SELECTED,
    address_selected: place,
  });
  dispatch({
    type: SET_SEARCH_ADDRESS_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: FETCH_SEARCH_ADDRESS_DATA,
    search_address_set: [],
  });
};

export const invalidSearchAddressQuery = () => (dispatch) => {
  dispatch({
    type: FETCH_SEARCH_ADDRESS_DATA,
    search_address_set: [],
  });
  dispatch({
    type: FETCH_SEARCH_ADDRESS_API_ERROR,
    error_api: false,
  });
  dispatch({
    type: SET_SEARCH_ADDRESS_ERROR,
    error: false,
  });
  dispatch({
    type: SET_SEARCH_ADDRESS_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: SET_SEARCH_ADDRESS_TEXT_HELPER,
    text_helper: "",
  });
};

export const closeAddressPlaceQuery = () => (dispatch) => {
  dispatch({
    type: SET_SEARCH_ADDRESS_AUTOCOMPLETE_STATUS,
    open: false,
  });
};

//END ADDRESS SEARCH

//START PLACE SEARCH
export const fetchSearchPlaceTextField =
  (query, fromTimeline = false, lang, lat, lng) =>
    async (dispatch) => {
      try {
        const response = await Axios.get(
          environment.apiUrl +
          "muvsearch/nearbyplaces/" +
          query +
          "/" +
          lang +
          "?latitude=" +
          lat +
          "&longitude=" +
          lng +
          "&limit=5"
        );
        if (response.statusText !== "OK") {
          throw Error(response.statusText);
        }
        dispatch({
          type: FETCH_SEARCH_PLACE_DATA,
          search_place_set: response.data || [],
        });

        dispatch({
          type: SET_SEARCH_PLACE_AUTOCOMPLETE_STATUS,
          open: true,
        });
        dispatch({
          type: FETCH_SEARCH_PLACE_API_ERROR,
          error_api: false,
        });
        if (response.data !== undefined && response.data.length === 0) {
          dispatch({
            type: SET_SEARCH_PLACE_ERROR,
            error: false,
          });
          dispatch({
            type: SET_SEARCH_PLACE_TEXT_HELPER,
            text_helper: "",
          });
          if (!fromTimeline) {
            dispatch({
              type: SET_SEARCH_PLACE_AUTOCOMPLETE_STATUS,
              open: false,
            });
          }
        } else {
          dispatch({
            type: SET_SEARCH_PLACE_ERROR,
            error: false,
          });
          dispatch({
            type: SET_SEARCH_PLACE_TEXT_HELPER,
            text_helper: "",
          });
          dispatch({
            type: SET_SEARCH_PLACE_AUTOCOMPLETE_STATUS,
            open: true,
          });
        }
      } catch (error) {
        dispatch({
          type: FETCH_SEARCH_PLACE_DATA,
          search_place_set: [],
        });
        dispatch({
          type: FETCH_SEARCH_PLACE_API_ERROR,
          error_api: true,
        });
        dispatch({
          type: SET_SEARCH_PLACE_ERROR,
          error: false,
        });
        dispatch({
          type: SET_SEARCH_PLACE_AUTOCOMPLETE_STATUS,
          open: false,
        });
        dispatch({
          type: SET_SEARCH_PLACE_TEXT_HELPER,
          text_helper: "",
        });
      }
    };

export const setSearchPlaceSelected = (place) => (dispatch) => {
  dispatch({
    type: SET_SEARCH_PLACE_SELECTED,
    place_selected: place,
  });
  dispatch({
    type: SET_SEARCH_PLACE_AUTOCOMPLETE_STATUS,
    open: true,
  });
  dispatch({
    type: FETCH_SEARCH_PLACE_DATA,
    search_place_set: [],
  });
};

export const closeSearchPlaceQuery = () => (dispatch) => {
  dispatch({
    type: SET_SEARCH_PLACE_AUTOCOMPLETE_STATUS,
    open: false,
  });
};

export const invalidSearchPlaceQuery = () => (dispatch) => {
  dispatch({
    type: FETCH_SEARCH_PLACE_DATA,
    search_place_set: [],
  });
  dispatch({
    type: FETCH_SEARCH_PLACE_API_ERROR,
    error_api: false,
  });
  dispatch({
    type: SET_SEARCH_PLACE_ERROR,
    error: false,
  });
  dispatch({
    type: SET_SEARCH_PLACE_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: SET_SEARCH_PLACE_TEXT_HELPER,
    text_helper: "",
  });
};
//END PLACE SEARCH

export const invalidSearchDestinationQuery = () => (dispatch) => {
  dispatch({
    type: FETCH_SEARCH_DESTINATION_DATA,
    search_destination_set: [],
  });
  dispatch({
    type: FETCH_SEARCH_DESTINATION_API_ERROR,
    error_api: false,
  });
  dispatch({
    type: SET_SEARCH_DESTINATION_ERROR,
    error: false,
  });
  dispatch({
    type: SET_SEARCH_DESTINATION_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: SET_SEARCH_DESTINATION_TEXT_HELPER,
    text_helper: "",
  });
};

export const deleteTimelineWizard =
  (token, previousTripId = "") =>
    (dispatch) => {
      token === "" &&
        previousTripId !== "" &&
        Axios.post(
          environment.apiUrl +
          "memberarea/trip/deletetrip/en/TMPUUID?tripId=" +
          previousTripId
        );
      dispatch({
        type: SET_TIMELINE_WIZARD_STATUS,
        status: false,
      });
      dispatch({
        type: SET_TIMELINE_WIZARD_DELETE_ALART_STATUS,
        status: false,
      });
      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_ID,
        trip_id: "",
      });

      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_NAME,
        trip_name: "",
      });

      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_START_DATE,
        trip_start_date: "",
      });

      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
        trip_no_date: "",
      });

      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
        trip_duration: "",
      });
      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
        trip_description: "",
      });
      dispatch({
        type: SET_TRIP_TYPE_SELECTED,
        type_id: "",
      });
      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
        trip_destinations: [],
      });

      dispatch({
        type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS,
        trip_destination_id: [],
      });

      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
        trip_auth_status: "",
      });
      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_IMAGE,
        trip_image: "",
      });
      dispatch({
        type: SET_LEAVING_FROM_AIRPORT_SELECTED,
        airport_selected: null,
      });
      dispatch({
        type: SET_RETURNING_TO_AIRPORT_SELECTED,
        airport_selected: null,
      });
      dispatch({
        type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
        activities: [],
      });
      Cookies.remove("muv_active_trip");
    };


export const hideTimeline = () => (dispatch) => {
  dispatch({
    type: SET_TIMELINE_WIZARD_STATUS,
    status: false,
  });

};

export const closeTripTimelineWizard = () => (dispatch) => {
  dispatch({
    type: SET_TIMELINE_WIZARD_STATUS,
    status: false,
  });
  dispatch({
    type: SET_TIMELINE_WIZARD_DELETE_ALART_STATUS,
    status: false,
  });
  dispatch({
    type: SET_TIMELINE_ACTIVE_TRIP_ID,
    trip_id: "",
  });

  dispatch({
    type: SET_TIMELINE_ACTIVE_TRIP_NAME,
    trip_name: "",
  });

  dispatch({
    type: SET_TIMELINE_ACTIVE_TRIP_START_DATE,
    trip_start_date: "",
  });

  dispatch({
    type: SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
    trip_no_date: "",
  });

  dispatch({
    type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
    trip_duration: "",
  });
  dispatch({
    type: SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
    trip_destinations: [],
  });
  dispatch({
    type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
    trip_description: "",
  });
  dispatch({
    type: SET_TRIP_TYPE_SELECTED,
    type_id: "",
  });
  dispatch({
    type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS,
    trip_destination_id: [],
  });
  dispatch({
    type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
    trip_auth_status: "",
  });
  dispatch({
    type: SET_TIMELINE_ACTIVE_TRIP_IMAGE,
    trip_image: "",
  });
  dispatch({
    type: SET_LEAVING_FROM_AIRPORT_SELECTED,
    airport_selected: null,
  });
  dispatch({
    type: SET_RETURNING_TO_AIRPORT_SELECTED,
    airport_selected: null,
  });
  dispatch({
    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
    activities: [],
  });
  Cookies.remove("muv_active_trip");
};

export const setTimelineWizardDeleteAlartStatus = (status) => (dispatch) => {
  dispatch({
    type: SET_TIMELINE_WIZARD_DELETE_ALART_STATUS,
    status: status,
  });
};

export const syncTripCostTimelineWizard =
  (trip, uuid_auth) => async (dispatch) => {
    const uuid = uuid_auth === "" ? "TMPUUID" : uuid_auth;
    const url_active_trip_get_cost =
      environment.apiUrl +
      "timeline/getTripCost/en/" +
      uuid +
      "?tripId=" +
      trip.tripId +
      "&getTripCost";
    dispatch({
      type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
      status: true,
    });
    GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
      if (responseTripCost.statusText === "OK") {
        dispatch({
          type: SET_TIMELINE_ACTIVE_TRIP_COST,
          trip_cost: responseTripCost.data.result,
        });

        dispatch({
          type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
          status: false,
        });
      } else {
        console.log("no permission");
      }
    });
  };


export const setTimelineTripDestinationStatus =
  (openStatus) =>
    (dispatch) => {

      dispatch({
        type: SET_TIMELINE_TRIP_DESTINATIONS_STATUS,
        status: openStatus
      });
    };


export const setTimelineTripDestinationOpenStatus =
  (tripDestinationId = "", closeOthers = "", destination) =>
    (dispatch) => {
      closeOthers === "CLOSEOTHERS" &&
        dispatch({
          type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
          trip_destination_id: tripDestinationId,
        });
      closeOthers === "OPENSELECTED" &&
        dispatch({
          type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_OPEN_SELECTED,
          trip_destination_id: tripDestinationId,
        });
      closeOthers === "CLOSEALL" &&
        dispatch({
          type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_ALL,
        });
      closeOthers === "" &&
        dispatch({
          type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS,
          trip_destination_id: tripDestinationId,
        });
      dispatch({
        type: SET_ACTIVE_TRIP_DESTINATION,
        trip_destination_id: tripDestinationId,
        destination_id: destination?.id || destination?.td_id,
      });
    };

export const swrapTripDestinatinInTrip =
  (tripDestinationDragObject, tripDestinationDropObject) =>
    async (dispatch) => {
      dispatch({
        type: SWRAP_TRIP_DESTINATION_IN_TRIP,
        trip_destination_drag_object: tripDestinationDragObject,
        trip_destination_drop_object: tripDestinationDropObject,
      });

      /* update api */
    };
export const dragDropTripDestinatinInTrip =
  (lang, uuid, destinationsRearrange, tripId) => async (dispatch) => {
    const trip_destination_ids = Array.from(
      new Set(destinationsRearrange.map((d) => d.td_id))
    );
    if (uuid !== "") {
      let obj = {
        lang: lang,
        uuid: uuid,
        tripDestination: trip_destination_ids,
      };
      let api_url =
        environment.apiUrl +
        "timeline/updateTripDestinationPosition/" +
        lang +
        "/" +
        uuid;
      PostAsyncHelper(api_url, obj).then((responseDestinations) => {
        if (responseDestinations.statusText === "OK") {
          const destinations = responseDestinations.data.result;

          dispatch({
            type: DRAG_DROP_TRIP_DESTINATION_IN_TRIP,
            trip_destinations_rearrange: destinations,
          });

          dispatch({
            type: ALERT_BARS_HANDLE,
            message_type: "success",
            message: "Saved",
          });
          const url_active_trip_get_cost =
            environment.apiUrl +
            "timeline/getTripCost/en/" +
            uuid +
            "?tripId=" +
            tripId +
            "&getTripCost";
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
            status: true,
          });
          GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
            if (responseTripCost.statusText === "OK") {
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_COST,
                trip_cost: responseTripCost.data.result,
              });
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                status: false,
              });
            } else {
              console.log("no permission");
            }
          });
          const fetch_active_trip_activities_api_url =
            environment.apiUrl +
            "timeline/getTripActivities/" +
            lang +
            "/" +
            uuid +
            "?tripId=" +
            tripId +
            "&getTripActivities";

          GetAsyncHelper(fetch_active_trip_activities_api_url).then(
            (responseTripActivities) => {
              if (responseTripActivities.statusText === "OK") {
                dispatch({
                  type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                  activities: responseTripActivities.data.result,
                });
                dispatch({
                  type: ALERT_BARS_HANDLE,
                  message_type: "success",
                  message: "saved",
                });
              } else {
                console.log("no permission");
              }
            }
          );
        }
      });
    }
  };

export const addGoogleDestinatinInTrip =
  (
    lang,
    uuid,
    destination,
    tripId,
    tripDuration,
    previousDestinationId,
    latitude,
    longitude,
    duration = 3
  ) =>
    async (dispatch) => {
      if (uuid !== "") {
        let obj = {
          lang: lang,
          uuid: uuid,
          tripId: parseInt(tripId),
          duration: parseInt(tripDuration),
          googlePlaceId: destination.googlePlaceId,
          googlePlaceLatitude: `${latitude}`,
          googlePlaceLongitude: `${longitude}`,
          googlePlaceName: destination.googlePlaceName,
          googlePlaceCity: destination.googlePlaceCity,
          googlePlaceState: destination.googlePlaceState,
          googlePlaceCountry: destination.googlePlaceCountry,
        };

        let api_url =
          environment.apiUrl +
          "timeline/addCustomTripDestination/" +
          lang +
          "/" +
          uuid +
          "?action=addTripDestination";
        PostAsyncHelper(api_url, obj).then((responseDestinations) => {
          if (responseDestinations.statusText === "OK") {
            const destinations = responseDestinations.data.result;
            const destinationsLength = responseDestinations.data.result.length;
            //console.log("Getting result from backend : ")
            //console.log(destinations)
            //console.log(destinationsLength)
            dispatch({
              type: UPDATE_TRIP_DESTINATION_IN_TRIP,
              trip_destinations_rearrange: destinations,
            });
            dispatch({
              type: ADD_TRIP_DESTINATION_IN_TRIP_OPEN_STATUS,
              trip_destination_open_status: {
                tripDestinationId: destinations[destinationsLength - 1].td_id,
                openStatus: true,
              },
            });
            dispatch({
              type: SET_ACTIVE_TRIP_DESTINATION,
              trip_destination_id: destinations[destinationsLength - 1].td_id,
              destination_id: destinations[destinationsLength - 1].id,
            });
            dispatch({
              type: SET_ACTIVE_DAY_IN_TRIP,
              trip_destination_id: destinations[destinationsLength - 1].td_id,
              day_in_trip: destinations[destinationsLength - 1].startingDayInTrip,
              day_in_trip_destination: "1",
            });
            //update trip duration
            const diffTripdays =
              previousDestinationId === destination.destinationId
                ? duration
                : Number(duration) - 1;
            const obj_trip_duration = {
              lang: lang,
              uuid: uuid,
              duration: Number(tripDuration) + Number(diffTripdays),
              tripId: tripId,
            };
            const api_url_update_trip_duration =
              environment.apiUrl +
              "timeline/updateTripDuration/" +
              lang +
              "/" +
              uuid;
            PostAsyncHelper(api_url_update_trip_duration, obj_trip_duration).then(
              (responseTripDuration) => {
                responseTripDuration.statusText === "OK" &&
                  dispatch({
                    type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
                    trip_duration: Number(tripDuration) + Number(diffTripdays),
                  });
              }
            );
            const url_active_trip_get_cost =
              environment.apiUrl +
              "timeline/getTripCost/en/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripCost";
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
              status: true,
            });
            GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
              if (responseTripCost.statusText === "OK") {
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_COST,
                  trip_cost: responseTripCost.data.result,
                });
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                  status: false,
                });
              } else {
                console.log("no permission");
              }
            });
            dispatch({
              type: ALERT_BARS_HANDLE,
              message_type: "success",
              message: destination.name + " Saved",
            });
          }
        });
      }
    };

export const addTripDestinatinInTrip =
  (
    lang,
    uuid,
    destination,
    tripId,
    tripDuration,
    previousDestinationId,
    duration = 1
  ) =>
    async (dispatch) => {
      if (uuid !== "") {
        let obj = {
          lang: lang,
          uuid: uuid,
          destinationId: destination.destinationId,
          tripId: tripId,
          // duration: duration,
        };
        let api_url =
          environment.apiUrl +
          "timeline/addTripDestination/" +
          lang +
          "/" +
          uuid +
          "?action=addTripDestination";
        PostAsyncHelper(api_url, obj).then((responseDestinations) => {
          if (responseDestinations.statusText === "OK") {
            const destinations = responseDestinations.data.result;
            const destinationsLength = responseDestinations.data.result.length;
            dispatch({
              type: UPDATE_TRIP_DESTINATION_IN_TRIP,
              trip_destinations_rearrange: destinations,
            });
            dispatch({
              type: ADD_TRIP_DESTINATION_IN_TRIP_OPEN_STATUS,
              trip_destination_open_status: {
                tripDestinationId: destinations[destinationsLength - 1].td_id,
                openStatus: true,
              },
            });
            dispatch({
              type: SET_ACTIVE_TRIP_DESTINATION,
              trip_destination_id: destinations[destinationsLength - 1].td_id,
              destination_id: destinations[destinationsLength - 1].id,
            });
            dispatch({
              type: SET_ACTIVE_DAY_IN_TRIP,
              trip_destination_id: destinations[destinationsLength - 1].td_id,
              day_in_trip: destinations[destinationsLength - 1].startingDayInTrip,
              day_in_trip_destination: "1",
            });
            /* update trip duration */
            const diffTripdays =
              previousDestinationId === destination.destinationId
                ? duration
                : Number(duration) - 1;
            const obj_trip_duration = {
              lang: lang,
              uuid: uuid,
              // duration: (Number(tripDuration) + Number(diffTripdays)),
              tripId: tripId,
            };

            dispatch(setTripToTimeline(tripId, uuid));
            // const api_url_update_trip_duration = environment.apiUrl +'timeline/updateTripDuration/' + lang + '/' + uuid
            // PostAsyncHelper(api_url_update_trip_duration, obj_trip_duration).then(responseTripDuration => {
            //     responseTripDuration.statusText === "OK" && dispatch({
            //         type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
            //         trip_duration: (Number(tripDuration) + Number(diffTripdays)),
            //     })
            // })
            // const url_active_trip_get_cost = environment.apiUrl +"timeline/getTripCost/en/" + uuid + "?tripId=" + tripId + "&getTripCost"
            // dispatch({
            //     type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
            //     status: true
            // })
            // GetAsyncHelper(url_active_trip_get_cost).then(responseTripCost => {
            //     if (responseTripCost.statusText === "OK") {
            //         dispatch({
            //             type: SET_TIMELINE_ACTIVE_TRIP_COST,
            //             trip_cost: responseTripCost.data.result
            //         })
            //         dispatch({
            //             type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
            //             status: false
            //         })

            //     } else {
            //         console.log("no permission")
            //     }
            // })
            dispatch({
              type: SET_TIMELINE_WIZARD_STATUS,
              status: true,
            });
            dispatch({
              type: ALERT_BARS_HANDLE,
              message_type: "success",
              message: destination.name + " Saved",
            });
          }
        });
      }
    };
export const deleteTripDestinationInTrip =
  (lang, uuid, tripDestination, tripId, tripDuration) => async (dispatch) => {
    if (uuid !== "") {
      let obj = {
        lang: lang,
        uuid: uuid,
        tripDestinationId: tripDestination.td_id,
      };
      let api_url =
        environment.apiUrl +
        "timeline/removeTripDestination/" +
        lang +
        "/" +
        uuid;
      PostAsyncHelper(api_url, obj).then((responseDestinations) => {
        if (responseDestinations.statusText === "OK") {
          dispatch({
            type: UPDATE_TRIP_DESTINATION_IN_TRIP,
            trip_destinations_rearrange: responseDestinations.data.result,
          });
          dispatch({
            type: DELETE_TRIP_DESTINATION_IN_TRIP_OPEN_STATUS,
            trip_destination_id: tripDestination.td_id,
          });
          /* update trip duration */
          const obj_trip_duration = {
            lang: lang,
            uuid: uuid,
            duration: Number(tripDuration) - (tripDestination.duration - 1),
            tripId: tripId,
          };
          const api_url_update_trip_duration =
            environment.apiUrl +
            "timeline/updateTripDuration/" +
            lang +
            "/" +
            uuid;
          PostAsyncHelper(api_url_update_trip_duration, obj_trip_duration).then(
            (responseTripDuration) => {
              responseTripDuration.statusText === "OK" &&
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
                  trip_duration:
                    Number(tripDuration) - (tripDestination.duration - 1),
                });
            }
          );
          const url_active_trip_get_cost =
            environment.apiUrl +
            "timeline/getTripCost/en/" +
            uuid +
            "?tripId=" +
            tripId +
            "&getTripCost";
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
            status: true,
          });
          GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
            if (responseTripCost.statusText === "OK") {
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_COST,
                trip_cost: responseTripCost.data.result,
              });
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                status: false,
              });
            } else {
              console.log("no permission");
            }
          });
          const fetch_active_trip_activities_api_url =
            environment.apiUrl +
            "timeline/getTripActivities/" +
            lang +
            "/" +
            uuid +
            "?tripId=" +
            tripId +
            "&getTripActivities";

          GetAsyncHelper(fetch_active_trip_activities_api_url).then(
            (responseTripActivities) => {
              if (responseTripActivities.statusText === "OK") {
                dispatch({
                  type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                  activities: responseTripActivities.data.result,
                });
                dispatch({
                  type: ALERT_BARS_HANDLE,
                  message_type: "success",
                  message: "saved",
                });
              } else {
                console.log("no permission");
              }
            }
          );
          dispatch({
            type: ALERT_BARS_HANDLE,
            message_type: "success",
            message: tripDestination.name + " deleted",
          });
        }
      });
    }
  };
export const addDayToTripDestinationInTrip =
  (lang, uuid, tripDestination, tripId, tripDuration) => async (dispatch) => {
    if (uuid !== "") {
      let obj = {
        lang: lang,
        uuid: uuid,
        tripDestinationId: tripDestination.td_id,
      };
      let api_url =
        environment.apiUrl +
        "timeline/addDayToTripDestination/" +
        lang +
        "/" +
        uuid;
      PostAsyncHelper(api_url, obj).then((responseDestinations) => {
        if (responseDestinations.statusText === "OK") {
          dispatch({
            type: UPDATE_TRIP_DESTINATION_IN_TRIP,
            trip_destinations_rearrange: responseDestinations.data.result,
          });
          /* update trip duration */
          const obj_trip_duration = {
            lang: lang,
            uuid: uuid,
            // duration: (Number(tripDuration) + 1),
            tripId: tripId,
          };
          const api_url_update_trip_duration =
            environment.apiUrl +
            "timeline/updateTripDuration/" +
            lang +
            "/" +
            uuid;
          PostAsyncHelper(api_url_update_trip_duration, obj_trip_duration).then(
            (responseTripDuration) => {
              responseTripDuration.statusText === "OK" &&
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
                  trip_duration: Number(tripDuration) + 1,
                });
            }
          );

          dispatch({
            type: ALERT_BARS_HANDLE,
            message_type: "success",
            message: tripDestination.name + " saved",
          });
        }
      });
    }
  };

export const deleteDayFromTripDestinationInTrip =
  (
    lang,
    uuid,
    tripDestination,
    tripId,
    tripDuration,
    dayInTripDestination,
    activeDay
  ) =>
    async (dispatch) => {
      if (uuid !== "" && Number(tripDuration) - 1 > 0) {
        let obj = {
          lang: lang,
          uuid: uuid,
          tripDestinationId: tripDestination.td_id,
          dayInDestination: dayInTripDestination,
        };
        let api_url =
          environment.apiUrl + "timeline/removeDay/" + lang + "/" + uuid;
        PostAsyncHelper(api_url, obj).then((responseDestinations) => {
          if (responseDestinations.statusText === "OK") {
            const fetch_active_trip_activities_api_url =
              environment.apiUrl +
              "timeline/getTripActivities/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripActivities";

            GetAsyncHelper(fetch_active_trip_activities_api_url).then(
              (responseTripActivities) => {
                if (responseTripActivities.statusText === "OK") {
                  dispatch({
                    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                    activities: responseTripActivities.data.result,
                  });
                } else {
                  console.log("no permission");
                }
              }
            );
            const url_active_trip_get_destinations =
              environment.apiUrl +
              "timeline/getTripDestinations/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripDestinations";
            GetAsyncHelper(url_active_trip_get_destinations).then(
              (responseTripDestinations) => {
                if (responseTripDestinations.statusText === "OK") {
                  dispatch({
                    type: UPDATE_TRIP_DESTINATION_IN_TRIP,
                    trip_destinations_rearrange: responseTripDestinations.data,
                  });
                } else {
                  console.log("no permission");
                }
              }
            );

            /* update trip duration */
            const obj_trip_duration = {
              lang: lang,
              uuid: uuid,
              duration: Number(tripDuration) - 1,
              tripId: tripId,
            };
            const api_url_update_trip_duration =
              environment.apiUrl +
              "timeline/updateTripDuration/" +
              lang +
              "/" +
              uuid;
            PostAsyncHelper(api_url_update_trip_duration, obj_trip_duration).then(
              (responseTripDuration) => {
                responseTripDuration.statusText === "OK" &&
                  dispatch({
                    type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
                    trip_duration: Number(tripDuration) - 1,
                  });
              }
            );
            dispatch({
              type: ALERT_BARS_HANDLE,
              message_type: "success",
              message: "saved",
            });
          }
        });
        activeDay.tripDestinationId === tripDestination.td_id &&
          activeDay.dayInTripDestination !== "1" &&
          Number(activeDay.dayInTripDestination) >=
          Number(dayInTripDestination) &&
          dispatch({
            type: SET_ACTIVE_DAY_IN_TRIP,
            trip_destination_id: activeDay.tripDestinationId,
            day_in_trip: String(Number(activeDay.dayInTrip) - 1),
            day_in_trip_destination: String(
              Number(activeDay.dayInTripDestination) - 1
            ),
          });
      }
    };

export const setActiveTripDestinationId =
  (destination, dayInTrip = "", dayInTripDestination = "") =>
    (dispatch) => {
      dispatch({
        type: SET_ACTIVE_TRIP_DESTINATION,
        trip_destination_id: destination.td_id,
        destination_id: destination.id,
      });
      if (dayInTrip === "") {
        const destinationDays =
          destination.spanningDays !== undefined &&
          destination.spanningDays.split(",");
        const destinationLastDayInTrip =
          destinationDays[destinationDays.length - 1];
        const destinationLastDayInTripDestination = String(
          destinationDays.length
        );
        dispatch({
          type: SET_ACTIVE_DAY_IN_TRIP,
          trip_destination_id: destination.td_id,
          day_in_trip: destinationLastDayInTrip,
          day_in_trip_destination: destinationLastDayInTripDestination,
        });
      } else {
        dispatch({
          type: SET_ACTIVE_DAY_IN_TRIP,
          trip_destination_id: destination.td_id,
          day_in_trip: dayInTrip,
          day_in_trip_destination: dayInTripDestination,
        });
      }
    };
export const setTimelineDraggingEstablishment =
  (establishment, destinationId) => (dispatch) => {
    dispatch({
      type: SET_TIMELINE_WIZARD_DRAGGING_ESTABLISHMENT,
      dragging_establisment: establishment,
      destination_id: destinationId,
    });
  };
export const setTimelineDraggingActivity =
  (
    dragActivityIndexInDay,
    dragActivityInDestination,
    dragDeleteActivity,
    activity,
    dragActivityIdsInDay
  ) =>
    (dispatch) => {
      dispatch({
        type: SET_TIMELINE_WIZARD_DRAGGING_ACTIVITY,
        dragging_activity_index_in_day: dragActivityIndexInDay,
        dragging_activity_in_destination: dragActivityInDestination,
        drag_delete_activity: dragDeleteActivity,
        dragging_activity: activity,
        drag_ctivity_ids_in_day: dragActivityIdsInDay,
      });
    };

export const setActiveDayInTrip =
  (tripDestinationId, dayInTrip, dayInTripDestination, destinationId) =>
    (dispatch) => {
      dispatch({
        type: SET_ACTIVE_DAY_IN_TRIP,
        trip_destination_id: tripDestinationId,
        day_in_trip: dayInTrip,
        day_in_trip_destination: dayInTripDestination,
      });
      dispatch({
        type: SET_ACTIVE_TRIP_DESTINATION,
        trip_destination_id: tripDestinationId,
        destination_id: destinationId,
      });
      dispatch({
        type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
        trip_destination_id: tripDestinationId,
      });
    };

export const fetchActiveTripFromCookies =
  (urlDestinationId, lang, timeline_status = true) =>
    (dispatch) => {
      const muv_token = Cookies.get("muv_token");
      const muv_active_trip = Cookies.get("muv_active_trip");
      if (muv_active_trip !== undefined && muv_active_trip !== "") {
        if (muv_token === undefined) {
          // console.log("no login")
          const url_get =
            environment.apiUrl +
            "timeline/getTripInfo/en/TMPUUID?tripId=" +
            muv_active_trip +
            "&getTripInfo";
          GetAsyncHelper(url_get).then((responseTrip) => {
            if (responseTrip.statusText === "OK") {
              const trip = responseTrip.data.result;
              dispatch(updateActiveTrip(trip));
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_ID,
                trip_id: trip.tripID,
              });
              console.log("here", trip);

              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_NAME,
                trip_name: trip.tripName,
              });

              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_START_DATE,
                trip_start_date:
                  trip.noDate === "0" ? trip.tripStartDate : "0000-00-00",
              });

              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
                trip_no_date: trip.noDate,
              });

              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
                trip_duration: trip.tripDaysCount,
              });
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
                trip_description: trip.tripDescription,
              });
              dispatch({
                type: SET_TRIP_TYPE_SELECTED,
                type_id: trip.typeId,
              });
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
                trip_auth_status: trip.isPublic,
              });
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_IMAGE,
                trip_image: trip.headerImage,
              });
              dispatch({
                type: SET_LEAVING_FROM_AIRPORT_SELECTED,
                airport_selected: trip.leavingFromAirport,
              });
              dispatch({
                type: SET_RETURNING_TO_AIRPORT_SELECTED,
                airport_selected: trip.returningToAirport,
              });
              // timeline_status && dispatch({
              //     type: SET_TIMELINE_WIZARD_STATUS,
              //     status: true
              // })
            } else {
              console.log("no permission");
            }
          });
          const url_active_trip_get_cost =
            environment.apiUrl +
            "timeline/getTripCost/en/TMPUUID?tripId=" +
            muv_active_trip +
            "&getTripCost";
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
            status: true,
          });
          GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
            if (responseTripCost.statusText === "OK") {
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_COST,
                trip_cost: responseTripCost.data.result,
              });
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                status: false,
              });
            } else {
              console.log("no permission");
            }
          });

          const fetch_active_trip_activities_api_url =
            environment.apiUrl +
            "timeline/getTripActivities/en/TMPUUID?tripId=" +
            muv_active_trip +
            "&getTripActivities";

          GetAsyncHelper(fetch_active_trip_activities_api_url).then(
            (responseTripActivities) => {
              if (responseTripActivities.statusText === "OK") {
                dispatch({
                  type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                  activities: responseTripActivities.data.result,
                });
              } else {
                console.log("no permission");
              }
            }
          );
          const url_active_trip_get_destinations =
            environment.apiUrl +
            "timeline/getTripDestinations/" +
            lang +
            "/TMPUUID?tripId=" +
            muv_active_trip +
            "&getTripDestinations";
          GetAsyncHelper(url_active_trip_get_destinations).then(
            (responseTripDestinations) => {
              if (responseTripDestinations.statusText === "OK") {
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
                  trip_destinations: responseTripDestinations.data,
                });
                const destinations = responseTripDestinations.data;
                const idsDestinations = Array.from(
                  new Set(destinations.map((d) => d.id))
                );
                if (
                  idsDestinations.find((id) => id === urlDestinationId) ===
                  undefined
                ) {
                  // console.log("destination isn't the timeline tripdestination")
                  destinations.length > 0 &&
                    destinations[destinations.length - 1] !== undefined &&
                    dispatch({
                      type: SET_ACTIVE_TRIP_DESTINATION,
                      trip_destination_id:
                        destinations[destinations.length - 1].td_id,
                      destination_id: destinations[destinations.length - 1].id,
                    });
                  if (
                    destinations.length > 0 &&
                    destinations[destinations.length - 1] !== undefined
                  ) {
                    const destinationDays =
                      destinations[destinations.length - 1].spanningDays !==
                      undefined &&
                      destinations[destinations.length - 1].spanningDays.split(
                        ","
                      );
                    const destinationLastDayInTrip = destinationDays[0];
                    const destinationLastDayInTripDestination = String(1);
                    dispatch({
                      type: SET_ACTIVE_DAY_IN_TRIP,
                      trip_destination_id:
                        destinations[destinations.length - 1].td_id,
                      day_in_trip: destinationLastDayInTrip,
                      day_in_trip_destination:
                        destinationLastDayInTripDestination,
                    });
                  }
                  destinations.length > 0 &&
                    destinations[destinations.length - 1] !== undefined &&
                    dispatch({
                      type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
                      trip_destination_id:
                        destinations[destinations.length - 1].td_id,
                    });
                } else {
                  // console.log("destination is the timeline tripdestination")
                  const destinationFound = destinations.filter(
                    (d) => d.id === urlDestinationId
                  );
                  destinationFound !== undefined &&
                    destinationFound.length > 0 &&
                    destinationFound[0] !== undefined &&
                    dispatch({
                      type: SET_ACTIVE_TRIP_DESTINATION,
                      trip_destination_id: destinationFound[0].td_id,
                      destination_id: destinationFound[0].id,
                    }) &&
                    dispatch({
                      type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
                      trip_destination_id: destinationFound[0].td_id,
                    });
                  if (
                    destinationFound !== undefined &&
                    destinationFound.length > 0 &&
                    destinationFound[0] !== undefined
                  ) {
                    const destinationDays =
                      destinationFound[0].spanningDays !== undefined &&
                      destinationFound[0].spanningDays.split(",");
                    const destinationLastDayInTrip = destinationDays[0];
                    const destinationLastDayInTripDestination = String(1);
                    dispatch({
                      type: SET_ACTIVE_DAY_IN_TRIP,
                      trip_destination_id: destinationFound[0].td_id,
                      day_in_trip: destinationLastDayInTrip,
                      day_in_trip_destination:
                        destinationLastDayInTripDestination,
                    });
                  }
                }
              } else {
                console.log("no permission");
              }
            }
          );
        } else {
          // console.log("logined")

          const api_url_token =
            environment.apiUrl + "membertoken?token=" + muv_token;
          PostAsyncHelper(api_url_token).then((responseToken) => {
            const member = responseToken?.data?.message;
            const uuid = member?.memberRestUUID;
            const url_active_trip_get =
              environment.apiUrl +
              "timeline/getTripInfo/en/" +
              uuid +
              "?tripId=" +
              muv_active_trip +
              "&getTripInfo";
            GetAsyncHelper(url_active_trip_get).then((responseTrip) => {
              if (responseTrip.statusText === "OK") {
                const trip = responseTrip.data.result;

                dispatch(updateActiveTrip(trip));
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_ID,
                  trip_id: trip.tripID,
                });

                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_NAME,
                  trip_name: trip.tripName,
                });

                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_START_DATE,
                  trip_start_date:
                    trip.noDate === "0" ? trip.tripStartDate : "0000-00-00",
                });

                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
                  trip_no_date: trip.noDate,
                });

                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
                  trip_duration: trip.tripDaysCount,
                });
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
                  trip_description: trip.tripDescription,
                });
                dispatch({
                  type: SET_TRIP_TYPE_SELECTED,
                  type_id: trip.typeId,
                });
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
                  trip_auth_status: trip.isPublic,
                });
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_IMAGE,
                  trip_image: trip.headerImage,
                });
                dispatch({
                  type: SET_LEAVING_FROM_AIRPORT_SELECTED,
                  airport_selected: trip.leavingFromAirport,
                });
                dispatch({
                  type: SET_RETURNING_TO_AIRPORT_SELECTED,
                  airport_selected: trip.returningToAirport,
                });
                // timeline_status && dispatch({
                //     type: SET_TIMELINE_WIZARD_STATUS,
                //     status: true
                // })
              } else {
                console.log("no permission");
              }
            });
            const url_active_trip_get_cost =
              environment.apiUrl +
              "timeline/getTripCost/en/" +
              uuid +
              "?tripId=" +
              muv_active_trip +
              "&getTripCost";
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
              status: true,
            });
            GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
              if (responseTripCost.statusText === "OK") {
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_COST,
                  trip_cost: responseTripCost.data.result,
                });
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                  status: false,
                });
              } else {
                console.log("no permission");
              }
            });
            const fetch_active_trip_activities_api_url =
              environment.apiUrl +
              "timeline/getTripActivities/en/" +
              uuid +
              "?tripId=" +
              muv_active_trip +
              "&getTripActivities";
            GetAsyncHelper(fetch_active_trip_activities_api_url).then(
              (responseTripActivities) => {
                if (responseTripActivities.statusText === "OK") {
                  dispatch({
                    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                    activities: responseTripActivities.data.result,
                  });
                } else {
                  console.log("no permission");
                }
              }
            );

            const url_active_trip_get_destinations =
              environment.apiUrl +
              "timeline/getTripDestinations/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              muv_active_trip +
              "&getTripDestinations";
            GetAsyncHelper(url_active_trip_get_destinations).then(
              (responseTripDestinations) => {
                if (responseTripDestinations.statusText === "OK") {
                  dispatch({
                    type: SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
                    trip_destinations: responseTripDestinations.data,
                  });
                  const destinations = responseTripDestinations.data;
                  const idsDestinations = Array.from(
                    new Set(destinations.map((d) => d.id))
                  );
                  if (
                    idsDestinations.find((id) => id === urlDestinationId) ===
                    undefined
                  ) {
                    // console.log("destination isn't the timeline tripdestination")
                    destinations.length > 0 &&
                      destinations[destinations.length - 1] !== undefined &&
                      dispatch({
                        type: SET_ACTIVE_TRIP_DESTINATION,
                        trip_destination_id:
                          destinations[destinations.length - 1].td_id,
                        destination_id: destinations[destinations.length - 1].id,
                      });
                    if (
                      destinations.length > 0 &&
                      destinations[destinations.length - 1] !== undefined
                    ) {
                      const destinationDays =
                        destinations[destinations.length - 1].spanningDays !==
                        undefined &&
                        destinations[destinations.length - 1].spanningDays.split(
                          ","
                        );
                      const destinationLastDayInTrip = destinationDays[0];
                      const destinationLastDayInTripDestination = String(1);
                      dispatch({
                        type: SET_ACTIVE_DAY_IN_TRIP,
                        trip_destination_id:
                          destinations[destinations.length - 1].td_id,
                        day_in_trip: destinationLastDayInTrip,
                        day_in_trip_destination:
                          destinationLastDayInTripDestination,
                      });
                    }
                    destinations.length > 0 &&
                      destinations[destinations.length - 1] !== undefined &&
                      dispatch({
                        type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
                        trip_destination_id:
                          destinations[destinations.length - 1].td_id,
                      });
                  } else {
                    // console.log("destination is the timeline tripdestination")
                    const destinationFound = destinations.filter(
                      (d) => d.id === urlDestinationId
                    );
                    destinationFound !== undefined &&
                      destinationFound.length > 0 &&
                      destinationFound[0] !== undefined &&
                      dispatch({
                        type: SET_ACTIVE_TRIP_DESTINATION,
                        trip_destination_id: destinationFound[0].td_id,
                        destination_id: destinationFound[0].id,
                      }) &&
                      dispatch({
                        type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
                        trip_destination_id: destinationFound[0].td_id,
                      });
                    if (
                      destinationFound !== undefined &&
                      destinationFound.length > 0 &&
                      destinationFound[0] !== undefined
                    ) {
                      const destinationDays =
                        destinationFound[0].spanningDays !== undefined &&
                        destinationFound[0].spanningDays.split(",");
                      const destinationLastDayInTrip = destinationDays[0];
                      const destinationLastDayInTripDestination = String(1);

                      dispatch({
                        type: SET_ACTIVE_DAY_IN_TRIP,
                        trip_destination_id: destinationFound[0].td_id,
                        day_in_trip: destinationLastDayInTrip,
                        day_in_trip_destination:
                          destinationLastDayInTripDestination,
                      });
                    }
                  }
                } else {
                  console.log("no permission");
                }
              }
            );
          });
        }
      }
    };

export const addActivityToDayOfTripDestinationInTrip =
  (
    lang,
    uuid,
    tripDestinationId,
    dayInTripDestination,
    establishmentId,
    tripId,
    activityId = ""
  ) =>
    async (dispatch) => {
      if (uuid !== "") {
        let obj = {
          lang: lang,
          uuid: uuid,
          tripDestinationId: tripDestinationId,
          dayInDestination: dayInTripDestination,
          placeId: establishmentId,
          afterActivityId: activityId,
        };
        let api_url =
          environment.apiUrl + "timeline/addActivity/" + lang + "/" + uuid;
        PostAsyncHelper(api_url, obj).then((responseActivity) => {
          if (responseActivity.statusText === "OK") {
            const fetch_active_trip_activities_api_url =
              environment.apiUrl +
              "timeline/getTripActivities/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripActivities";

            GetAsyncHelper(fetch_active_trip_activities_api_url).then(
              (responseTripActivities) => {
                if (responseTripActivities.statusText === "OK") {
                  dispatch({
                    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                    activities: responseTripActivities.data.result,
                  });
                  dispatch({
                    type: ALERT_BARS_HANDLE,
                    message_type: "success",
                    message: "saved",
                  });
                } else {
                  console.log("no permission");
                }
              }
            );
          }
        });
      }
    };

export const updateTimelineActivity =
  (
    lengthOfStay,
    customPlaceNameByUser,
    customPlaceNameByGoogle,
    googlePlaceId,
    googlePlaceLatitude,
    googlePlaceLongitude,
    googlePlaceCity,
    googlePlaceState,
    googlePlaceCountry,
    googlePlaceFormattedAddress,
    lang,
    uuid,
    activityId,
    dayInDestination,
    tripId,
    startTime
  ) =>
    async (dispatch) => {
      const obj = {
        lengthOfStay: lengthOfStay,
        customPlaceNameByUser: customPlaceNameByUser,
        customPlaceNameByGoogle: customPlaceNameByGoogle,
        googlePlaceId: googlePlaceId,
        googlePlaceLatitude: googlePlaceLatitude,
        googlePlaceLongitude: googlePlaceLongitude,
        googlePlaceCity: googlePlaceCity,
        googlePlaceState: googlePlaceState,
        googlePlaceCountry: googlePlaceCountry,
        googlePlaceFormattedAddress: googlePlaceFormattedAddress,
        dayInDestination: dayInDestination,
        activityId: activityId,
        startTime: startTime,
        //forceTest: true
      };
      if (uuid !== "") {
        let api_url = environment.apiUrl + "timeline/updateActivity/" + uuid;
        //console.log("addCustomActivityToDayOfTripDestinationInTrip")
        //console.log(api_url)
        //console.log(obj)
        PostAsyncHelper(api_url, obj).then((responseCustom) => {
          //console.log("Post Response: ")
          //console.log(responseCustom)
          if (responseCustom.statusText === "OK") {
            const fetch_active_trip_activities_api_url =
              environment.apiUrl +
              "timeline/getTripActivities/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripActivities";

            GetAsyncHelper(fetch_active_trip_activities_api_url).then(
              (responseTripActivities) => {
                if (responseTripActivities.statusText === "OK") {
                  //console.log("After Post:  GET Response data result: ")
                  //console.log(responseTripActivities.data.result)
                  dispatch({
                    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                    activities: responseTripActivities.data.result,
                  });

                  dispatch({
                    type: SET_SEARCH_ADDRESS_SELECTED,
                    address_selected: null,
                  });

                  dispatch({
                    type: SET_SEARCH_PLACE_SELECTED,
                    place_selected: null,
                  });

                  dispatch({
                    type: ALERT_BARS_HANDLE,
                    message_type: "success",
                    message: "saved",
                  });
                } else {
                  console.log("no permission");
                }
              }
            );
          }
        });
      }
    };

export const addCustomActivityToDayOfTripDestinationInTrip =
  (
    lengthOfStay,
    customPlaceNameByUser,
    customPlaceNameByGoogle,
    googlePlaceId,
    googlePlaceLatitude,
    googlePlaceLongitude,
    googlePlaceCity,
    googlePlaceState,
    googlePlaceCountry,
    googlePlaceFormattedAddress,
    lang,
    uuid,
    tripDestinationId,
    dayInDestination,
    tripId
  ) =>
    async (dispatch) => {
      const obj = {
        lengthOfStay: lengthOfStay,
        customPlaceNameByUser: customPlaceNameByUser,
        customPlaceNameByGoogle: customPlaceNameByGoogle,
        googlePlaceId: googlePlaceId,
        googlePlaceLatitude: googlePlaceLatitude,
        googlePlaceLongitude: googlePlaceLongitude,
        googlePlaceCity: googlePlaceCity,
        googlePlaceState: googlePlaceState,
        googlePlaceCountry: googlePlaceCountry,
        googlePlaceFormattedAddress: googlePlaceFormattedAddress,
        lang: lang,
        uuid: uuid,
        tripDestinationId: tripDestinationId,
        dayInDestination: dayInDestination,
        tripId: tripId,
        //forceTest: true
      };
      if (uuid !== "") {
        let api_url =
          environment.apiUrl + "timeline/addCustomActivity/" + lang + "/" + uuid;
        //console.log("addCustomActivityToDayOfTripDestinationInTrip")
        //console.log(api_url)
        //console.log(obj)
        PostAsyncHelper(api_url, obj).then((responseCustom) => {
          //console.log("Post Response: ")
          //console.log(responseCustom)
          if (responseCustom.statusText === "OK") {
            const fetch_active_trip_activities_api_url =
              environment.apiUrl +
              "timeline/getTripActivities/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripActivities";

            GetAsyncHelper(fetch_active_trip_activities_api_url).then(
              (responseTripActivities) => {
                if (responseTripActivities.statusText === "OK") {
                  //console.log("After Post:  GET Response data result: ")
                  //console.log(responseTripActivities.data.result)
                  dispatch({
                    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                    activities: responseTripActivities.data.result,
                  });

                  dispatch({
                    type: SET_SEARCH_ADDRESS_SELECTED,
                    address_selected: null,
                  });

                  dispatch({
                    type: SET_SEARCH_PLACE_SELECTED,
                    place_selected: null,
                  });

                  dispatch({
                    type: ALERT_BARS_HANDLE,
                    message_type: "success",
                    message: "saved",
                  });
                } else {
                  console.log("no permission");
                }
              }
            );
          }
        });
      }
    };

export const addActivityInActivitiesOfTripDestinationInTrip =
  (
    lang,
    uuid,
    tripDestinationId,
    dayInTripDestination,
    establishmentId,
    tripId,
    activityId = "",
    toDayInDestination,
    fromDayInDestination,
    activitiesInDestinationDayIds,
    indexActivity
  ) =>
    async (dispatch) => {
      if (uuid !== "") {
        const obj_add = {
          lang: lang,
          uuid: uuid,
          tripDestinationId: tripDestinationId,
          dayInDestination: dayInTripDestination,
          placeId: establishmentId,
          afterActivityId: activityId,
        };
        let api_url =
          environment.apiUrl + "timeline/addActivity/" + lang + "/" + uuid;
        PostAsyncHelper(api_url, obj_add).then((responseActivity) => {
          const copyActivitiesInDestinationDayIds = Array.from(
            activitiesInDestinationDayIds
          );
          activitiesInDestinationDayIds.splice(
            activitiesInDestinationDayIds.length,
            0,
            responseActivity.data.result.activityID
          );
          copyActivitiesInDestinationDayIds.splice(
            indexActivity,
            0,
            responseActivity.data.result.activityID
          );
          if (responseActivity.statusText === "OK") {
            dispatch({
              type: SET_SEARCH_ADDRESS_SELECTED,
              address_selected: null,
            });
            const obj_drag = {
              tripDestinationId: tripDestinationId,
              fromTripDestinationId: tripDestinationId,
              fromDayInDestination: fromDayInDestination,
              toDayInDestination: toDayInDestination,
              allActivitiesFrom: activitiesInDestinationDayIds,
              allActivitiesTo: copyActivitiesInDestinationDayIds,
            };
            let api_url =
              environment.apiUrl +
              "timeline/dragAndDropActivity/" +
              lang +
              "/" +
              uuid;
            PostAsyncHelper(api_url, obj_drag).then(
              (responseDragAndDropActivity) => {
                if (
                  responseDragAndDropActivity &&
                  responseDragAndDropActivity.statusText === "OK"
                ) {
                  const fetch_active_trip_activities_api_url =
                    environment.apiUrl +
                    "timeline/getTripActivities/" +
                    lang +
                    "/" +
                    uuid +
                    "?tripId=" +
                    tripId +
                    "&getTripActivities";

                  GetAsyncHelper(fetch_active_trip_activities_api_url).then(
                    (responseTripActivities) => {
                      if (responseTripActivities.statusText === "OK") {
                        dispatch({
                          type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                          activities: responseTripActivities.data.result,
                        });
                        dispatch({
                          type: ALERT_BARS_HANDLE,
                          message_type: "success",
                          message: "saved",
                        });
                      } else {
                        console.log("no permission");
                      }
                    }
                  );
                }
              }
            );
          }
        });
      }
    };

export const dragDropActivityInActivitiesOfTripDestinationInTrip =
  (
    lang,
    uuid,
    tripDestinationId,
    tripId,
    activityId = "",
    toDayInDestination,
    fromDayInDestination,
    activitiesInDestinationDayIds,
    indexActivity,
    fromIndexActivity,
    fromTripDestinationId,
    fromActivitiesIds
  ) =>
    async (dispatch) => {
      if (uuid !== "") {
        let copyActivitiesIds = Array.from(activitiesInDestinationDayIds);
        copyActivitiesIds =
          Number(tripDestinationId) === Number(fromTripDestinationId) &&
            Number(fromDayInDestination) === Number(toDayInDestination)
            ? copyActivitiesIds.filter((id) => id !== activityId)
            : copyActivitiesIds;
        const diffIndex =
          Number(toDayInDestination) === Number(fromDayInDestination) &&
            indexActivity > fromIndexActivity
            ? 1
            : 0;
        // console.log(copyActivitiesIds)
        copyActivitiesIds.splice(indexActivity - diffIndex, 0, activityId);
        const obj_drag = {
          tripDestinationId: tripDestinationId,
          fromTripDestinationId: fromTripDestinationId,
          fromDayInDestination: fromDayInDestination,
          toDayInDestination: toDayInDestination,
          allActivitiesFrom: fromActivitiesIds,
          allActivitiesTo: copyActivitiesIds,
        };
        let api_url =
          environment.apiUrl +
          "timeline/dragAndDropActivity/" +
          lang +
          "/" +
          uuid;
        PostAsyncHelper(api_url, obj_drag).then((responseDragAndDropActivity) => {
          if (responseDragAndDropActivity.statusText === "OK") {
            const fetch_active_trip_activities_api_url =
              environment.apiUrl +
              "timeline/getTripActivities/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripActivities";

            GetAsyncHelper(fetch_active_trip_activities_api_url).then(
              (responseTripActivities) => {
                if (responseTripActivities.statusText === "OK") {
                  dispatch({
                    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                    activities: responseTripActivities.data.result,
                  });
                  dispatch({
                    type: ALERT_BARS_HANDLE,
                    message_type: "success",
                    message: "saved",
                  });
                } else {
                  console.log("no permission");
                }
              }
            );
          }
        });
      }
    };

export const deleteActivityToDayOfTripDestinationInTrip =
  (lang, uuid, tripDestinationId, activityId, tripId) => async (dispatch) => {
    if (uuid !== "") {
      let obj = {
        lang: lang,
        uuid: uuid,
        tripDestinationId: tripDestinationId,
        activityId: activityId,
      };
      let api_url =
        environment.apiUrl + "timeline/removeActivity/" + lang + "/" + uuid;
      PostAsyncHelper(api_url, obj).then((responseActivity) => {
        if (responseActivity.statusText === "OK") {
          const fetch_active_trip_activities_api_url =
            environment.apiUrl +
            "timeline/getTripActivities/" +
            lang +
            "/" +
            uuid +
            "?tripId=" +
            tripId +
            "&getTripActivities";

          GetAsyncHelper(fetch_active_trip_activities_api_url).then(
            (responseTripActivities) => {
              if (responseTripActivities.statusText === "OK") {
                dispatch({
                  type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                  activities: responseTripActivities.data.result,
                });
                dispatch({
                  type: ALERT_BARS_HANDLE,
                  message_type: "success",
                  message: "saved",
                });
              } else {
                console.log("no permission");
              }
            }
          );
        }
      });
    }
  };

export const deleteActivitiesOfTripDestinationInTrip =
  (lang, uuid, availableDeleteActivities, tripId) => async (dispatch) => {
    availableDeleteActivities.map((a) => {
      delete a.activityDay;
      delete a.activityDayInDestination;
      delete a.activityDescription;
      delete a.activityDuration;
      delete a.activityEstabID;
      delete a.activityLatitude;
      delete a.activityLongitude;
      delete a.activityNeighborhood;
      delete a.activityNoTime;
      delete a.activityScore;
      delete a.activityStarRating;
      delete a.activityStartTime;
      delete a.activitySubTypes;
      delete a.activityTimeToReach;
      delete a.activityTypes;
      delete a.establishmentURL;
      delete a.image;
      delete a.shortDescription;
      delete a.uri;
      // Object.assign(a, {
      //     lang: lang,
      //     uuid: uuid
      // })
      return a;
    });
    // console.log(availableDeleteActivities)
    if (uuid !== "") {
      let obj = {
        availableDeleteActivities: availableDeleteActivities,
      };
      let api_url =
        environment.apiUrl +
        "timeline/removeMultipleActivities/" +
        lang +
        "/" +
        uuid;
      PostAsyncHelper(api_url, obj).then((responseActivity) => {
        if (responseActivity.statusText === "OK") {
          const fetch_active_trip_activities_api_url =
            environment.apiUrl +
            "timeline/getTripActivities/" +
            lang +
            "/" +
            uuid +
            "?tripId=" +
            tripId +
            "&getTripActivities";

          GetAsyncHelper(fetch_active_trip_activities_api_url).then(
            (responseTripActivities) => {
              if (responseTripActivities.statusText === "OK") {
                dispatch({
                  type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                  activities: responseTripActivities.data.result,
                });
                dispatch({
                  type: ALERT_BARS_HANDLE,
                  message_type: "success",
                  message: "saved",
                });
              } else {
                console.log("no permission");
              }
            }
          );
        }
      });
    }
  };

export const addActivityToTripDestinationInTrip =
  (
    lang,
    uuid,
    tripDestinationId,
    dayInTripDestination,
    establishmentId,
    tripId,
    last_establishmentId,
    tripDuration,
    destinationId,
    activeTripDestinationIds,
    isSetActiveTrip = false,
    activeDayMapDayInTrip = 1,
    duration = 3,
    activityId = "",
    after6pmCutoff,
    nextDayInTripDestination,
    nextDayInTrip,
    typeID
  ) =>
    async (dispatch) => {
      if (last_establishmentId !== establishmentId) {
        const newRoom =
          activeTripDestinationIds.find((id) => id === String(destinationId)) ===
          undefined;
        if (newRoom) {
          // console.log("add destiantion and activity")
          let obj = {
            lang: lang,
            uuid: uuid,
            destinationId: destinationId,
            tripId: tripId,
            duration: duration,
          };
          let api_url =
            environment.apiUrl +
            "timeline/addTripDestination/" +
            lang +
            "/" +
            uuid +
            "?action=addTripDestination";
          PostAsyncHelper(api_url, obj).then((responseDestinations) => {
            if (responseDestinations.statusText === "OK") {
              const destinations = responseDestinations.data.result;
              const destinationsLength = responseDestinations.data.result.length;
              dispatch({
                type: UPDATE_TRIP_DESTINATION_IN_TRIP,
                trip_destinations_rearrange: destinations,
              });
              dispatch({
                type: ADD_TRIP_DESTINATION_IN_TRIP_OPEN_STATUS,
                trip_destination_open_status: {
                  tripDestinationId: destinations[destinationsLength - 1].td_id,
                  openStatus: true,
                },
              });
              dispatch({
                type: SET_ACTIVE_TRIP_DESTINATION,
                trip_destination_id: destinations[destinationsLength - 1].td_id,
                destination_id: destinations[destinationsLength - 1].id,
              });
              dispatch({
                type: SET_ACTIVE_DAY_IN_TRIP,
                trip_destination_id: destinations[destinationsLength - 1].td_id,
                day_in_trip:
                  destinations[destinationsLength - 1].startingDayInTrip,
                day_in_trip_destination: "1",
              });

              /* update trip duration */
              const diffTripdays = Number(duration) - 1;
              const obj_trip_duration = {
                lang: lang,
                uuid: uuid,
                // duration: (Number(tripDuration) + Number(diffTripdays)),
                tripId: tripId,
              };
              const api_url_update_trip_duration =
                environment.apiUrl +
                "timeline/updateTripDuration/" +
                lang +
                "/" +
                uuid;
              PostAsyncHelper(
                api_url_update_trip_duration,
                obj_trip_duration
              ).then((responseTripDuration) => {
                responseTripDuration.statusText === "OK" &&
                  dispatch({
                    type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
                    trip_duration: Number(tripDuration) + Number(diffTripdays),
                  });
              });

              // add activity
              const obj_add_activity = {
                lang: lang,
                uuid: uuid,
                tripDestinationId: destinations[destinationsLength - 1].td_id,
                dayInDestination: 1,
                placeId: establishmentId,
                afterActivityId: activityId,
              };
              let api_url_activity =
                environment.apiUrl + "timeline/addActivity/" + lang + "/" + uuid;
              PostAsyncHelper(api_url_activity, obj_add_activity).then(
                (responseActivity) => {
                  if (
                    responseActivity !== undefined &&
                    responseActivity.statusText === "OK"
                  ) {
                    const fetch_active_trip_activities_api_url =
                      environment.apiUrl +
                      "timeline/getTripActivities/" +
                      lang +
                      "/" +
                      uuid +
                      "?tripId=" +
                      tripId +
                      "&getTripActivities";

                    GetAsyncHelper(fetch_active_trip_activities_api_url).then(
                      (responseTripActivities) => {
                        if (responseTripActivities.statusText === "OK") {
                          dispatch({
                            type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                            activities: responseTripActivities.data.result,
                          });
                          dispatch({
                            type: ALERT_BARS_HANDLE,
                            message_type: "success",
                            message: "saved",
                          });
                        } else {
                          console.log("no permission");
                        }
                      }
                    );
                    const url_active_trip_get_cost =
                      environment.apiUrl +
                      "timeline/getTripCost/en/" +
                      uuid +
                      "?tripId=" +
                      tripId +
                      "&getTripCost";
                    dispatch({
                      type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                      status: true,
                    });
                    GetAsyncHelper(url_active_trip_get_cost).then(
                      (responseTripCost) => {
                        if (responseTripCost.statusText === "OK") {
                          dispatch({
                            type: SET_TIMELINE_ACTIVE_TRIP_COST,
                            trip_cost: responseTripCost.data.result,
                          });
                          dispatch({
                            type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                            status: false,
                          });
                        } else {
                          console.log("no permission");
                        }
                      }
                    );
                    dispatch({
                      type: SET_TIMELINE_WIZARD_STATUS,
                      status: true,
                    });
                  }
                }
              );
            }
          });
        } else {
          if (uuid !== "") {
            isSetActiveTrip &&
              dispatch({
                type: SET_ACTIVE_TRIP_DESTINATION,
                trip_destination_id: tripDestinationId,
                destination_id: destinationId,
              });

            let dayInTrip = activeDayMapDayInTrip;
            let dayInTripDes = String(dayInTripDestination);

            if (
              typeID &&
              (typeID !== "3" || typeID !== "4" || typeID !== "5") &&
              after6pmCutoff
            ) {
              dayInTrip = nextDayInTrip;
              dayInTripDes = String(nextDayInTripDestination);
            }

            isSetActiveTrip &&
              dispatch({
                type: SET_ACTIVE_DAY_IN_TRIP,
                trip_destination_id: tripDestinationId,
                day_in_trip: dayInTrip,
                day_in_trip_destination: dayInTripDes,
              });

            const obj_add = {
              lang: lang,
              uuid: uuid,
              tripDestinationId: tripDestinationId,
              dayInDestination: dayInTripDes,
              placeId: establishmentId,
              afterActivityId: activityId,
            };
            let api_url =
              environment.apiUrl + "timeline/addActivity/" + lang + "/" + uuid;
            PostAsyncHelper(api_url, obj_add).then((responseActivity) => {
              if (
                responseActivity !== undefined &&
                responseActivity.statusText === "OK"
              ) {
                const fetch_active_trip_activities_api_url =
                  environment.apiUrl +
                  "timeline/getTripActivities/" +
                  lang +
                  "/" +
                  uuid +
                  "?tripId=" +
                  tripId +
                  "&getTripActivities";

                GetAsyncHelper(fetch_active_trip_activities_api_url).then(
                  (responseTripActivities) => {
                    if (responseTripActivities.statusText === "OK") {
                      dispatch({
                        type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                        activities: responseTripActivities.data.result,
                      });
                      dispatch({
                        type: SET_ADDED_ACTIVITY_IN_TRIP,
                        activityID: establishmentId,
                      });

                      dispatch({
                        type: ALERT_BARS_HANDLE,
                        message_type: "success",
                        message: "saved",
                      });
                      dispatch({
                        type: SET_TIMELINE_WIZARD_STATUS,
                        status: true,
                      });
                    } else {
                      console.log("no permission");
                    }
                  }
                );
              }
            });
          }
        }
      } else {
        dispatch({
          type: ALERT_BARS_HANDLE,
          message_type: "warning",
          message: "You have already added this activity at this time.",
        });
      }
    };

export const setStartTimeToActivity =
  (lang, uuid, activityId, date, tripId) => async (dispatch) => {
    if (uuid !== "") {
      const activityStartTime =
        date === null
          ? "00:00"
          : ("0" + date.getHours()).slice(-2) +
          ":" +
          ("0" + date.getMinutes()).slice(-2);

      const obj_update_start_time = {
        activityId: activityId,
        startTime: activityStartTime,
      };

      const api_url =
        environment.apiUrl +
        "timeline/setActivityStartTime/" +
        lang +
        "/" +
        uuid;
      PostAsyncHelper(api_url, obj_update_start_time).then(
        (responseActivity) => {
          if (responseActivity.statusText === "OK") {
            const fetch_active_trip_activities_api_url =
              environment.apiUrl +
              "timeline/getTripActivities/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripActivities";
            GetAsyncHelper(fetch_active_trip_activities_api_url).then(
              (responseTripActivities) => {
                if (responseTripActivities.statusText === "OK") {
                  dispatch({
                    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                    activities: responseTripActivities.data.result,
                  });
                  dispatch({
                    type: ALERT_BARS_HANDLE,
                    message_type: "success",
                    message: "saved",
                  });
                } else {
                  console.log("no permission");
                }
              }
            );
          }
        }
      );
    }
    // const obj_update_no_time = {
    //     activityId: activityId,
    // }
    // const api_url_no_time = 'https://devapi.muvtravel.com/api/public/timeline/setActivityNoTime/' + lang + '/' + uuid
    // PostAsyncHelper(api_url_no_time, obj_update_no_time)
  };


export const setNoTimeToActivity =
  (lang, uuid, activityId, date, tripId) => async (dispatch) => {
    if (uuid !== "") {

      const obj_update_no_time = {
        activityId: activityId,
      };

      const api_url =
        environment.apiUrl +
        "timeline/setActivityNoTime/" +
        lang +
        "/" +
        uuid;
      PostAsyncHelper(api_url, obj_update_no_time).then(
        (responseActivity) => {
          if (responseActivity.statusText === "OK") {
            const fetch_active_trip_activities_api_url =
              environment.apiUrl +
              "timeline/getTripActivities/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripActivities";
            GetAsyncHelper(fetch_active_trip_activities_api_url).then(
              (responseTripActivities) => {
                if (responseTripActivities.statusText === "OK") {
                  dispatch({
                    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                    activities: responseTripActivities.data.result,
                  });
                  dispatch({
                    type: ALERT_BARS_HANDLE,
                    message_type: "success",
                    message: "saved",
                  });
                } else {
                  console.log("no permission");
                }
              }
            );
          }
        }
      );
    }

  };

export const setDurationToActivity =
  (lang, uuid, activityId, date, tripId) => async (dispatch) => {
    if (uuid !== "") {
      const activityDuration =
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2);

      const obj_update_duration = {
        activityId: activityId,
        duration: activityDuration,
      };

      const api_url =
        environment.apiUrl +
        "timeline/setActivityDuration/" +
        lang +
        "/" +
        uuid;
      PostAsyncHelper(api_url, obj_update_duration).then((responseActivity) => {
        if (responseActivity.statusText === "OK") {
          const fetch_active_trip_activities_api_url =
            environment.apiUrl +
            "timeline/getTripActivities/" +
            lang +
            "/" +
            uuid +
            "?tripId=" +
            tripId +
            "&getTripActivities";
          GetAsyncHelper(fetch_active_trip_activities_api_url).then(
            (responseTripActivities) => {
              if (responseTripActivities.statusText === "OK") {
                dispatch({
                  type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                  activities: responseTripActivities.data.result,
                });
                dispatch({
                  type: ALERT_BARS_HANDLE,
                  message_type: "success",
                  message: "saved",
                });
              } else {
                console.log("no permission");
              }
            }
          );
        }
      });
    }
  };

export const getEstablishmentsNearbyMapCenter =
  (coordinates, lang, selectedTypes) => async (dispatch) => {
    const obj_get_establishments = {
      coordinates: coordinates,
      typeIds: selectedTypes || [],
      // limit: GET_ESTABLISHMENTS_NEAR_BY_MAP_CENTER,
    };

    const api_url =
      environment.apiUrl + "muvsearch/searchPlacesInPolygon/" + lang;
    PostAsyncHelper(api_url, obj_get_establishments).then(
      (responseEstablishments) => {
        if (
          responseEstablishments !== undefined &&
          responseEstablishments.statusText === "OK"
        ) {
          dispatch({
            type: FETCH_PLACES_NEAR_BY_CENTER,
            places_near_by_center: responseEstablishments.data,
          });
        }
      }
    );
  };

export const cleanupSliderImage = () => (dispatch) => {
  dispatch({
    type: FETCH_SLIDER_IMAGES_DESTINATION,
    slider_images: [],
  });
  dispatch({
    type: FETCH_SLIDER_IMAGES_ESTABLISHMENT,
    slider_images: [],
  });
};

export const fetchActiveTripByTripId = (tripId, lang) => (dispatch) => {
  const muv_token = Cookies.get("muv_token");
  const muv_active_trip = tripId;
  dispatch({
    type: SET_LOADER,
    payload: false,
  });
  if (muv_active_trip !== undefined && muv_active_trip !== "") {
    if (muv_token === undefined) {
      // console.log("no login")
      const url_get =
        environment.apiUrl +
        "timeline/getTripInfo/en/TMPUUID?tripId=" +
        muv_active_trip +
        "&getTripInfo";
      GetAsyncHelper(url_get).then((responseTrip) => {
        if (responseTrip.statusText === "OK") {
          const trip = responseTrip.data.result;
          dispatch(updateActiveTrip(trip));
          Cookies.set("muv_active_trip", muv_active_trip, {
            expires: 365,
          });
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_ID,
            trip_id: trip.tripID,
          });

          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_NAME,
            trip_name: trip.tripName,
          });

          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_START_DATE,
            trip_start_date:
              trip.noDate === "0" ? trip.tripStartDate : "0000-00-00",
          });

          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
            trip_no_date: trip.noDate,
          });

          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
            trip_duration: trip.tripDaysCount,
          });
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
            trip_description: trip.tripDescription,
          });
          dispatch({
            type: SET_TRIP_TYPE_SELECTED,
            type_id: trip.typeId,
          });
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
            trip_auth_status: trip.isPublic,
          });
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_IMAGE,
            trip_image: trip.headerImage,
          });
          dispatch({
            type: SET_LEAVING_FROM_AIRPORT_SELECTED,
            airport_selected: trip.leavingFromAirport,
          });
          dispatch({
            type: SET_RETURNING_TO_AIRPORT_SELECTED,
            airport_selected: trip.returningToAirport,
          });
          // dispatch({
          //     type: SET_TIMELINE_WIZARD_STATUS,
          //     status: true
          // })
        } else {
          console.log("no permission");
        }
      });
      const url_active_trip_get_cost =
        environment.apiUrl +
        "timeline/getTripCost/en/TMPUUID?tripId=" +
        muv_active_trip +
        "&getTripCost";
      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
        status: true,
      });
      GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
        if (responseTripCost.statusText === "OK") {
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_COST,
            trip_cost: responseTripCost.data.result,
          });
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
            status: false,
          });
        } else {
          console.log("no permission");
        }
      });

      const fetch_active_trip_activities_api_url =
        environment.apiUrl +
        "timeline/getTripActivities/en/TMPUUID?tripId=" +
        muv_active_trip +
        "&getTripActivities";

      GetAsyncHelper(fetch_active_trip_activities_api_url).then(
        (responseTripActivities) => {
          if (responseTripActivities.statusText === "OK") {
            dispatch({
              type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
              activities: responseTripActivities.data.result,
            });
          } else {
            console.log("no permission");
          }
        }
      );
      const url_active_trip_get_destinations =
        environment.apiUrl +
        "timeline/getTripDestinations/" +
        lang +
        "/TMPUUID?tripId=" +
        muv_active_trip +
        "&getTripDestinations";
      GetAsyncHelper(url_active_trip_get_destinations).then(
        (responseTripDestinations) => {
          if (responseTripDestinations.statusText === "OK") {
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
              trip_destinations: responseTripDestinations.data,
            });
            const destinations = responseTripDestinations.data;
            const idsDestinations = Array.from(
              new Set(destinations.map((d) => d.id))
            );
            const tdidsDestinations = Array.from(
              new Set(destinations.map((d) => d.td_id))
            );
            // the first destination is activie destination
            if (
              idsDestinations !== undefined &&
              idsDestinations.length > 0 &&
              idsDestinations[0] !== undefined
            ) {
              const first_destination_id = idsDestinations[0];
              dispatch({
                type: SET_ACTIVE_TRIP_DESTINATION,
                trip_destination_id: tdidsDestinations[0],
                destination_id: first_destination_id,
              });
              dispatch({
                type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
                trip_destination_id: tdidsDestinations[0],
              });
              const destinationDays =
                destinations[0].spanningDays !== undefined &&
                destinations[0].spanningDays.split(",");
              const destinationLastDayInTrip =
                destinationDays[destinationDays.length - 1];
              const destinationLastDayInTripDestination = String(
                destinationDays.length
              );
              dispatch({
                type: SET_ACTIVE_DAY_IN_TRIP,
                trip_destination_id: tdidsDestinations[0],
                day_in_trip: destinationLastDayInTrip,
                day_in_trip_destination: destinationLastDayInTripDestination,
              });
              dispatch({
                type: SET_DESTINATION_ID_DESTINATION,
                active_id: first_destination_id,
              });
              /* fetch feature list */
              GetAsyncHelper(
                environment.apiUrl +
                "destination/main/" +
                lang +
                "/" +
                first_destination_id
              ).then((responseGeneral) => {
                if (
                  responseGeneral === undefined ||
                  responseGeneral.statusText !== "OK"
                ) {
                  dispatch({
                    type: FETCH_API_ERROR_DESTINATION,
                    api_error: true,
                  });
                } else {
                  dispatch({
                    type: FETCH_GENERAL_INFO_DESTINATION,
                    general_info: responseGeneral.data.result.generalInfo,
                  });
                  dispatch({
                    type: FETCH_BREADCRUMB_DESTINATION,
                    breadcrumb: responseGeneral.data.result.destinationTree,
                  });

                  dispatch({
                    type: FETCH_NESTED_IDS_DESTINATION,
                    nested_ids:
                      responseGeneral.data.result.destinationNestedIds,
                  });
                }
              });
              GetAsyncHelper(
                environment.apiUrl +
                "destination/photogallery/" +
                lang +
                "/" +
                first_destination_id
              ).then((photoGalleryResponse) => {
                if (
                  photoGalleryResponse === undefined ||
                  photoGalleryResponse.statusText !== "OK"
                ) {
                  dispatch({
                    type: FETCH_API_ERROR_DESTINATION,
                    api_error: true,
                  });
                } else {
                  dispatch({
                    type: FETCH_SLIDER_IMAGES_DESTINATION,
                    slider_images: photoGalleryResponse.data.results,
                  });
                }
              });
              dispatch({
                type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                is_fetching_establishments: true,
              });

              GetAsyncHelper(
                environment.apiUrl +
                "destination/getavailablefeatures/" +
                lang +
                "/" +
                first_destination_id
              ).then((featureResponse) => {
                if (
                  featureResponse === undefined ||
                  featureResponse.statusText !== "OK"
                ) {
                  dispatch({
                    type: FETCH_API_ERROR_DESTINATION,
                    api_error: true,
                  });
                  dispatch({
                    type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                    is_fetching_establishments: false,
                  });
                } else {
                  dispatch({
                    type: FETCH_FEATURES_DESTINATION,
                    features: featureResponse.data.features,
                  });
                  if (
                    featureResponse.data.features.length > 0 &&
                    featureResponse.data.features[0] !== undefined
                  ) {
                    dispatch({
                      type: SET_FEATURE_FORMAT,
                      featureSelected: featureResponse.data.features[0],
                    });
                    /*  get first feature's types */
                    GetAsyncHelper(
                      environment.apiUrl +
                      "destination/getfeaturetypes/" +
                      lang +
                      "/" +
                      first_destination_id +
                      "?featureID=" +
                      featureResponse.data.features[0].feature_id
                    ).then((responseTypes) => {
                      if (responseTypes.statusText === "OK") {
                        dispatch({
                          type: FETCH_FEATURE_TYPES_DESTINATION,
                          types: responseTypes.data.types,
                        });
                        if (
                          responseTypes.data.types.length > 0 &&
                          responseTypes.data.types[0] !== undefined
                        ) {
                          dispatch({
                            type: DESTINATION_SWITCH_FEATURE_TYPE_CONTAINER,
                            typeSelected: responseTypes.data.types[0],
                          });
                          /*  get first feature's type's subtype */
                          GetAsyncHelper(
                            environment.apiUrl +
                            "destination/getfeaturesubtypes/" +
                            lang +
                            "/" +
                            first_destination_id +
                            "?featureid=" +
                            featureResponse.data.features[0].feature_id +
                            "&typeID=" +
                            responseTypes.data.types[0].typeID
                          ).then((responseSubtypes) => {
                            if (responseSubtypes.statusText === "OK") {
                              dispatch({
                                type: FETCH_FEATURE_SUBTYPES_DESTINATION,
                                subtypes: responseSubtypes.data,
                              });
                            } else {
                              dispatch({
                                type: FETCH_API_ERROR_DESTINATION,
                                api_error: true,
                              });
                            }
                          });
                          dispatch({
                            type: UPDATE_SEARCH_QUERY_DESTINATION,
                            search_query: "",
                          });
                          let obj = {
                            featureID:
                              featureResponse.data.features[0].feature_id,
                            typeID: responseTypes.data.types[0].typeID,
                            limit: 20,
                            offset: 0,
                            subtype: [],
                            sortingOrder: {
                              title:
                                featureResponse.data.features[0].sorting.title,
                              code: featureResponse.data.features[0].sorting
                                .code,
                            },
                            sortingDirection: "",
                            searchquery: "",
                          };
                          let api_url =
                            environment.apiUrl +
                            "destination/getlistoffeatures/" +
                            lang +
                            "/" +
                            first_destination_id;
                          dispatch({
                            type: UPDATE_LAZYLOADING_URL_REQUESTS_DESTINATION,
                            api_url: api_url,
                            requests: obj,
                          });
                          PostAsyncHelper(api_url, obj).then(
                            (responseEstablishments) => {
                              if (
                                responseEstablishments !== undefined &&
                                responseEstablishments.statusText === "OK"
                              ) {
                                featureResponse.data.features.length > 0 &&
                                  featureResponse.data.features[0]
                                    .feature_id ===
                                  features_router.places.featureId &&
                                  dispatch({
                                    type: FETCH_ESTABLISMENT_SETS_DESTINATION,
                                    result_sets_establishments:
                                      responseEstablishments.data.results,
                                  });
                                featureResponse.data.features.length > 0 &&
                                  featureResponse.data.features[0]
                                    .feature_id ===
                                  features_router.trips.featureId &&
                                  dispatch({
                                    type: FETCH_TRIP_SETS_DESTINATION,
                                    result_sets_trips:
                                      responseEstablishments.data.results,
                                  });
                                dispatch({
                                  type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                                  is_fetching_establishments: false,
                                });
                                if (
                                  responseEstablishments.data.results.length < 5
                                ) {
                                  dispatch({
                                    type: UPDATE_LAZYLOADING_IS_FATCH_ALL_DESTINATION,
                                    no_progress: true,
                                  });
                                } else {
                                  dispatch({
                                    type: UPDATE_LAZYLOADING_IS_FATCH_ALL_DESTINATION,
                                    no_progress: false,
                                  });
                                }
                              } else {
                                dispatch({
                                  type: FETCH_API_ERROR_DESTINATION,
                                  api_error: true,
                                });
                              }
                            }
                          );
                          dispatch({
                            type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                            is_fetching_establishments: false,
                          });
                        }
                      } else {
                        dispatch({
                          type: FETCH_API_ERROR_DESTINATION,
                          api_error: true,
                        });
                        dispatch({
                          type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                          is_fetching_establishments: false,
                        });
                      }
                    });
                  } else {
                    dispatch({
                      type: SET_FEATURE_FORMAT,
                      featureSelected: null,
                    });
                    dispatch({
                      type: FETCH_FEATURE_TYPES_DESTINATION,
                      types: [],
                    });
                    let obj = {
                      featureID: 0,
                      typeID: 0,
                      limit: LAZYLOADING_ESTABLISHMENTS_LIMIT,
                      offset: 0,
                      subtype: [],
                      sortingOrder: {
                        title: "",
                        code: "",
                      },
                      sortingDirection: "",
                      searchquery: "",
                    };
                    let api_url = "";
                    dispatch({
                      type: UPDATE_LAZYLOADING_URL_REQUESTS_DESTINATION,
                      api_url: api_url,
                      requests: obj,
                    });
                    dispatch({
                      type: FETCH_FEATURE_SUBTYPES_DESTINATION,
                      subtypes: [],
                    });
                    dispatch({
                      type: UPDATE_LAZYLOADING_IS_FATCH_ALL_DESTINATION,
                      no_progress: true,
                    });
                    dispatch({
                      type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                      is_fetching_establishments: false,
                    });
                  }
                }
              });
              dispatch({
                type: CLEAN_SELECTED_SUBTYPES_DESTINATION,
              });

              GetAsyncHelper(
                environment.apiUrl +
                "destination/getinfluencers/" +
                lang +
                "/" +
                first_destination_id
              ).then((influencersResponse) => {
                if (
                  influencersResponse === undefined &&
                  influencersResponse.statusText !== "OK"
                ) {
                  dispatch({
                    type: FETCH_API_ERROR_DESTINATION,
                    api_error: true,
                  });
                } else {
                  dispatch({
                    type: FETCH_INFLUENCERS_DESTINATION,
                    influencers: influencersResponse.data.influencers,
                  });
                }
              });
              const sortingOptionsRequests = {
                featureId: 1,
              };
              PostAsyncHelper(
                environment.apiUrl +
                "featurelist/getFeatureSortingOptions/" +
                lang,
                sortingOptionsRequests
              ).then((responseSortingOptions) => {
                if (
                  responseSortingOptions === undefined &&
                  responseSortingOptions.statusText !== "OK"
                ) {
                  dispatch({
                    type: FETCH_API_ERROR_DESTINATION,
                    api_error: true,
                  });
                } else {
                  dispatch({
                    type: FETCH_SORTING_OPTION_DESTINATION,
                    sorting_options: responseSortingOptions?.data?.results,
                  });
                }
              });
              GetAsyncHelper(
                environment.apiUrl +
                "destination/suggestedtrips/" +
                lang +
                "/" +
                first_destination_id +
                "?limit=10"
              ).then((suggestedTripsResponse) => {
                if (
                  suggestedTripsResponse === undefined &&
                  suggestedTripsResponse.statusText !== "OK"
                ) {
                  dispatch({
                    type: FETCH_API_ERROR_DESTINATION,
                    api_error: true,
                  });
                } else {
                  dispatch({
                    type: FETCH_SUGGESTEDTRIPS_DESTINATION,
                    suggested_trips: suggestedTripsResponse.data.results,
                  });
                }
              });
              dispatch({
                type: SET_LIST_DISPLAY_FORMAT_DESTINATION,
                container_format: list_container_mode.list,
              });
            }
          } else {
            console.log("no permission");
          }
        }
      );
    } else {
      // console.log("logined")

      const api_url_token =
        environment.apiUrl + "membertoken?token=" + muv_token;
      PostAsyncHelper(api_url_token).then((responseToken) => {
        const member = responseToken?.data?.message;
        const uuid = member.memberRestUUID;
        const url_active_trip_get =
          environment.apiUrl +
          "timeline/getTripInfo/en/" +
          uuid +
          "?tripId=" +
          muv_active_trip +
          "&getTripInfo";
        GetAsyncHelper(url_active_trip_get).then((responseTrip) => {
          if (responseTrip.statusText === "OK") {
            const trip = responseTrip.data.result;
            dispatch(updateActiveTrip(trip));

            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_ID,
              trip_id: trip.tripID,
            });

            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_NAME,
              trip_name: trip.tripName,
            });

            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_START_DATE,
              trip_start_date:
                trip.noDate === "0" ? trip.tripStartDate : "0000-00-00",
            });

            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
              trip_no_date: trip.noDate,
            });

            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
              trip_duration: trip.tripDaysCount,
            });
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
              trip_description: trip.tripDescription,
            });
            dispatch({
              type: SET_TRIP_TYPE_SELECTED,
              type_id: trip.typeId,
            });
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
              trip_auth_status: trip.isPublic,
            });
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_IMAGE,
              trip_image: trip.headerImage,
            });
            dispatch({
              type: SET_LEAVING_FROM_AIRPORT_SELECTED,
              airport_selected: trip.leavingFromAirport,
            });
            dispatch({
              type: SET_RETURNING_TO_AIRPORT_SELECTED,
              airport_selected: trip.returningToAirport,
            });
            // dispatch({
            //     type: SET_TIMELINE_WIZARD_STATUS,
            //     status: true
            // })
          } else {
            console.log("no permission");
          }
        });
        const url_active_trip_get_cost =
          environment.apiUrl +
          "timeline/getTripCost/en/" +
          uuid +
          "?tripId=" +
          muv_active_trip +
          "&getTripCost";
        dispatch({
          type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
          status: true,
        });
        GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
          if (responseTripCost.statusText === "OK") {
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_COST,
              trip_cost: responseTripCost.data.result,
            });
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
              status: false,
            });
          } else {
            console.log("no permission");
          }
        });
        const fetch_active_trip_activities_api_url =
          environment.apiUrl +
          "timeline/getTripActivities/en/" +
          uuid +
          "?tripId=" +
          muv_active_trip +
          "&getTripActivities";
        GetAsyncHelper(fetch_active_trip_activities_api_url).then(
          (responseTripActivities) => {
            if (responseTripActivities.statusText === "OK") {
              dispatch({
                type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                activities: responseTripActivities.data.result,
              });
            } else {
              console.log("no permission");
            }
          }
        );

        const url_active_trip_get_destinations =
          environment.apiUrl +
          "timeline/getTripDestinations/" +
          lang +
          "/" +
          uuid +
          "?tripId=" +
          muv_active_trip +
          "&getTripDestinations";
        GetAsyncHelper(url_active_trip_get_destinations).then(
          (responseTripDestinations) => {
            if (responseTripDestinations.statusText === "OK") {
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
                trip_destinations: responseTripDestinations.data,
              });
              const destinations = responseTripDestinations.data;
              const idsDestinations = Array.from(
                new Set(destinations.map((d) => d.id))
              );
              const tdidsDestinations = Array.from(
                new Set(destinations.map((d) => d.td_id))
              );

              if (
                idsDestinations !== undefined &&
                idsDestinations.length > 0 &&
                idsDestinations[0] !== undefined
              ) {
                const first_destination_id = idsDestinations[0];
                dispatch({
                  type: SET_ACTIVE_TRIP_DESTINATION,
                  trip_destination_id: tdidsDestinations[0],
                  destination_id: first_destination_id,
                });
                dispatch({
                  type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
                  trip_destination_id: tdidsDestinations[0],
                });
                const destinationDays =
                  destinations[0].spanningDays !== undefined &&
                  destinations[0].spanningDays.split(",");
                const destinationLastDayInTrip =
                  destinationDays[destinationDays.length - 1];
                const destinationLastDayInTripDestination = String(
                  destinationDays.length
                );
                dispatch({
                  type: SET_ACTIVE_DAY_IN_TRIP,
                  trip_destination_id: tdidsDestinations[0],
                  day_in_trip: destinationLastDayInTrip,
                  day_in_trip_destination: destinationLastDayInTripDestination,
                });
                dispatch({
                  type: SET_DESTINATION_ID_DESTINATION,
                  active_id: first_destination_id,
                });
                /* fetch feature list */
                GetAsyncHelper(
                  environment.apiUrl +
                  "destination/main/" +
                  lang +
                  "/" +
                  first_destination_id
                ).then((responseGeneral) => {
                  if (
                    responseGeneral === undefined ||
                    responseGeneral.statusText !== "OK"
                  ) {
                    dispatch({
                      type: FETCH_API_ERROR_DESTINATION,
                      api_error: true,
                    });
                  } else {
                    dispatch({
                      type: FETCH_GENERAL_INFO_DESTINATION,
                      general_info: responseGeneral.data.result.generalInfo,
                    });
                    dispatch({
                      type: FETCH_BREADCRUMB_DESTINATION,
                      breadcrumb: responseGeneral.data.result.destinationTree,
                    });

                    dispatch({
                      type: FETCH_NESTED_IDS_DESTINATION,
                      nested_ids:
                        responseGeneral.data.result.destinationNestedIds,
                    });
                  }
                });
                GetAsyncHelper(
                  environment.apiUrl +
                  "destination/photogallery/" +
                  lang +
                  "/" +
                  first_destination_id
                ).then((photoGalleryResponse) => {
                  if (
                    photoGalleryResponse === undefined ||
                    photoGalleryResponse.statusText !== "OK"
                  ) {
                    dispatch({
                      type: FETCH_API_ERROR_DESTINATION,
                      api_error: true,
                    });
                  } else {
                    dispatch({
                      type: FETCH_SLIDER_IMAGES_DESTINATION,
                      slider_images: photoGalleryResponse.data.results,
                    });
                  }
                });
                dispatch({
                  type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                  is_fetching_establishments: true,
                });
                GetAsyncHelper(
                  environment.apiUrl +
                  "destination/getavailablefeatures/" +
                  lang +
                  "/" +
                  first_destination_id
                ).then((featureResponse) => {
                  if (
                    featureResponse === undefined ||
                    featureResponse.statusText !== "OK"
                  ) {
                    dispatch({
                      type: FETCH_API_ERROR_DESTINATION,
                      api_error: true,
                    });
                    dispatch({
                      type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                      is_fetching_establishments: false,
                    });
                  } else {
                    dispatch({
                      type: FETCH_FEATURES_DESTINATION,
                      features: featureResponse.data.features,
                    });
                    if (
                      featureResponse.data.features.length > 0 &&
                      featureResponse.data.features[0] !== undefined
                    ) {
                      dispatch({
                        type: SET_FEATURE_FORMAT,
                        featureSelected: featureResponse.data.features[0],
                      });
                      /*  get first feature's types */
                      GetAsyncHelper(
                        environment.apiUrl +
                        "destination/getfeaturetypes/" +
                        lang +
                        "/" +
                        first_destination_id +
                        "?featureID=" +
                        featureResponse.data.features[0].feature_id
                      ).then((responseTypes) => {
                        if (responseTypes.statusText === "OK") {
                          dispatch({
                            type: FETCH_FEATURE_TYPES_DESTINATION,
                            types: responseTypes.data.types,
                          });
                          if (
                            responseTypes.data.types.length > 0 &&
                            responseTypes.data.types[0] !== undefined
                          ) {
                            dispatch({
                              type: DESTINATION_SWITCH_FEATURE_TYPE_CONTAINER,
                              typeSelected: responseTypes.data.types[0],
                            });
                            /*  get first feature's type's subtype */
                            GetAsyncHelper(
                              environment.apiUrl +
                              "destination/getfeaturesubtypes/" +
                              lang +
                              "/" +
                              first_destination_id +
                              "?featureid=" +
                              featureResponse.data.features[0].feature_id +
                              "&typeID=" +
                              responseTypes.data.types[0].typeID
                            ).then((responseSubtypes) => {
                              if (responseSubtypes.statusText === "OK") {
                                dispatch({
                                  type: FETCH_FEATURE_SUBTYPES_DESTINATION,
                                  subtypes: responseSubtypes.data,
                                });
                              } else {
                                dispatch({
                                  type: FETCH_API_ERROR_DESTINATION,
                                  api_error: true,
                                });
                              }
                            });
                            dispatch({
                              type: UPDATE_SEARCH_QUERY_DESTINATION,
                              search_query: "",
                            });
                            let obj = {
                              featureID:
                                featureResponse.data.features[0].feature_id,
                              typeID: responseTypes.data.types[0].typeID,
                              limit: 20,
                              offset: 0,
                              subtype: [],
                              sortingOrder: {
                                title:
                                  featureResponse.data.features[0].sorting
                                    .title,
                                code: featureResponse.data.features[0].sorting
                                  .code,
                              },
                              sortingDirection: "",
                              searchquery: "",
                            };
                            let api_url =
                              environment.apiUrl +
                              "destination/getlistoffeatures/" +
                              lang +
                              "/" +
                              first_destination_id;
                            dispatch({
                              type: UPDATE_LAZYLOADING_URL_REQUESTS_DESTINATION,
                              api_url: api_url,
                              requests: obj,
                            });
                            PostAsyncHelper(api_url, obj).then(
                              (responseEstablishments) => {
                                if (
                                  responseEstablishments !== undefined &&
                                  responseEstablishments.statusText === "OK"
                                ) {
                                  featureResponse.data.features.length > 0 &&
                                    featureResponse.data.features[0]
                                      .feature_id ===
                                    features_router.places.featureId &&
                                    dispatch({
                                      type: FETCH_ESTABLISMENT_SETS_DESTINATION,
                                      result_sets_establishments:
                                        responseEstablishments.data.results,
                                    });
                                  featureResponse.data.features.length > 0 &&
                                    featureResponse.data.features[0]
                                      .feature_id ===
                                    features_router.trips.featureId &&
                                    dispatch({
                                      type: FETCH_TRIP_SETS_DESTINATION,
                                      result_sets_trips:
                                        responseEstablishments.data.results,
                                    });
                                  dispatch({
                                    type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                                    is_fetching_establishments: false,
                                  });
                                  if (
                                    responseEstablishments.data.results.length <
                                    5
                                  ) {
                                    dispatch({
                                      type: UPDATE_LAZYLOADING_IS_FATCH_ALL_DESTINATION,
                                      no_progress: true,
                                    });
                                  } else {
                                    dispatch({
                                      type: UPDATE_LAZYLOADING_IS_FATCH_ALL_DESTINATION,
                                      no_progress: false,
                                    });
                                  }
                                } else {
                                  dispatch({
                                    type: FETCH_API_ERROR_DESTINATION,
                                    api_error: true,
                                  });
                                }
                              }
                            );
                            dispatch({
                              type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                              is_fetching_establishments: false,
                            });
                          }
                        } else {
                          dispatch({
                            type: FETCH_API_ERROR_DESTINATION,
                            api_error: true,
                          });
                          dispatch({
                            type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                            is_fetching_establishments: false,
                          });
                        }
                      });
                    } else {
                      dispatch({
                        type: SET_FEATURE_FORMAT,
                        featureSelected: null,
                      });
                      dispatch({
                        type: FETCH_FEATURE_TYPES_DESTINATION,
                        types: [],
                      });
                      let obj = {
                        featureID: 0,
                        typeID: 0,
                        limit: LAZYLOADING_ESTABLISHMENTS_LIMIT,
                        offset: 0,
                        subtype: [],
                        sortingOrder: {
                          title: "",
                          code: "",
                        },
                        sortingDirection: "",
                        searchquery: "",
                      };
                      let api_url = "";
                      dispatch({
                        type: UPDATE_LAZYLOADING_URL_REQUESTS_DESTINATION,
                        api_url: api_url,
                        requests: obj,
                      });
                      dispatch({
                        type: FETCH_FEATURE_SUBTYPES_DESTINATION,
                        subtypes: [],
                      });
                      dispatch({
                        type: UPDATE_LAZYLOADING_IS_FATCH_ALL_DESTINATION,
                        no_progress: true,
                      });
                      dispatch({
                        type: SET_TIMELINE_WIZARD_FETCHING_ESTABLISHMENTS,
                        is_fetching_establishments: false,
                      });
                    }
                  }
                });
                dispatch({
                  type: CLEAN_SELECTED_SUBTYPES_DESTINATION,
                });

                GetAsyncHelper(
                  environment.apiUrl +
                  "destination/getinfluencers/" +
                  lang +
                  "/" +
                  first_destination_id
                ).then((influencersResponse) => {
                  if (
                    influencersResponse === undefined &&
                    influencersResponse.statusText !== "OK"
                  ) {
                    dispatch({
                      type: FETCH_API_ERROR_DESTINATION,
                      api_error: true,
                    });
                  } else {
                    dispatch({
                      type: FETCH_INFLUENCERS_DESTINATION,
                      influencers: influencersResponse.data.influencers,
                    });
                  }
                });
                const sortingOptionsRequests = {
                  featureId: 1,
                };
                PostAsyncHelper(
                  environment.apiUrl +
                  "featurelist/getFeatureSortingOptions/" +
                  lang,
                  sortingOptionsRequests
                ).then((responseSortingOptions) => {
                  if (
                    responseSortingOptions === undefined &&
                    responseSortingOptions.statusText !== "OK"
                  ) {
                    dispatch({
                      type: FETCH_API_ERROR_DESTINATION,
                      api_error: true,
                    });
                  } else {
                    dispatch({
                      type: FETCH_SORTING_OPTION_DESTINATION,
                      sorting_options: responseSortingOptions?.data?.results,
                    });
                  }
                });
                GetAsyncHelper(
                  environment.apiUrl +
                  "destination/suggestedtrips/" +
                  lang +
                  "/" +
                  first_destination_id +
                  "?limit=10"
                ).then((suggestedTripsResponse) => {
                  if (
                    suggestedTripsResponse === undefined &&
                    suggestedTripsResponse.statusText !== "OK"
                  ) {
                    dispatch({
                      type: FETCH_API_ERROR_DESTINATION,
                      api_error: true,
                    });
                  } else {
                    dispatch({
                      type: FETCH_SUGGESTEDTRIPS_DESTINATION,
                      suggested_trips:
                        suggestedTripsResponse === undefined
                          ? suggestedTripsResponse.data.results
                          : [],
                    });
                  }
                });
                dispatch({
                  type: SET_LIST_DISPLAY_FORMAT_DESTINATION,
                  container_format: list_container_mode.list,
                });
              }
            } else {
              console.log("no permission");
            }
          }
        );
      });
    }
  }
};

/* get search information */
export const fetchSearchEstablishmentTextField =
  (query, lang, destinationId) => async (dispatch) => {
    let api_url =
      environment.apiUrl +
      "muvsearch/featureSearch/" +
      query +
      "/" +
      lang +
      "?destinations[0][id]=" +
      destinationId +
      "&featureId=1";

    GetAsyncHelper(api_url).then((responseEstablishments) => {
      if (
        responseEstablishments === undefined &&
        responseEstablishments.statusText !== "OK"
      ) {
        dispatch({
          type: FETCH_SEARCH_ESTABLISHMENT_DATA,
          search_establishment_set: [],
        });
        dispatch({
          type: FETCH_SEARCH_ESTABLISHMENT_API_ERROR,
          error_api: true,
        });
        dispatch({
          type: SET_SEARCH_ESTABLISHMENT_ERROR,
          error: false,
        });
        dispatch({
          type: SET_SEARCH_ESTABLISHMENT_AUTOCOMPLETE_STATUS,
          open: false,
        });
        dispatch({
          type: SET_SEARCH_ESTABLISHMENT_TEXT_HELPER,
          text_helper: "",
        });
      } else {
        dispatch({
          type: FETCH_SEARCH_ESTABLISHMENT_DATA,
          search_establishment_set:
            responseEstablishments.data.results.searchResults,
        });

        dispatch({
          type: FETCH_SEARCH_ESTABLISHMENT_API_ERROR,
          error_api: false,
        });
        dispatch({
          type: SET_SEARCH_ESTABLISHMENT_ERROR,
          error: false,
        });
        dispatch({
          type: SET_SEARCH_ESTABLISHMENT_AUTOCOMPLETE_STATUS,
          open: true,
        });
        dispatch({
          type: SET_SEARCH_ESTABLISHMENT_TEXT_HELPER,
          text_helper: "",
        });
      }
    });
  };

export const setSearchEstablishmentSelected = (establishment) => (dispatch) => {
  dispatch({
    type: SET_SEARCH_ESTABLISHMENT_SELECTED,
    establishment_selected: establishment,
  });
  dispatch({
    type: SET_SEARCH_ESTABLISHMENT_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: FETCH_SEARCH_ESTABLISHMENT_DATA,
    search_establishment_set: [],
  });
};

export const invalidSearchEstablishmentQuery = () => (dispatch) => {
  dispatch({
    type: FETCH_SEARCH_ESTABLISHMENT_DATA,
    search_establishment_set: [],
  });
  dispatch({
    type: FETCH_SEARCH_ESTABLISHMENT_API_ERROR,
    error_api: false,
  });
  dispatch({
    type: SET_SEARCH_ESTABLISHMENT_ERROR,
    error: false,
  });
  dispatch({
    type: SET_SEARCH_ESTABLISHMENT_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: SET_SEARCH_ESTABLISHMENT_TEXT_HELPER,
    text_helper: "",
  });
};

export const fetchTimelineTripHotels = (uuid, lang, tripId) => (dispatch) => {
  const url_get =
    environment.apiUrl +
    "timeline/getTripHotelsInfo/" +
    lang +
    "/" +
    uuid +
    "?tripId=" +
    tripId;
  GetAsyncHelper(url_get).then((responseHotels) => {
    if (responseHotels !== undefined && responseHotels.statusText === "OK") {
      dispatch({
        type: FETCH_TIMELINE_MUV_HOTELS,
        hotels: responseHotels.data.result.muvHotels,
      });
    }
  });
};

/* get profile information sets*/
export const fetchProfileSelectedSets = (uuid, lang) => async (dispatch) => {
  GetAsyncHelper(
    environment.apiUrl + "muver/getmuverprofileinfo/" + uuid + "/" + lang
  ).then((responseProfile) => {
    if (responseProfile !== undefined && responseProfile.statusText === "OK") {
      const resultProfile = responseProfile.data.result;
      /* birthday */
      let date_moment = moment(resultProfile.birth_date, "YYYY/MM/DD");
      let day = date_moment.format("D");
      let month = date_moment.format("MM");
      let year = date_moment.format("YYYY");
      let birthday_date = {
        year: year,
        month: month,
        day: day,
      };
      dispatch({
        type: SET_BIRTHDAY,
        date: birthday_date,
      });
      /* gender */
      dispatch({
        type: SET_GENDER_SELECTED,
        gender_selected:
          resultProfile.gender === "" ? null : resultProfile.gender,
      });
      /* orientation */
      dispatch({
        type: SET_ORIENTATION_SELECTED,
        orientation_selected:
          resultProfile.orientation === "" ? null : resultProfile.orientation,
      });
      /* religion */
      dispatch({
        type: SET_RELIGION_SELECTED,
        religion_selected:
          resultProfile.religion === "" ? null : resultProfile.religion,
      });
      /* professions */
      dispatch({
        type: SET_PROFESSION_SELECTED,
        profession_selected: resultProfile.professions,
      });
      /* education */
      dispatch({
        type: SET_EDUCATION_SELECTED,
        education_selected:
          resultProfile.education === "" ? null : resultProfile.education,
      });
      /* cultures */
      dispatch({
        type: SET_CULTURE_SELECTED,
        culture_selected: resultProfile.cultures,
      });
      /* language fluency */
      dispatch({
        type: SET_LANGUAGE_FLUENCY,
        language_fluency:
          resultProfile.languageFluency !== undefined &&
            resultProfile.languageFluency !== null &&
            resultProfile.languageFluency !== ""
            ? resultProfile.languageFluency
            : [],
      });
      /* hometown */
      dispatch({
        type: SET_HOMETOWN_SELECTED,
        hometown_selected:
          resultProfile.memberHomeTownInfoFromGooglePlaces !== null
            ? {
              description:
                resultProfile.memberHomeTownInfoFromGooglePlaces.city +
                " " +
                resultProfile.memberHomeTownInfoFromGooglePlaces.country,
            }
            : null,
      });
      /*  air port */
      dispatch({
        type: SET_HOMETOWN_AIRPORT_SELECTED,
        airport_selected:
          resultProfile.memberHomeTownAirportInfoFromGooglePlaces !== null
            ? resultProfile.memberHomeTownAirportInfoFromGooglePlaces
            : null,
      });
      /* social account */
      dispatch({
        type: SET_FACEBOOK,
        facebook: resultProfile.facebook === null ? "" : resultProfile.facebook,
      });
      dispatch({
        type: SET_INSTAGRAM,
        instagram:
          resultProfile.instagram === null ? "" : resultProfile.instagram,
      });
      dispatch({
        type: SET_TWITTER,
        twitter: resultProfile.twitter === null ? "" : resultProfile.twitter,
      });
      dispatch({
        type: SET_PINTEREST,
        pinterest:
          resultProfile.pinterest === null ? "" : resultProfile.pinterest,
      });
      dispatch({
        type: SET_SNAPCHAT,
        snapchat: resultProfile.snapchat === null ? "" : resultProfile.snapchat,
      });
    }
  });
};

export const setTripDescription =
  (lang, uuid, tripId, tripDescription) => async (dispatch) => {
    if (uuid !== "") {
      let obj = {
        lang: lang,
        uuid: uuid,
        tripId: tripId,
        tripDescription: tripDescription,
      };
      let api_url =
        environment.apiUrl +
        "memberarea/trip/updateTripDescription/" +
        lang +
        "/" +
        uuid;
      PostAsyncHelper(api_url, obj).then((responseTripDescription) => {
        if (
          responseTripDescription !== undefined &&
          responseTripDescription.statusText === "OK"
        ) {
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
            trip_description: tripDescription,
          });
        }
      });
    }
  };
export const setTripAuthStatus =
  (lang, uuid, tripId, tripStatus) => async (dispatch) => {
    if (uuid !== "") {
      let obj = {
        lang: lang,
        uuid: uuid,
        tripId: tripId,
        isPublic: tripStatus,
      };
      let api_url =
        environment.apiUrl +
        "memberarea/trip/updateTripPrivateMod/" +
        lang +
        "/" +
        uuid;
      PostAsyncHelper(api_url, obj).then((responseStatus) => {
        if (
          responseStatus !== undefined &&
          responseStatus.statusText === "OK"
        ) {
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
            trip_auth_status: responseStatus.data.result.isPublic,
          });
          dispatch({
            type: ALERT_BARS_HANDLE,
            message_type: "success",
            message: "saved",
          });
        }
      });
    }
  };

/* get leaving from airport information */
export const fetchLeavingFromAirportTextField = (query) => async (dispatch) => {
  try {
    const response = await Axios.get(
      environment.apiUrl + "muvsearch/airportsearch/" + query + "?limit=7"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: FETCH_LEAVING_FROM_AIRPORT_DATA,
      airport_resource: response.data,
    });

    dispatch({
      type: FETCH_LEAVING_FROM_AIRPORT_API_ERROR,
      error_api: false,
    });
    if (response.data !== undefined && response.data.length === 0) {
      dispatch({
        type: SET_LEAVING_FROM_AIRPORT_ERROR,
        error: false,
      });
      dispatch({
        type: SET_LEAVING_FROM_AIRPORT_TEXT_HELPER,
        text_helper: "",
      });
      dispatch({
        type: SET_LEAVING_FROM_AIRPORT_AUTOCOMPLETE_STATUS,
        open: false,
      });
    } else {
      dispatch({
        type: SET_LEAVING_FROM_AIRPORT_ERROR,
        error: false,
      });
      dispatch({
        type: SET_LEAVING_FROM_AIRPORT_TEXT_HELPER,
        text_helper: "",
      });
      dispatch({
        type: SET_LEAVING_FROM_AIRPORT_AUTOCOMPLETE_STATUS,
        open: true,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_LEAVING_FROM_AIRPORT_DATA,
      airport_resource: [],
    });
    dispatch({
      type: FETCH_LEAVING_FROM_AIRPORT_API_ERROR,
      error_api: true,
    });
    dispatch({
      type: SET_LEAVING_FROM_AIRPORT_ERROR,
      error: false,
    });
    dispatch({
      type: SET_LEAVING_FROM_AIRPORT_AUTOCOMPLETE_STATUS,
      open: false,
    });
    dispatch({
      type: SET_LEAVING_FROM_AIRPORT_TEXT_HELPER,
      text_helper: "",
    });
  }
};

export const setLeavingFromAirportSelected =
  (airport, uuid = "", lang = "") =>
    (dispatch) => {
      dispatch({
        type: SET_LEAVING_FROM_AIRPORT_SELECTED,
        airport_selected: airport,
      });

      dispatch({
        type: SET_LEAVING_FROM_AIRPORT_AUTOCOMPLETE_STATUS,
        open: false,
      });
      dispatch({
        type: FETCH_LEAVING_FROM_AIRPORT_DATA,
        airport_resource: [],
      });
      /* post closest airport */
      if (uuid !== "") {
        // console.log(airport)
        // if (airport !== null && airport !== undefined && airport !== "") {
        //     let obj = {
        //         airport: airport
        //     }
        //     let api_url = 'https://devapi.muvtravel.com/api/public/account/addHomeAirport/' + uuid + '/' + lang
        //     PostAsyncHelper(api_url, obj)
        // } else {
        //     let obj = {
        //         removeOnly: 1,
        //     }
        //     let api_url = 'https://devapi.muvtravel.com/api/public/account/addHomeAirport/' + uuid + '/' + lang
        //     PostAsyncHelper(api_url, obj)
        // }
        console.log(airport);
      }
    };

export const invalidLeavingFromAirportQuery = () => (dispatch) => {
  dispatch({
    type: FETCH_LEAVING_FROM_AIRPORT_DATA,
    airport_resource: [],
  });
  dispatch({
    type: FETCH_LEAVING_FROM_AIRPORT_API_ERROR,
    error_api: false,
  });
  dispatch({
    type: SET_LEAVING_FROM_AIRPORT_ERROR,
    error: false,
  });
  dispatch({
    type: SET_LEAVING_FROM_AIRPORT_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: SET_LEAVING_FROM_AIRPORT_TEXT_HELPER,
    text_helper: "",
  });
};

/* get hometown airport information */
export const fetchReturningToAirportTextField = (query) => async (dispatch) => {
  try {
    const response = await Axios.get(
      environment.apiUrl + "muvsearch/airportsearch/" + query + "?limit=7"
    );
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    console.log(response.data);
    dispatch({
      type: FETCH_RETURNING_TO_AIRPORT_DATA,
      airport_resource: response.data,
    });

    dispatch({
      type: FETCH_RETURNING_TO_AIRPORT_API_ERROR,
      error_api: false,
    });
    if (response.data !== undefined && response.data.length === 0) {
      dispatch({
        type: SET_RETURNING_TO_AIRPORT_ERROR,
        error: false,
      });
      dispatch({
        type: SET_RETURNING_TO_AIRPORT_TEXT_HELPER,
        text_helper: "",
      });
      dispatch({
        type: SET_RETURNING_TO_AIRPORT_AUTOCOMPLETE_STATUS,
        open: false,
      });
    } else {
      dispatch({
        type: SET_RETURNING_TO_AIRPORT_ERROR,
        error: false,
      });
      dispatch({
        type: SET_RETURNING_TO_AIRPORT_TEXT_HELPER,
        text_helper: "",
      });
      dispatch({
        type: SET_RETURNING_TO_AIRPORT_AUTOCOMPLETE_STATUS,
        open: true,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_RETURNING_TO_AIRPORT_DATA,
      airport_resource: [],
    });
    dispatch({
      type: FETCH_RETURNING_TO_AIRPORT_API_ERROR,
      error_api: true,
    });
    dispatch({
      type: SET_RETURNING_TO_AIRPORT_ERROR,
      error: false,
    });
    dispatch({
      type: SET_RETURNING_TO_AIRPORT_AUTOCOMPLETE_STATUS,
      open: false,
    });
    dispatch({
      type: SET_RETURNING_TO_AIRPORT_TEXT_HELPER,
      text_helper: "",
    });
  }
};

export const setReturningToAirportSelected =
  (airport, uuid = "", lang = "") =>
    (dispatch) => {
      dispatch({
        type: SET_RETURNING_TO_AIRPORT_SELECTED,
        airport_selected: airport,
      });

      dispatch({
        type: SET_RETURNING_TO_AIRPORT_AUTOCOMPLETE_STATUS,
        open: false,
      });
      dispatch({
        type: FETCH_RETURNING_TO_AIRPORT_DATA,
        airport_resource: [],
      });
      /* post closest airport */
      if (uuid !== "") {
        // console.log(airport)
        // if (airport !== null && airport !== undefined && airport !== "") {
        //     let obj = {
        //         airport: airport
        //     }
        //     let api_url = 'https://devapi.muvtravel.com/api/public/account/addHomeAirport/' + uuid + '/' + lang
        //     PostAsyncHelper(api_url, obj)
        // } else {
        //     let obj = {
        //         removeOnly: 1,
        //     }
        //     let api_url = 'https://devapi.muvtravel.com/api/public/account/addHomeAirport/' + uuid + '/' + lang
        //     PostAsyncHelper(api_url, obj)
        // }
        console.log(airport);
      }
    };

export const invalidReturningToAirportQuery = () => (dispatch) => {
  dispatch({
    type: FETCH_RETURNING_TO_AIRPORT_DATA,
    airport_resource: [],
  });
  dispatch({
    type: FETCH_RETURNING_TO_AIRPORT_API_ERROR,
    error_api: false,
  });
  dispatch({
    type: SET_RETURNING_TO_AIRPORT_ERROR,
    error: false,
  });
  dispatch({
    type: SET_RETURNING_TO_AIRPORT_AUTOCOMPLETE_STATUS,
    open: false,
  });
  dispatch({
    type: SET_RETURNING_TO_AIRPORT_TEXT_HELPER,
    text_helper: "",
  });
};

export const fetchTripTypesSets = () => async (dispatch) => {
  GetAsyncHelper(
    environment.apiUrl + "featurelist/getfeaturetypes/en?featureID=3"
  ).then((responseTripTypes) => {
    if (
      responseTripTypes !== undefined &&
      responseTripTypes.statusText === "OK"
    ) {
      dispatch({
        type: FETCH_TRIP_TYPES_SETS,
        sets: responseTripTypes.data.types,
      });
    }
  });
};

export const setTripType = (type) => async (dispatch) => {
  console.log(type);
  dispatch({
    type: SET_TRIP_TYPE_SELECTED,
    type_id: type.typeID,
  });
  // if (uuid !== undefined && uuid !== "") {
  //     let api_url = 'https://devapi.muvtravel.com/api/public/account/updateMemberInfoFields/' + uuid + '/' + lang
  //     const obj = {
  //         uuid: uuid,
  //         lang: lang,
  //         updateFieldName: "firstName",
  //         updateFieldValue: first_name,
  //     }
  //     PostAsyncHelper(api_url, obj)
  // }
};

export const fetchTripCompanionSets =
  (tripId, uuid, lang) => async (dispatch) => {
    try {
      const url = environment.apiUrl + "getTripCompanions/" + lang + "/" + uuid + "?tripId=" + tripId
      const response = await GetAsyncHelper(url)
      if (response && response.statusText === "OK") {
        const data = response.data
        const sets = data?.companions || data?.result || data || []
        dispatch({
          type: FETCH_TRIP_COMPANION_SETS,
          sets: sets,
        })
      } else {
        dispatch({
          type: FETCH_TRIP_COMPANION_SETS,
          sets: [],
        })
      }
    } catch (e) {
      dispatch({
        type: FETCH_TRIP_COMPANION_SETS,
        sets: [],
      })
    }
  };

export const setTripCompanion = (companion) => async (dispatch) => {
  console.log(companion);
  // dispatch({
  //     type: SET_TRIP_TYPE_SELECTED,
  //     type_id: type.typeID
  // })
  // if (uuid !== undefined && uuid !== "") {
  //     let api_url = 'https://devapi.muvtravel.com/api/public/account/updateMemberInfoFields/' + uuid + '/' + lang
  //     const obj = {
  //         uuid: uuid,
  //         lang: lang,
  //         updateFieldName: "firstName",
  //         updateFieldValue: first_name,
  //     }
  //     PostAsyncHelper(api_url, obj)
  // }
};

export const checkEmailExsitCompanion = (email) => async (dispatch) => {
  try {
    const response = await Axios({
      method: "post",
      url: environment.apiUrl + "memberemailisavailable",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify({
        email: email,
      }),
    });
    if (response.statusText !== "OK") {
      throw Error(response.statusText);
    }
    dispatch({
      type: CEHCK_EMAIL_EXIST_SUCCESS_COMPANION,
      check_email_exsit: response.data.status,
      axios_error: "axios success",
    });
    if (response.data.status === "success") {
      dispatch({
        type: SET_EMAIL_ADDRESS_COMPANION,
        email_address: email,
      });
      dispatch({
        type: SET_EMAIL_ADDRESS_ERROR_COMPANION,
        error: false,
      });
      dispatch({
        type: SET_EMAIL_ADDRESS_TEXT_HELPER_COMPANION,
        text_helper: "",
      });
    } else if (response.data.status === "fail") {
      dispatch({
        type: SET_EMAIL_ADDRESS_COMPANION,
        email_address: email,
      });
      dispatch({
        type: SET_EMAIL_ADDRESS_ERROR_COMPANION,
        error: false,
      });
      dispatch({
        type: SET_EMAIL_ADDRESS_TEXT_HELPER_COMPANION,
        text_helper: "It's muver account.",
      });
    }
  } catch (error) {
    dispatch({
      type: CEHCK_EMAIL_EXIST_FAILURE_COMPANION,
      check_email_exsit: "",
      axios_error: error.message,
    });
  }
};

export const cleanEmailAddressCompanion = () => (dispatch) => {
  dispatch({
    type: SET_EMAIL_ADDRESS_COMPANION,
    email_address: "",
  });
  dispatch({
    type: SET_EMAIL_ADDRESS_ERROR_COMPANION,
    error: false,
  });
  dispatch({
    type: SET_EMAIL_ADDRESS_TEXT_HELPER_COMPANION,
    text_helper: "",
  });
};

export const invalidEmailAddressCompanion = () => (dispatch) => {
  dispatch({
    type: SET_EMAIL_ADDRESS_COMPANION,
    email_address: "",
  });
  dispatch({
    type: SET_EMAIL_ADDRESS_ERROR_COMPANION,
    error: true,
  });
  dispatch({
    type: SET_EMAIL_ADDRESS_TEXT_HELPER_COMPANION,
    text_helper: "Email is invalid.",
  });
};

/* first name */

export const setFirstNameCompanion = (first_name, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_FIRST_NAME_COMPANION,
    first_name: first_name,
  });

  dispatch({
    type: SET_FIRST_NAME_ERROR_COMPANION,
    error: false,
  });
  dispatch({
    type: SET_FIRST_NAME_TEXT_HELPER_COMPANION,
    text_helper: "",
  });
};

export const cleanFirstNameCompanion = () => (dispatch) => {
  dispatch({
    type: SET_FIRST_NAME_COMPANION,
    first_name: "",
  });

  dispatch({
    type: SET_FIRST_NAME_ERROR_COMPANION,
    error: false,
  });
  dispatch({
    type: SET_FIRST_NAME_TEXT_HELPER_COMPANION,
    text_helper: "",
  });
};

export const invalidFirstNameCompanion = () => (dispatch) => {
  dispatch({
    type: SET_FIRST_NAME_COMPANION,
    first_name: "",
  });
  dispatch({
    type: SET_FIRST_NAME_ERROR_COMPANION,
    error: true,
  });
  dispatch({
    type: SET_FIRST_NAME_TEXT_HELPER_COMPANION,
    text_helper: "Use 1 or more letters",
  });
};

/* last name companioin */

export const setLastNameCompanion = (last_name, uuid, lang) => (dispatch) => {
  dispatch({
    type: SET_LAST_NAME_COMPANION,
    last_name: last_name,
  });
  dispatch({
    type: SET_LAST_NAME_ERROR_COMPANION,
    error: false,
  });
  dispatch({
    type: SET_LAST_NAME_TEXT_HELPER_COMPANION,
    text_helper: "",
  });
};
export const cleanLastNameCompanion = () => (dispatch) => {
  dispatch({
    type: SET_LAST_NAME_COMPANION,
    last_name: "",
  });
  dispatch({
    type: SET_LAST_NAME_ERROR_COMPANION,
    error: false,
  });
  dispatch({
    type: SET_LAST_NAME_TEXT_HELPER_COMPANION,
    text_helper: "",
  });
};

export const invalidLastNameCompanion = () => (dispatch) => {
  dispatch({
    type: SET_LAST_NAME_COMPANION,
    last_name: "",
  });
  dispatch({
    type: SET_LAST_NAME_ERROR_COMPANION,
    error: true,
  });
  dispatch({
    type: SET_LAST_NAME_TEXT_HELPER_COMPANION,
    text_helper: "Use 1 or more letters",
  });
};

export const clearAllTimeline = () => (dispatch) => {
  dispatch({
    type: CLEAR_ALL_TIMELINE,
  });
};

export const clearTimelineTrip = () => (dispatch) => {
  /* remove  cookies */
  Cookies.remove("muv_active_trip");
  dispatch({
    type: CLEAR_TIMELINE_TRIP,
  });
};

export const fetchActiveTripBooking = (tripId, lang) => (dispatch) => {
  const muv_token = Cookies.get("muv_token");
  const muv_active_trip = tripId;
  dispatch({
    type: SET_LOADER,
    payload: false,
  });
  if (muv_active_trip !== undefined && muv_active_trip !== "") {
    if (muv_token === undefined) {
      // console.log("no login")
      const url_get =
        environment.apiUrl +
        "timeline/getTripInfo/en/TMPUUID?tripId=" +
        muv_active_trip +
        "&getTripInfo";
      GetAsyncHelper(url_get).then((responseTrip) => {
        if (responseTrip.statusText === "OK") {
          const trip = responseTrip.data.result;
          dispatch(updateActiveTrip(trip));
          Cookies.set("muv_active_trip", muv_active_trip, {
            expires: 365,
          });

          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_ID,
            trip_id: trip.tripID,
          });

          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_NAME,
            trip_name: trip.tripName,
          });

          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_START_DATE,
            trip_start_date:
              trip.noDate === "0" ? trip.tripStartDate : "0000-00-00",
          });

          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
            trip_no_date: trip.noDate,
          });

          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
            trip_duration: trip.tripDaysCount,
          });
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
            trip_description: trip.tripDescription,
          });
          dispatch({
            type: SET_TRIP_TYPE_SELECTED,
            type_id: trip.typeId,
          });
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
            trip_auth_status: trip.isPublic,
          });
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_IMAGE,
            trip_image: trip.headerImage,
          });
          dispatch({
            type: SET_LEAVING_FROM_AIRPORT_SELECTED,
            airport_selected: trip.leavingFromAirport,
          });
          dispatch({
            type: SET_RETURNING_TO_AIRPORT_SELECTED,
            airport_selected: trip.returningToAirport,
          });
          // dispatch({
          //     type: SET_TIMELINE_WIZARD_STATUS,
          //     status: true
          // })
        } else {
          console.log("no permission");
        }
      });
      const url_active_trip_get_cost =
        environment.apiUrl +
        "timeline/getTripCost/en/TMPUUID?tripId=" +
        muv_active_trip +
        "&getTripCost";
      dispatch({
        type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
        status: true,
      });
      GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
        if (responseTripCost.statusText === "OK") {
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_COST,
            trip_cost: responseTripCost.data.result,
          });
          dispatch({
            type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
            status: false,
          });
        } else {
          console.log("no permission");
        }
      });

      const fetch_active_trip_activities_api_url =
        environment.apiUrl +
        "timeline/getTripActivities/en/TMPUUID?tripId=" +
        muv_active_trip +
        "&getTripActivities";

      GetAsyncHelper(fetch_active_trip_activities_api_url).then(
        (responseTripActivities) => {
          if (responseTripActivities.statusText === "OK") {
            dispatch({
              type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
              activities: responseTripActivities.data.result,
            });
          } else {
            console.log("no permission");
          }
        }
      );
      const url_active_trip_get_destinations =
        environment.apiUrl +
        "timeline/getTripDestinations/" +
        lang +
        "/TMPUUID?tripId=" +
        muv_active_trip +
        "&getTripDestinations";
      GetAsyncHelper(url_active_trip_get_destinations).then(
        (responseTripDestinations) => {
          if (responseTripDestinations.statusText === "OK") {
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
              trip_destinations: responseTripDestinations.data,
            });
            const destinations = responseTripDestinations.data;
            const idsDestinations = Array.from(
              new Set(destinations.map((d) => d.id))
            );
            const tdidsDestinations = Array.from(
              new Set(destinations.map((d) => d.td_id))
            );
            // the first destination is activie destination
            if (
              idsDestinations !== undefined &&
              idsDestinations.length > 0 &&
              idsDestinations[0] !== undefined
            ) {
              const first_destination_id = idsDestinations[0];
              dispatch({
                type: SET_ACTIVE_TRIP_DESTINATION,
                trip_destination_id: tdidsDestinations[0],
                destination_id: first_destination_id,
              });
              dispatch({
                type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
                trip_destination_id: tdidsDestinations[0],
              });
              const destinationDays =
                destinations[0].spanningDays !== undefined &&
                destinations[0].spanningDays.split(",");
              const destinationLastDayInTrip =
                destinationDays[destinationDays.length - 1];
              const destinationLastDayInTripDestination = String(
                destinationDays.length
              );
              dispatch({
                type: SET_ACTIVE_DAY_IN_TRIP,
                trip_destination_id: tdidsDestinations[0],
                day_in_trip: destinationLastDayInTrip,
                day_in_trip_destination: destinationLastDayInTripDestination,
              });
              dispatch({
                type: SET_DESTINATION_ID_DESTINATION,
                active_id: first_destination_id,
              });
            }
          } else {
            console.log("no permission");
          }
        }
      );
    } else {
      // console.log("logined")

      const api_url_token =
        environment.apiUrl + "membertoken?token=" + muv_token;
      PostAsyncHelper(api_url_token).then((responseToken) => {
        const member = responseToken?.data?.message;
        const uuid = member.memberRestUUID;
        const url_active_trip_get =
          environment.apiUrl +
          "timeline/getTripInfo/en/" +
          uuid +
          "?tripId=" +
          muv_active_trip +
          "&getTripInfo";
        GetAsyncHelper(url_active_trip_get).then((responseTrip) => {
          if (responseTrip.statusText === "OK") {
            const trip = responseTrip.data.result;
            dispatch(updateActiveTrip(trip));

            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_ID,
              trip_id: trip.tripID,
            });

            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_NAME,
              trip_name: trip.tripName,
            });

            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_START_DATE,
              trip_start_date:
                trip.noDate === "0" ? trip.tripStartDate : "0000-00-00",
            });

            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
              trip_no_date: trip.noDate,
            });

            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
              trip_duration: trip.tripDaysCount,
            });
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
              trip_description: trip.tripDescription,
            });
            dispatch({
              type: SET_TRIP_TYPE_SELECTED,
              type_id: trip.typeId,
            });
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
              trip_auth_status: trip.isPublic,
            });
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_IMAGE,
              trip_image: trip.headerImage,
            });
            dispatch({
              type: SET_LEAVING_FROM_AIRPORT_SELECTED,
              airport_selected: trip.leavingFromAirport,
            });
            dispatch({
              type: SET_RETURNING_TO_AIRPORT_SELECTED,
              airport_selected: trip.returningToAirport,
            });
            // dispatch({
            //     type: SET_TIMELINE_WIZARD_STATUS,
            //     status: true
            // })
          } else {
            console.log("no permission");
          }
        });
        const url_active_trip_get_cost =
          environment.apiUrl +
          "timeline/getTripCost/en/" +
          uuid +
          "?tripId=" +
          muv_active_trip +
          "&getTripCost";
        dispatch({
          type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
          status: true,
        });
        GetAsyncHelper(url_active_trip_get_cost).then((responseTripCost) => {
          if (responseTripCost.statusText === "OK") {
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_COST,
              trip_cost: responseTripCost.data.result,
            });
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
              status: false,
            });
          } else {
            console.log("no permission");
          }
        });
        const fetch_active_trip_activities_api_url =
          environment.apiUrl +
          "timeline/getTripActivities/en/" +
          uuid +
          "?tripId=" +
          muv_active_trip +
          "&getTripActivities";
        GetAsyncHelper(fetch_active_trip_activities_api_url).then(
          (responseTripActivities) => {
            if (responseTripActivities.statusText === "OK") {
              dispatch({
                type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                activities: responseTripActivities.data.result,
              });
            } else {
              console.log("no permission");
            }
          }
        );

        const url_active_trip_get_destinations =
          environment.apiUrl +
          "timeline/getTripDestinations/" +
          lang +
          "/" +
          uuid +
          "?tripId=" +
          muv_active_trip +
          "&getTripDestinations";
        GetAsyncHelper(url_active_trip_get_destinations).then(
          (responseTripDestinations) => {
            if (responseTripDestinations.statusText === "OK") {
              dispatch({
                type: SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
                trip_destinations: responseTripDestinations.data,
              });
              const destinations = responseTripDestinations.data;
              const idsDestinations = Array.from(
                new Set(destinations.map((d) => d.id))
              );
              const tdidsDestinations = Array.from(
                new Set(destinations.map((d) => d.td_id))
              );

              if (
                idsDestinations !== undefined &&
                idsDestinations.length > 0 &&
                idsDestinations[0] !== undefined
              ) {
                const first_destination_id = idsDestinations[0];
                dispatch({
                  type: SET_ACTIVE_TRIP_DESTINATION,
                  trip_destination_id: tdidsDestinations[0],
                  destination_id: first_destination_id,
                });
                dispatch({
                  type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
                  trip_destination_id: tdidsDestinations[0],
                });
                const destinationDays =
                  destinations[0].spanningDays !== undefined &&
                  destinations[0].spanningDays.split(",");
                const destinationLastDayInTrip =
                  destinationDays[destinationDays.length - 1];
                const destinationLastDayInTripDestination = String(
                  destinationDays.length
                );
                dispatch({
                  type: SET_ACTIVE_DAY_IN_TRIP,
                  trip_destination_id: tdidsDestinations[0],
                  day_in_trip: destinationLastDayInTrip,
                  day_in_trip_destination: destinationLastDayInTripDestination,
                });
                dispatch({
                  type: SET_DESTINATION_ID_DESTINATION,
                  active_id: first_destination_id,
                });
              }
            } else {
              console.log("no permission");
            }
          }
        );
      });
    }
  }
};

export const copyTripDestinationsToTrip =
  (lang, uuid, tripId, tripIdFrom) => async (dispatch) => {
    if (uuid !== "") {
      let obj = {
        lang: lang,
        uuid: uuid,
        tripId: tripId,
        tripIdFrom: tripIdFrom,
      };
      let api_url =
        environment.apiUrl +
        "timeline/copyTripIntoAnotherTrip/" +
        lang +
        "/" +
        uuid;

      PostAsyncHelper(api_url, obj).then((response) => {
        if (response.statusText === "OK") {
          const status = response.data.status;
          if (status === "success") {
            //console.log(`copyTripDestinationsToTrip  Post result status == success`)
            const url_active_trip_get =
              environment.apiUrl +
              "timeline/getTripInfo/en/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripInfo";
            GetAsyncHelper(url_active_trip_get).then((responseTrip) => {
              if (responseTrip.statusText === "OK") {
                //console.log(`copyTripDestinationsToTrip  getTripInfo :`)
                const trip = responseTrip.data.result;
                dispatch(updateActiveTrip(trip));
                //console.log(trip)
                /*dispatch({
                                type: SET_TIMELINE_ACTIVE_TRIP_ID,
                                trip_id: trip.tripID
                            })*/

                /*dispatch({
                                type: SET_TIMELINE_ACTIVE_TRIP_NAME,
                                trip_name: trip.tripName
                            })*/

                /*dispatch({
                                type: SET_TIMELINE_ACTIVE_TRIP_START_DATE,
                                trip_start_date: trip.noDate === "0" ? trip.tripStartDate : "0000-00-00"
                            })*/

                /*dispatch({
                                type: SET_TIMELINE_ACTIVE_TRIP_NO_DATE,
                                trip_no_date: trip.noDate
                            })*/

                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_DURATION,
                  trip_duration: trip.tripDaysCount,
                });
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_DESCRIPTION,
                  trip_description: trip.tripDescription,
                });
                dispatch({
                  type: SET_TRIP_TYPE_SELECTED,
                  type_id: trip.typeId,
                });
                /*dispatch({
                                type: SET_TIMELINE_ACTIVE_TRIP_AUTH_STATUS,
                                trip_auth_status: trip.isPublic
                            })*/
                dispatch({
                  type: SET_TIMELINE_ACTIVE_TRIP_IMAGE,
                  trip_image: trip.headerImage,
                });
                dispatch({
                  type: SET_LEAVING_FROM_AIRPORT_SELECTED,
                  airport_selected: trip.leavingFromAirport,
                });
                dispatch({
                  type: SET_RETURNING_TO_AIRPORT_SELECTED,
                  airport_selected: trip.returningToAirport,
                });
                // dispatch({
                //     type: SET_TIMELINE_WIZARD_STATUS,
                //     status: true
                // })
              } else {
                console.log("no permission");
              }
            });
            const url_active_trip_get_cost =
              environment.apiUrl +
              "timeline/getTripCost/en/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripCost";
            dispatch({
              type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
              status: true,
            });
            GetAsyncHelper(url_active_trip_get_cost).then(
              (responseTripCost) => {
                if (responseTripCost.statusText === "OK") {
                  //console.log(`copyTripDestinationsToTrip  getTripCost`)
                  //console.log(responseTripCost.data)
                  dispatch({
                    type: SET_TIMELINE_ACTIVE_TRIP_COST,
                    trip_cost: responseTripCost.data.result,
                  });
                  dispatch({
                    type: SET_TIMELINE_ACTIVE_TRIP_COST_FETCH_STATUS,
                    status: false,
                  });
                } else {
                  console.log("no permission");
                }
              }
            );
            const fetch_active_trip_activities_api_url =
              environment.apiUrl +
              "timeline/getTripActivities/en/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripActivities";
            GetAsyncHelper(fetch_active_trip_activities_api_url).then(
              (responseTripActivities) => {
                if (responseTripActivities.statusText === "OK") {
                  //console.log(`copyTripDestinationsToTrip  getTripActivities`)
                  //console.log(responseTripActivities.data.result)
                  dispatch({
                    type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                    activities: responseTripActivities.data.result,
                  });
                } else {
                  console.log("no permission");
                }
              }
            );

            const url_active_trip_get_destinations =
              environment.apiUrl +
              "timeline/getTripDestinations/" +
              lang +
              "/" +
              uuid +
              "?tripId=" +
              tripId +
              "&getTripDestinations";
            GetAsyncHelper(url_active_trip_get_destinations).then(
              (responseTripDestinations) => {
                if (responseTripDestinations.statusText === "OK") {
                  //console.log(`copyTripDestinationsToTrip  getTripDestination`)
                  //console.log(responseTripDestinations.data)
                  dispatch({
                    type: SET_TIMELINE_ACTIVE_TRIP_DESTINATIONS,
                    trip_destinations: responseTripDestinations.data,
                  });
                  const destinations = responseTripDestinations.data;
                  const idsDestinations = Array.from(
                    new Set(destinations.map((d) => d.id))
                  );
                  const tdidsDestinations = Array.from(
                    new Set(destinations.map((d) => d.td_id))
                  );

                  if (
                    idsDestinations !== undefined &&
                    idsDestinations.length > 0 &&
                    idsDestinations[0] !== undefined
                  ) {
                    const first_destination_id = idsDestinations[0];
                    dispatch({
                      type: SET_ACTIVE_TRIP_DESTINATION,
                      trip_destination_id: tdidsDestinations[0],
                      destination_id: first_destination_id,
                    });
                    dispatch({
                      type: SET_TIMELINE_TRIP_DESTINATION_OPEN_STATUS_CLOSE_OTHERS,
                      trip_destination_id: tdidsDestinations[0],
                    });
                    const destinationDays =
                      destinations[0].spanningDays !== undefined &&
                      destinations[0].spanningDays.split(",");
                    const destinationLastDayInTrip =
                      destinationDays[destinationDays.length - 1];
                    const destinationLastDayInTripDestination = String(
                      destinationDays.length
                    );
                    dispatch({
                      type: SET_ACTIVE_DAY_IN_TRIP,
                      trip_destination_id: tdidsDestinations[0],
                      day_in_trip: destinationLastDayInTrip,
                      day_in_trip_destination:
                        destinationLastDayInTripDestination,
                    });
                    dispatch({
                      type: SET_DESTINATION_ID_DESTINATION,
                      active_id: first_destination_id,
                    });
                  }
                } else {
                  console.log("no permission");
                }
              }
            );
          }
        }
      });
    }
  };

export const optimizeTimeline =
  (lang, uuid, tripId, showLoader) => async (dispatch) => {
    if (showLoader) {
      showLoader(true);
    }

    const optimize_url =
      environment.apiUrl +
      "timeline/optimizeTrip/" +
      lang +
      "/" +
      uuid +
      "?tripId=" +
      tripId;
    PostAsyncHelper(optimize_url).then((response) => {
      if (response && response.statusText && response.statusText === "OK") {
        const fetch_active_trip_activities_api_url =
          environment.apiUrl +
          "timeline/getTripActivities/" +
          lang +
          "/" +
          uuid +
          "?tripId=" +
          tripId +
          "&getTripActivities";
        GetAsyncHelper(fetch_active_trip_activities_api_url).then(
          (responseTripActivities) => {
            if (
              responseTripActivities &&
              responseTripActivities.statusText &&
              responseTripActivities.statusText === "OK"
            ) {
              dispatch({
                type: FETCH_ACTIVE_ACTIVITIES_IN_TRIP,
                activities: responseTripActivities.data.result,
              });
              if (showLoader) {
                showLoader(false);
              }
            } else {
              console.log("no permission");
              if (showLoader) {
                showLoader(false);
              }
            }
          }
        );
      } else {
        if (showLoader) {
          showLoader(false);
        }
        console.log("no permission");
      }
    });
  };
